/* tslint:disable */
/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType } from 'graphql';
/**
 * This file is auto-generated by graphql-schema-typescript
 * Please note that any changes in this file may be overwritten
 */
 

/*******************************
 *                             *
 *          TYPE DEFS          *
 *                             *
 *******************************/
export interface GQLQuery {
  
  /**
   * comment returns a specific comment.
   */
  comment?: GQLComment;
  
  /**
   * comments returns a filtered comments connection that can be paginated. This is
   * a fairly expensive edge to filter against, moderation queues should utlilize
   * the dedicated edges for more optimized responses.
   */
  comments: GQLCommentsConnection;
  
  /**
   * story is a specific article that can be identified by either an ID or a URL.
   */
  story?: GQLStory;
  
  /**
   * stream will load a specific story that can be identified by either an ID or a
   * URL and will create the story if that feature is enabled.
   */
  stream?: GQLStory;
  
  /**
   * stories returns filtered stories that can be paginated.
   */
  stories: GQLStoriesConnection;
  
  /**
   * user will return the user referenced by their ID.
   * 
   * TODO: evaluate adding a profile based lookup.
   */
  user?: GQLUser;
  
  /**
   * users returns filtered users that can be paginated.
   * 
   * TODO: evaluate adding status based filtering.
   */
  users: GQLUsersConnection;
  site?: GQLSite;
  sites: GQLSitesConnection;
  
  /**
   * viewer is the current logged in User. If no user is currently logged in, it will
   * return null. This is the only nullable field that can be returned that depends
   * on the authentication state that will not throw an error.
   */
  viewer?: GQLUser;
  
  /**
   * settings is the Settings for a given Tenant.
   */
  settings: GQLSettings;
  
  /**
   * discoverOIDCConfiguration will discover the OpenID Connect configuration based
   * on the provided issuer. Discovery is not supported on all providers, and is
   * described in the OpenID Connect Discovery 1.0 incorporating errata set 1:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfig
   * 
   * If the provider does not support discovery, the response will be null.
   */
  discoverOIDCConfiguration?: GQLDiscoveredOIDCConfiguration;
  
  /**
   * debugScrapeStoryMetadata will return the information that Coral was able to
   * scrape from the given URL. No data will be saved related to the Story based
   * on this scrape.
   */
  debugScrapeStoryMetadata?: GQLStoryMetadata;
  
  /**
   * moderationQueues returns the set of ModerationQueues that are available for
   * all stories or if given the story identified by the `storyID`.
   */
  moderationQueues: GQLModerationQueues;
  
  /**
   * sections will return the unique sections used by this Tenant.
   */
  sections?: Array<string>;
  
  /**
   * activeStories is the list of most recently commented on stories identified
   * by their `lastCommentedAt` field
   */
  activeStories: Array<GQLStory>;
  
  /**
   * webhookEndpint will return a specific WebhookEndpoint if it exists.
   */
  webhookEndpoint?: GQLWebhookEndpoint;
  
  /**
   * queues returns information on queues used in Coral to manage
   */
  queues: GQLQueues;
  
  /**
   * externalModerationPhase will return a specific ExternalModerationPhase if it
   * exists.
   */
  externalModerationPhase?: GQLExternalModerationPhase;
  
  /**
   * flags are the list of flags from user reported comments.
   */
  flags: GQLFlagsConnection;
}

/**
 * Comment is a comment left by a [User](/api/objects/User) on an
 * [Story](/api/objects/Story) or another [Comment](/api/objects/Comment)
 * as a reply.
 */
export interface GQLComment {
  
  /**
   * id is the identifier of the [Comment](/api/objects/Comment).
   */
  id: string;
  
  /**
   * body is the content of the [Comment](/api/objects/Comment), and is an alias to the body of the
   * `revision.body`.
   */
  body?: string;
  
  /**
   * revision is the current revision of the [Comment](/api/objects/Comment)'s body.
   */
  revision?: GQLCommentRevision;
  
  /**
   * revisionHistory stores the previous [CommentRevision](/api/objects/comment-revision)'s, with the most recent
   * edit last.
   */
  revisionHistory: Array<GQLCommentRevision>;
  
  /**
   * createdAt is the date in which the Comment was created.
   */
  createdAt: GQLTime;
  
  /**
   * author is the User that authored the Comment.
   */
  author?: GQLUser;
  
  /**
   * status represents the Comment's current status.
   */
  status: GQLCOMMENT_STATUS;
  
  /**
   * statusHistory returns a CommentModerationActionConnection that will list
   * the history of moderator actions performed on the Comment, with the most
   * recent last.
   */
  statusHistory: GQLCommentModerationActionConnection;
  
  /**
   * parentCount is the number of direct parents for this Comment. Currently this
   * value is the same as depth.
   */
  parentCount: number;
  
  /**
   * depth is the number of levels that a given comment is deep.
   */
  depth: number;
  
  /**
   * replyCount is the number of replies. Only direct replies to this Comment
   * are counted. Removed comments are included in this count.
   */
  replyCount: number;
  
  /**
   * replies will return the replies to this Comment.
   */
  replies: GQLCommentsConnection;
  
  /**
   * parent is the immediate parent of a given comment.
   */
  parent?: GQLComment;
  
  /**
   * rootParent is the highest level parent Comment. This Comment would have been
   * left on the Story itself.
   */
  rootParent?: GQLComment;
  
  /**
   * parents returns a CommentsConnection that allows accessing direct parents of
   * the given Comment.
   */
  parents: GQLCommentsConnection;
  
  /**
   * editing returns details about the edit status of a Comment.
   */
  editing: GQLEditInfo;
  
  /**
   * actionCounts stores the counts of all the actions for the Comment.
   */
  actionCounts: GQLActionCounts;
  
  /**
   * reactions is the actual Flags that were left by the Users or the system.
   */
  reactions: GQLReactionsConnection;
  
  /**
   * flags is the actual Flags that were left by the Users or the system.
   */
  flags: GQLFlagsConnection;
  
  /**
   * viewerActionPresence stores the presence information for all the actions
   * left by the current User on this Comment.
   */
  viewerActionPresence?: GQLActionPresence;
  
  /**
   * story is the Story that the Comment was written on.
   */
  story: GQLStory;
  
  /**
   * The permalink for this comment.
   */
  permalink: string;
  
  /**
   * tags are the list of tags assigned to the Comment.
   */
  tags: Array<GQLTag>;
  
  /**
   * deleted is whether the comment has been deleted.
   */
  deleted?: boolean;
  
  /**
   * canModerate returns true if the current user can moderate this Comment.
   */
  canModerate: boolean;
  
  /**
   * site is the Site referenced by the Story for this Comment.
   */
  site: GQLSite;
  
  /**
   * rating is the optional rating that is attached to the Comment.
   */
  rating?: number;
}

export interface GQLCommentRevision {
  
  /**
   * id is the identifier of the CommentRevision.
   */
  id: string;
  
  /**
   * comment is the reference to the original Comment associated with the current
   * Comment.
   */
  comment: GQLComment;
  
  /**
   * actionCounts stores the counts of all the actions for the CommentRevision
   * specifically.
   */
  actionCounts: GQLActionCounts;
  
  /**
   * body is the content of the CommentRevision. If null, it indicates that the
   * body text was deleted.
   */
  body?: string;
  
  /**
   * media is the optional media object attached to this revision.
   */
  media?: GQLCommentMedia;
  
  /**
   * metadata stores details on a CommentRevision.
   */
  metadata: GQLCommentRevisionMetadata;
  
  /**
   * createdAt is the time that the CommentRevision was created.
   */
  createdAt: GQLTime;
}

/**
 * ActionCounts returns the counts of each action for an item.
 */
export interface GQLActionCounts {
  
  /**
   * reaction returns the counts for the reaction action on an item.
   */
  reaction: GQLReactionActionCounts;
  
  /**
   * dontAgree returns the counts for the dontAgree action on an item. This edge is
   * restricted to administrators and moderators.
   */
  dontAgree: GQLDontAgreeActionCounts;
  
  /**
   * flag returns the counts for the flag action on an item. This edge is
   * restricted to administrators and moderators.
   */
  flag: GQLFlagActionCounts;
}

/**
 * ReactionActionCounts stores all the counts for the counts for the reaction
 * action on a given item.
 */
export interface GQLReactionActionCounts {
  
  /**
   * total is the total number of reactions against a given item.
   */
  total: number;
}

/**
 * DontAgreeActionCounts stores all the counts for the counts for the dontAgree
 * action on a given item.
 */
export interface GQLDontAgreeActionCounts {
  
  /**
   * total is the total number of dontAgree actions against a given item.
   */
  total: number;
}

/**
 * FlagActionCounts stores all the counts for the counts for the flag action on a
 * given item and the reason counts.
 */
export interface GQLFlagActionCounts {
  
  /**
   * total is the total number of flags against a given item.
   */
  total: number;
  
  /**
   * reasons stores the counts for the various reasons that an item could be
   * flagged for.
   */
  reasons: GQLFlagReasonActionCounts;
}

export interface GQLFlagReasonActionCounts {
  COMMENT_REPORTED_OFFENSIVE: number;
  COMMENT_REPORTED_ABUSIVE: number;
  COMMENT_REPORTED_SPAM: number;
  COMMENT_REPORTED_OTHER: number;
  COMMENT_REPORTED_BIO: number;
  COMMENT_DETECTED_TOXIC: number;
  COMMENT_DETECTED_SPAM: number;
  COMMENT_DETECTED_LINKS: number;
  COMMENT_DETECTED_BANNED_WORD: number;
  COMMENT_DETECTED_SUSPECT_WORD: number;
  COMMENT_DETECTED_RECENT_HISTORY: number;
  COMMENT_DETECTED_PREMOD_USER: number;
  COMMENT_DETECTED_NEW_COMMENTER: number;
  COMMENT_DETECTED_REPEAT_POST: number;
}

/**
 * CommentMedia is the various media types that can be attached to a Comment.
 */
export type GQLCommentMedia =
GQLGiphyMedia |
GQLTwitterMedia |
GQLYouTubeMedia |
GQLExternalMedia;

/** Use this to resolve union type CommentMedia */
export type GQLPossibleCommentMediaTypeNames =
'GiphyMedia' |
'TwitterMedia' |
'YouTubeMedia' |
'ExternalMedia';

export interface GQLCommentMediaNameMap {
  CommentMedia: GQLCommentMedia;
  GiphyMedia: GQLGiphyMedia;
  TwitterMedia: GQLTwitterMedia;
  YouTubeMedia: GQLYouTubeMedia;
  ExternalMedia: GQLExternalMedia;
}

/**
 * GiphyMedia is a particular GIF that is provided by the Giphy platform.
 */
export interface GQLGiphyMedia {
  
  /**
   * url is the URL to a image of the GIF.
   */
  url: string;
  
  /**
   * original is the URL to a image of the GIF.
   */
  original: string;
  
  /**
   * still is a thumbnail preview of the GIF.
   */
  still: string;
  
  /**
   * video is a URL to the mp4 video of the GIF.
   */
  video: string;
  
  /**
   * width is the width of the GIF in pixels.
   */
  width?: number;
  
  /**
   * height is the height of the GIF in pixels.
   */
  height?: number;
  
  /**
   * title is the title of the GIF.
   */
  title?: string;
}

/**
 * TwitterMedia is a specific Twitter Tweet.
 */
export interface GQLTwitterMedia {
  
  /**
   * url is the URL of a Twitter tweet.
   */
  url: string;
  
  /**
   * width is the width of the Twitter tweet in pixels.
   */
  width?: number;
}

/**
 * YouTubeMedia is a specific YouTube video.
 */
export interface GQLYouTubeMedia {
  
  /**
   * url is the URL of a YouTube video.
   */
  url: string;
  
  /**
   * still is the thumbnail of the YouTube video.
   */
  still: string;
  
  /**
   * title is the title of the YouTube video.
   */
  title?: string;
  
  /**
   * width is the width of the YouTube video in pixels.
   */
  width?: number;
  
  /**
   * height is the height of the YouTube video in pixels.
   */
  height?: number;
}

export interface GQLExternalMedia {
  
  /**
   * url is the URL of a YouTube video.
   */
  url: string;
  
  /**
   * extension is the file extension
   */
  extension: string;
  
  /**
   * width is the width of the YouTube video in pixels.
   */
  width?: number;
  
  /**
   * height is the height of the YouTube video in pixels.
   */
  height?: number;
}

export interface GQLCommentRevisionMetadata {
  
  /**
   * perspective stores metadata associated with the pipeline analysis of this
   * revision's body.
   */
  perspective?: GQLCommentRevisionPerspectiveMetadata;
  
  /**
   * wordList metadata stores extra status details about what occurred during
   * word list analysis of this comment revision.
   */
  wordList?: GQLCommentRevisionWordListMetadata;
  
  /**
   * externalModeration are the phases and their actions that were used to
   * analyze this comment revision.
   */
  externalModeration?: Array<GQLCommentRevisionExternalModerationPhaseMetadata>;
}

export interface GQLCommentRevisionPerspectiveMetadata {
  
  /**
   * score is the value detected from the perspective API. This is returned as the
   * percentage chance it would be considered toxic and can be compared to the
   * defined threshold value.
   */
  score: number;
}

export interface GQLCommentRevisionWordListMetadata {
  
  /**
   * timedOut is whether the wordlist analysis timed out when this revision
   * of the comment was sent through the moderation phases.
   */
  timedOut?: boolean;
}

export interface GQLCommentRevisionExternalModerationPhaseMetadata {
  name: string;
  analyzedAt: GQLTime;
  result: GQLExternalModerationPhaseResult;
}

/**
 * Time represented as an ISO8601 string.
 */
export type GQLTime = any;

export interface GQLExternalModerationPhaseResult {
  status?: GQLCOMMENT_STATUS;
  tags?: Array<GQLTAG>;
  actions?: Array<GQLExternalModerationPhaseAction>;
}

export enum GQLCOMMENT_STATUS {
  
  /**
   * The comment is not PREMOD, but was not applied a moderation status by a
   * moderator.
   */
  NONE = 'NONE',
  
  /**
   * The comment has been approved by a moderator.
   */
  APPROVED = 'APPROVED',
  
  /**
   * The comment has been rejected by a moderator.
   */
  REJECTED = 'REJECTED',
  
  /**
   * The comment was created while the stories premoderation option was on, and
   * new comments that haven't been moderated yet are referred to as
   * "premoderated" or "premod" comments.
   */
  PREMOD = 'PREMOD',
  
  /**
   * SYSTEM_WITHHELD represents a comment that was withheld by the system because
   * it was flagged by an internal process for further review.
   */
  SYSTEM_WITHHELD = 'SYSTEM_WITHHELD'
}

export enum GQLTAG {
  
  /**
   * STAFF is used when a Comment is written by a User that has the STAFF, ADMIN,
   * or MODERATOR role.
   */
  STAFF = 'STAFF',
  
  /**
   * ADMIN is used when a Comment is written by a User that has the ADMIN,
   * role.
   */
  ADMIN = 'ADMIN',
  
  /**
   * MODERATOR is used when a Comment is written by a User that has the MODERATOR,
   * role.
   */
  MODERATOR = 'MODERATOR',
  
  /**
   * FEATURED is used when a Comment is marked as such by a staff member.
   */
  FEATURED = 'FEATURED',
  
  /**
   * EXPERT is used when an a Comment is written by a User that is assigned as
   * an expert on a story.
   */
  EXPERT = 'EXPERT',
  
  /**
   * UNANSWERED is used when a Comment is written by a user and has not been
   * answered by an expert on a Story that is set to Q&A.
   */
  UNANSWERED = 'UNANSWERED',
  
  /**
   * REVIEW is used when a Comment is written with a rating on a Story that is set
   * to Ratings and Reviews.
   */
  REVIEW = 'REVIEW',
  
  /**
   * QUESTION is used when a Comment is written without a rating on a Story
   * that is set to Ratings and Reviews.
   */
  QUESTION = 'QUESTION'
}

export interface GQLExternalModerationPhaseAction {
  reason?: GQLCOMMENT_FLAG_REASON;
}

/**
 * COMMENT_FLAG_REASON is the union of the COMMENT_FLAG_REPORTED_REASON
 * and COMMENT_FLAG_DETECTED_REASON types.
 */
export enum GQLCOMMENT_FLAG_REASON {
  COMMENT_REPORTED_OFFENSIVE = 'COMMENT_REPORTED_OFFENSIVE',
  COMMENT_REPORTED_ABUSIVE = 'COMMENT_REPORTED_ABUSIVE',
  COMMENT_REPORTED_SPAM = 'COMMENT_REPORTED_SPAM',
  COMMENT_REPORTED_OTHER = 'COMMENT_REPORTED_OTHER',
  COMMENT_REPORTED_BIO = 'COMMENT_REPORTED_BIO',
  COMMENT_DETECTED_TOXIC = 'COMMENT_DETECTED_TOXIC',
  COMMENT_DETECTED_SPAM = 'COMMENT_DETECTED_SPAM',
  COMMENT_DETECTED_LINKS = 'COMMENT_DETECTED_LINKS',
  COMMENT_DETECTED_BANNED_WORD = 'COMMENT_DETECTED_BANNED_WORD',
  COMMENT_DETECTED_SUSPECT_WORD = 'COMMENT_DETECTED_SUSPECT_WORD',
  COMMENT_DETECTED_RECENT_HISTORY = 'COMMENT_DETECTED_RECENT_HISTORY',
  COMMENT_DETECTED_PREMOD_USER = 'COMMENT_DETECTED_PREMOD_USER',
  COMMENT_DETECTED_NEW_COMMENTER = 'COMMENT_DETECTED_NEW_COMMENTER',
  COMMENT_DETECTED_REPEAT_POST = 'COMMENT_DETECTED_REPEAT_POST'
}

/**
 * User is someone that leaves Comments, and logs in.
 */
export interface GQLUser {
  
  /**
   * id is the identifier of the User.
   */
  id: string;
  
  /**
   * username is the name of the User visible to other Users.
   */
  username?: string;
  
  /**
   * avatar is the url to the avatar for a specific User.
   */
  avatar?: string;
  
  /**
   * badges are user display badges
   */
  badges?: Array<string>;
  
  /**
   * email is the current email address for the User.
   */
  email?: string;
  
  /**
   * duplicateEmail is set on users that have a matching email with another user in
   * the database. Only relevant during the account completion process.
   */
  duplicateEmail?: string;
  
  /**
   * emailVerified when true indicates that the given email address has been
   * verified.
   */
  emailVerified?: boolean;
  
  /**
   * profiles is the array of profiles assigned to the user.
   */
  profiles: Array<GQLProfile>;
  
  /**
   * role is the current role of the User.
   */
  role: GQLUSER_ROLE;
  
  /**
   * moderatorNotes are notes left by moderators about the User.
   */
  moderatorNotes: Array<GQLModeratorNote>;
  
  /**
   * ignoreable is a computed property based on the user's role. Typically, users
   * with elevated privileges aren't allowed to be ignored.
   */
  ignoreable: boolean;
  
  /**
   * comments are the comments written by the User.
   */
  comments: GQLCommentsConnection;
  
  /**
   * allComments are comments regardless of visibility status.
   */
  allComments: GQLCommentsConnection;
  
  /**
   * rejectedComments are comments that have been rejected.
   */
  rejectedComments: GQLCommentsConnection;
  
  /**
   * ongoingDiscussions are stories where the given user has written comments in
   * sorted by their last comment date.
   */
  ongoingDiscussions: Array<GQLStory>;
  
  /**
   * recentCommentHistory returns recent commenting history by the User.
   */
  recentCommentHistory: GQLRecentCommentHistory;
  
  /**
   * commentModerationActionHistory returns a CommentModerationActionConnection
   * that this User has created.
   */
  commentModerationActionHistory: GQLCommentModerationActionConnection;
  
  /**
   * status stores the user status information regarding moderation state.
   */
  status: GQLUserStatus;
  
  /**
   * tokens lists the access tokens associated with the account.
   */
  tokens: Array<GQLToken>;
  
  /**
   * ignoredUsers will return the list of ignored users.
   */
  ignoredUsers: Array<GQLUser>;
  
  /**
   * notifications stores the notification settings for the given User.
   */
  notifications: GQLUserNotificationSettings;
  
  /**
   * createdAt is the time that the User was created at.
   */
  createdAt: GQLTime;
  
  /**
   * lastDownloadedAt the last time the user made a download request
   * of their account data.
   */
  lastDownloadedAt?: GQLTime;
  
  /**
   * scheduledDeletionDate is the time when the User is
   * scheduled to be deleted.
   */
  scheduledDeletionDate?: GQLTime;
  
  /**
   * deletedAt is the time when the User was deleted.
   */
  deletedAt?: GQLTime;
  
  /**
   * moderationScopes describes the scopes for moderation. These only apply when
   * the user has a MODERATOR role.
   */
  moderationScopes?: GQLUserModerationScopes;
  
  /**
   * ssoURL is the url for managing sso account
   */
  ssoURL?: string;
  
  /**
   * mediaSettings are the user's preferences around media stream behaviour.
   */
  mediaSettings: GQLUserMediaSettings;
  
  /**
   * bio is a user-defined biography.
   */
  bio?: string;
}

/**
 * Profile is all the different profiles that a given User may have associated
 * with their account.
 */
export type GQLProfile =
GQLLocalProfile |
GQLOIDCProfile |
GQLSSOProfile |
GQLFacebookProfile |
GQLGoogleProfile;

/** Use this to resolve union type Profile */
export type GQLPossibleProfileTypeNames =
'LocalProfile' |
'OIDCProfile' |
'SSOProfile' |
'FacebookProfile' |
'GoogleProfile';

export interface GQLProfileNameMap {
  Profile: GQLProfile;
  LocalProfile: GQLLocalProfile;
  OIDCProfile: GQLOIDCProfile;
  SSOProfile: GQLSSOProfile;
  FacebookProfile: GQLFacebookProfile;
  GoogleProfile: GQLGoogleProfile;
}

export interface GQLLocalProfile {
  id: string;
}

export interface GQLOIDCProfile {
  id: string;
  provider: string;
}

export interface GQLSSOProfile {
  id: string;
}

export interface GQLFacebookProfile {
  id: string;
}

export interface GQLGoogleProfile {
  id: string;
}

export enum GQLUSER_ROLE {
  COMMENTER = 'COMMENTER',
  STAFF = 'STAFF',
  MODERATOR = 'MODERATOR',
  ADMIN = 'ADMIN'
}

export interface GQLModeratorNote {
  
  /**
   * id is the identifier of the Note.
   */
  id: string;
  
  /**
   * body is the content of the Note
   */
  body: string;
  
  /**
   * createdAt is the date in which the Note was created.
   */
  createdAt: GQLTime;
  
  /**
   * createdBy is the Moderator that authored the Note.
   */
  createdBy: GQLUser;
}

export enum GQLCOMMENT_SORT {
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  REPLIES_DESC = 'REPLIES_DESC',
  REACTION_DESC = 'REACTION_DESC'
}

/**
 * Cursor represents a paginating cursor.
 */
export type GQLCursor = any;

/**
 * CommentsConnection represents a subset of a comment list.
 */
export interface GQLCommentsConnection {
  
  /**
   * edges are a subset of CommentEdge's.
   */
  edges: Array<GQLCommentEdge>;
  
  /**
   * nodes is a list of Comment's.
   */
  nodes: Array<GQLComment>;
  
  /**
   * pageInfo is information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * CommentEdge represents a unique Comment in a CommentsConnection.
 */
export interface GQLCommentEdge {
  
  /**
   * node is the Comment for this edge.
   */
  node: GQLComment;
  
  /**
   * cursor is used in pagination.
   */
  cursor: GQLCursor;
}

export interface GQLPageInfo {
  
  /**
   * Indicates that there are more nodes after this subset.
   */
  hasNextPage: boolean;
  
  /**
   * Included for legacy Relay reasons. Always set to false.
   */
  hasPreviousPage: boolean;
  
  /**
   * Included for legacy Relay reasons. Always set to null.
   */
  startCursor?: GQLCursor;
  
  /**
   * Specifies the last node's cursor for forwards pagination.
   */
  endCursor?: GQLCursor;
}

/**
 * Story is an Article or Page where Comments are written on by Users.
 */
export interface GQLStory {
  
  /**
   * id is the identifier of the Story.
   */
  id: string;
  
  /**
   * status is the status of the Story.
   */
  status: GQLSTORY_STATUS;
  
  /**
   * url is the url that the Story is located on.
   */
  url: string;
  
  /**
   * metadata stores the scraped metadata from the Story page.
   */
  metadata?: GQLStoryMetadata;
  
  /**
   * scrapedAt is the Time that the Story had it's metadata scraped at. If the time
   * is null, the Story has not been scraped yet.
   */
  scrapedAt?: GQLTime;
  
  /**
   * featuredComments are the Comments with the FEATURED tag on the Story.
   */
  featuredComments: GQLCommentsConnection;
  
  /**
   * comments are the comments on the Story.
   */
  comments: GQLCommentsConnection;
  
  /**
   * commentActionCounts stores the counts of all the actions against this Story and it's
   * Comments.
   */
  commentActionCounts: GQLActionCounts;
  
  /**
   * moderationQueues returns the set of ModerationQueues that are available for
   * this Story.
   */
  moderationQueues: GQLModerationQueues;
  
  /**
   * closedAt is the Time that the Story is closed for commenting. If null or in
   * the future, the story is not yet closed.
   */
  closedAt?: GQLTime;
  
  /**
   * isClosed returns true when the Story is currently closed for commenting.
   */
  isClosed: boolean;
  
  /**
   * commentCounts stores all the counts of Comments that are left on the Comment.
   */
  commentCounts: GQLCommentCounts;
  
  /**
   * createdAt is the date that the Story was created at.
   */
  createdAt: GQLTime;
  
  /**
   * settings is the set of Settings on a Story that inherit from the global
   * settings.
   */
  settings: GQLStorySettings;
  
  /**
   * lastCommentedAt is the last time someone commented on this story.
   */
  lastCommentedAt?: GQLTime;
  
  /**
   * canModerate returns true if the current user can moderate comments on this
   * Story.
   */
  canModerate: boolean;
  
  /**
   * site is the site associated with the story
   */
  site: GQLSite;
  
  /**
   * viewerCount is the number of viewers active on this Story.
   */
  viewerCount?: number;
  
  /**
   * ratings is information about ratings that is attached to this story by
   * published comments.
   */
  ratings?: GQLStoryRatings;
  
  /**
   * viewerRating is the Comment with a rating that the viewer has already added to
   * this story.
   */
  viewerRating?: GQLComment;
}

/**
 * STORY_STATUS represents filtering states that a Story can be in.
 */
export enum GQLSTORY_STATUS {
  
  /**
   * OPEN represents when a given Story is open for commenting.
   */
  OPEN = 'OPEN',
  
  /**
   * CLOSED represents when a given Story is not open for commenting.
   */
  CLOSED = 'CLOSED'
}

/**
 * StoryMetadata stores all the metadata that is scraped using the scraping tools
 * inside Coral. Coral utilizes [metascraper](https://metascraper.js.org/) which uses
 * a variety of filters derived from [The Open Graph Protocol](https://ogp.me/) to
 * scan for metadata on the page.
 */
export interface GQLStoryMetadata {
  
  /**
   * title stores the scraped title from the Story page.
   */
  title?: string;
  
  /**
   * author stores the scraped author from the Story page.
   */
  author?: string;
  
  /**
   * description stores the scraped description from the Story page.
   */
  description?: string;
  
  /**
   * image stores the scraped image from the Story page.
   */
  image?: string;
  
  /**
   * publishedAt stores the scraped publication date from the Story page.
   */
  publishedAt?: GQLTime;
  
  /**
   * modifiedAt stores the scraped modified date from the Story page.
   */
  modifiedAt?: GQLTime;
  
  /**
   * section stores the scraped section from the Story page.
   */
  section?: string;
}

/**
 * ModerationQueues are the list of ModerationQueue's that are supported inside
 * Coral that can be used to moderate Comments.
 */
export interface GQLModerationQueues {
  
  /**
   * unmoderated will return a ModerationQueue for all Comments that have not been
   * moderated yet.
   */
  unmoderated: GQLModerationQueue;
  
  /**
   * reported will return a ModerationQueue for all Comments that have been
   * published, have not been moderated by a human yet, and have been reported by
   * a User via a flag.
   */
  reported: GQLModerationQueue;
  
  /**
   * pending will return a ModerationQueue for all Comments that were held back by
   * the system and require moderation in order to be published.
   */
  pending: GQLModerationQueue;
}

/**
 * ModerationQueue returns the Comments associated with a Moderation Queue.
 */
export interface GQLModerationQueue {
  
  /**
   * id is a canonical identifier for this specific moderation queue.
   */
  id: string;
  
  /**
   * count will return the number of Comments that are in this queue.
   */
  count?: number;
  
  /**
   * comments are the comments on the ModerationQueue.
   */
  comments: GQLCommentsConnection;
}

export interface GQLCommentCounts {
  
  /**
   * totalPublished will return the count of all published Comments.
   */
  totalPublished: number;
  
  /**
   * tags stores the counts of all the Tags against Comment's on this Story.
   */
  tags: GQLCommentTagCounts;
  
  /**
   * statuses stores the counts of all the statuses against Comments on this Story.
   */
  statuses: GQLCommentStatusCounts;
}

/**
 * CommentTagCounts provides count data for Tags made against Comment's.
 */
export interface GQLCommentTagCounts {
  
  /**
   * FEATURED is the count of Comment's with the FEATURED tag.
   */
  FEATURED: number;
  
  /**
   * UNANSWERED is the count of Comment's with the UNANSWERED tag.
   */
  UNANSWERED: number;
  
  /**
   * REVIEW is the count of Comment's with the REVIEW tag.
   */
  REVIEW: number;
  
  /**
   * QUESTION is the count of Comment's with the QUESTION tag.
   */
  QUESTION: number;
}

export interface GQLCommentStatusCounts {
  
  /**
   * The comment is not PREMOD, but was not applied a moderation status by a
   * moderator.
   */
  NONE: number;
  
  /**
   * The comment has been approved by a moderator.
   */
  APPROVED: number;
  
  /**
   * The comment has been rejected by a moderator.
   */
  REJECTED: number;
  
  /**
   * The comment was created while the stories premoderation option was on, and
   * new comments that haven't been moderated yet are referred to as
   * "premoderated" or "premod" comments.
   */
  PREMOD: number;
  
  /**
   * SYSTEM_WITHHELD represents a comment that was withheld by the system because
   * it was flagged by an internal process for further review.
   */
  SYSTEM_WITHHELD: number;
}

export interface GQLStorySettings {
  
  /**
   * live provides configuration options related to live updates on this Story.
   */
  live: GQLLiveConfiguration;
  
  /**
   * moderation determines whether or not this is a PRE or POST moderated story.
   */
  moderation: GQLMODERATION_MODE;
  
  /**
   * premodLinksEnable will put all comments that contain links into premod.
   */
  premodLinksEnable: boolean;
  
  /**
   * messageBox stores settings related to the Story Message Box.
   */
  messageBox: GQLStoryMessageBox;
  
  /**
   * mode is the specified mode that the story should be updated with.
   */
  mode: GQLSTORY_MODE;
  
  /**
   * experts are used during Q&A mode to assign users to answer questions
   * on a Q&A stream. It is an optional parameter and is only used when
   * the story stream is in Q&A mode.
   */
  experts: Array<GQLUser>;
}

/**
 * LiveConfiguration provides configuration options related to live updates.
 */
export interface GQLLiveConfiguration {
  
  /**
   * configurable when false indicates that live updates cannot be modified.
   */
  configurable: boolean;
  
  /**
   * enabled when true will allow live updates.
   */
  enabled: boolean;
}

export enum GQLMODERATION_MODE {
  
  /**
   * Comments posted while in `PRE` mode will be labeled with a `PREMOD`
   * status and will require a moderator decision before being visible.
   */
  PRE = 'PRE',
  
  /**
   * Comments posted while in `POST` will be visible immediately.
   */
  POST = 'POST'
}

/**
 * StoryMessageBox stores settings related to the Story Message Box.
 */
export interface GQLStoryMessageBox {
  
  /**
   * enable when true will enable the Message Box on the comment stream.
   */
  enabled: boolean;
  
  /**
   * icon when set will reference the string for the Message box used by the
   * Message Box.
   */
  icon?: string;
  
  /**
   * content when set contains the actual markup for the Message Box.
   */
  content?: string;
}

export enum GQLSTORY_MODE {
  
  /**
   * Coments is when a story is used for general commenting.
   */
  COMMENTS = 'COMMENTS',
  
  /**
   * QA is used for when the story is in Q&A mode.
   */
  QA = 'QA',
  
  /**
   * RATINGS_AND_REVIEWS is used for when the story should be used for ratings and
   * reviews.
   */
  RATINGS_AND_REVIEWS = 'RATINGS_AND_REVIEWS'
}

export interface GQLSite {
  
  /**
   * id is the identifier of the Site.
   */
  id: string;
  
  /**
   * name is the name of the Site.
   */
  name: string;
  
  /**
   * allowedOrigins are the allowed origins for embeds.
   */
  allowedOrigins: Array<string>;
  
  /**
   * canModerate when true indicates that the current user can moderate comments
   * left on this Site.
   */
  canModerate: boolean;
  
  /**
   * topStories will return stories that have had the most comments within the last
   * 24 hours on this Site.
   */
  topStories: Array<GQLStory>;
  
  /**
   * createdAt is when the site was created.
   */
  createdAt: GQLTime;
}

export interface GQLStoryRatings {
  
  /**
   * average refers to the average rating across all ratings for the Story from
   * published comments.
   */
  average: number;
  
  /**
   * count refers to the number of ratings that have been submitted that
   * contributes to the `average`.
   */
  count: number;
}

/**
 * RecentCommentHistory returns data associated with a User's recent commenting
 * history within the specified timeFrame configured.
 */
export interface GQLRecentCommentHistory {
  
  /**
   * statuses stores the counts of all the statuses against Comments by a User
   * within the timeFrame configured.
   */
  statuses: GQLCommentStatusCounts;
}

export interface GQLCommentModerationActionConnection {
  
  /**
   * edges are a subset of CommentModerationActionEdge's.
   */
  edges: Array<GQLCommentModerationActionEdge>;
  
  /**
   * nodes is a list of CommentModerationAction's.
   */
  nodes: Array<GQLCommentModerationAction>;
  
  /**
   * pageInfo is information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

export interface GQLCommentModerationActionEdge {
  
  /**
   * node is the CommentModerationAction for this edge.
   */
  node: GQLCommentModerationAction;
  
  /**
   * cursor is used in pagination.
   */
  cursor: GQLCursor;
}

export interface GQLCommentModerationAction {
  id: string;
  
  /**
   * revision is the moderated CommentRevision.
   */
  revision: GQLCommentRevision;
  
  /**
   * status represents the status that was assigned by the moderator.
   */
  status: GQLCOMMENT_STATUS;
  
  /**
   * moderator is the User that performed the Moderator action. If null, this means
   * that the system has assigned the moderation status.
   */
  moderator?: GQLUser;
  
  /**
   * createdAt is the time that the CommentModerationAction was created.
   */
  createdAt: GQLTime;
}

/**
 * UserStatus stores the user status information regarding moderation state.
 */
export interface GQLUserStatus {
  
  /**
   * current represents the current statuses applied to the User.
   */
  current: Array<GQLUSER_STATUS>;
  
  /**
   * username stores the history of username changes for this user
   */
  username: GQLUsernameStatus;
  
  /**
   * banned stores the user banned status as well as the history of changes.
   */
  ban: GQLBanStatus;
  
  /**
   * suspension stores the user suspension status as well as the history of
   * changes.
   */
  suspension: GQLSuspensionStatus;
  
  /**
   * premod stores the user premod status as well as the history of changes.
   */
  premod: GQLPremodStatus;
  
  /**
   * warning stores the user warning status as well as the history of warnings
   */
  warning: GQLWarningStatus;
}

/**
 * USER_STATUS is used to describe the current state of a User. A User may exist in
 * multiple states.
 */
export enum GQLUSER_STATUS {
  
  /**
   * ACTIVE is used when a User is not suspended or banned.
   */
  ACTIVE = 'ACTIVE',
  
  /**
   * BANNED is used when a User is banned.
   */
  BANNED = 'BANNED',
  
  /**
   * SUSPENDED is used when a User is currently suspended.
   */
  SUSPENDED = 'SUSPENDED',
  
  /**
   * PREMOD is used when a User is currently set to require pre-moderation.
   */
  PREMOD = 'PREMOD',
  
  /**
   * WARNED is used when a user has been warned about behaviour and has not acknowledged
   */
  WARNED = 'WARNED'
}

export interface GQLUsernameStatus {
  
  /**
   * history is the list of all usernames for this user
   */
  history: Array<GQLUsernameHistory>;
}

export interface GQLUsernameHistory {
  
  /**
   * username is the username that was assigned
   */
  username: string;
  
  /**
   * createdBy is the user that created this username
   */
  createdBy: GQLUser;
  
  /**
   * createdAt is the time the username was created
   */
  createdAt: GQLTime;
}

/**
 * BanStatus contains information about a ban for a given User.
 */
export interface GQLBanStatus {
  
  /**
   * active when true, indicates that the given user is banned.
   */
  active: boolean;
  
  /**
   * sites is a list of sites that the user has been site banned on.
   */
  sites?: Array<GQLSite>;
  
  /**
   * history is the list of all ban events against a specific User.
   */
  history: Array<GQLBanStatusHistory>;
}

/**
 * BanStatusHistory is the list of all ban events against a specific User.
 */
export interface GQLBanStatusHistory {
  
  /**
   * active when true, indicates that the given user is banned.
   */
  active: boolean;
  
  /**
   * createdBy is the User that suspended the User. If `null`, the then the given
   * User was banned by the system.
   */
  createdBy?: GQLUser;
  
  /**
   * createdAt is the time that the given User was banned.
   */
  createdAt: GQLTime;
  
  /**
   * message is sent to banned user via email.
   */
  message: string;
  
  /**
   * sites are set when the ban was created to perform a site specific ban.
   */
  sites?: Array<GQLSite>;
}

/**
 * SuspensionStatus stores the user suspension status as well as the history of
 * changes.
 */
export interface GQLSuspensionStatus {
  
  /**
   * active when true, indicates that the given user is suspended.
   */
  active: boolean;
  
  /**
   * until is the time that the current user suspension is over.
   */
  until?: GQLTime;
  
  /**
   * history is the list of all suspension events against a specific User.
   */
  history: Array<GQLSuspensionStatusHistory>;
}

/**
 * SuspensionStatusHistory is the list of all suspension events against a specific User.
 */
export interface GQLSuspensionStatusHistory {
  
  /**
   * active is true when the given suspension status time range applies now.
   */
  active: boolean;
  
  /**
   * from is the time range that the suspension is active for.
   */
  from: GQLTimeRange;
  
  /**
   * createdBy is the User that suspended the User. If `null`, the then the given
   * User was suspended by the system.
   */
  createdBy?: GQLUser;
  
  /**
   * createdAt is the time that the suspension was created at.
   */
  createdAt: GQLTime;
  
  /**
   * modifiedBy is the User that cancelled/edited the suspension. If `null`, then
   * the suspension has not been cancelled/edited, or has been edited by the
   * system.
   */
  modifiedBy?: GQLUser;
  
  /**
   * modifiedAt is the time that the suspension was cancelled/edited. If `null`,
   * then the suspension has not been cancelled/edited.
   */
  modifiedAt?: GQLTime;
  
  /**
   * message is sent to suspended user via email.
   */
  message: string;
}

/**
 * TimeRange represents a range of times.
 */
export interface GQLTimeRange {
  
  /**
   * start is the time that the time range started on.
   */
  start: GQLTime;
  
  /**
   * finish is the time that the time range finished at.
   */
  finish: GQLTime;
}

export interface GQLPremodStatus {
  
  /**
   * active when true, indicates that the given user is set to pre-mod.
   */
  active: boolean;
  
  /**
   * history is the list of all suspension events against a specific User.
   */
  history: Array<GQLPremodStatusHistory>;
}

export interface GQLPremodStatusHistory {
  
  /**
   * active when true, indicates that the given user is premodded.
   */
  active: boolean;
  
  /**
   * createdBy is the user that flagged the commenter as pre-mod
   */
  createdBy: GQLUser;
  
  /**
   * createdAt is the time the user was set to pre-mod
   */
  createdAt: GQLTime;
}

export interface GQLWarningStatus {
  
  /**
   * active when true, indicates that the given user has been warned but has not acknowledged it.
   */
  active: boolean;
  
  /**
   * message is the current message for the warning on the User.
   */
  message?: string;
  
  /**
   * history will return the status history items for warnings.
   */
  history: Array<GQLWarningStatusHistory>;
}

export interface GQLWarningStatusHistory {
  
  /**
   * active when true, indicates that the given user has been warned but has not acknowledged the warning.
   */
  active: boolean;
  
  /**
   * createdBy is the user that warned the commenter
   */
  createdBy: GQLUser;
  
  /**
   * createdAt is the time the user was warned
   */
  createdAt: GQLTime;
  
  /**
   * acknowledgedAt is the time the commenter acknowledged the warning. if `null` then the warning
   * has not been acknowledged
   */
  acknowledgedAt?: GQLTime;
  
  /**
   * message is the custom message sent to the commenter
   */
  message?: string;
}

/**
 * Token facilitates accessing Coral externally with a token.
 */
export interface GQLToken {
  id: string;
  name: string;
  createdAt: GQLTime;
}

/**
 * UserNotificationSettings stores the notification settings for a given User.
 */
export interface GQLUserNotificationSettings {
  
  /**
   * onReply, when true, will enable notifications to be sent to users that have
   * replies to their comments.
   */
  onReply: boolean;
  
  /**
   * onFeatured, when true, will enable notifications to be sent to users that have
   * their comment's featured.
   */
  onFeatured: boolean;
  
  /**
   * onStaffReplies when true, will enable notifications to be sent to users that
   * have a staff member reply to their comments. These notifications will
   * supercede notifications that would have been sent for a basic reply
   * notification.
   */
  onStaffReplies: boolean;
  
  /**
   * onModeration when true, will enable notifications to be sent to users when a
   * comment that they wrote that was previously unpublished, becomes published due
   * to a moderator action.
   */
  onModeration: boolean;
  
  /**
   * digestFrequency is the frequency to send notifications.
   */
  digestFrequency: GQLDIGEST_FREQUENCY;
}

export enum GQLDIGEST_FREQUENCY {
  
  /**
   * NONE will have the notifications send immediatly rather than bundling for digesting.
   */
  NONE = 'NONE',
  
  /**
   * DAILY will queue up the notifications and send them daily.
   */
  DAILY = 'DAILY',
  
  /**
   * HOURLY will queue up the notifications and send them hourly.
   */
  HOURLY = 'HOURLY'
}

/**
 * UserModerationScopes describes the scopes for moderation. These only apply when
 * the user has a MODERATOR role.
 */
export interface GQLUserModerationScopes {
  
  /**
   * scoped returns true when the moderator has a scoped moderation role, and
   * cannot moderate organization wide.
   */
  scoped: boolean;
  
  /**
   * sites (when not null) list the sites that the user is only allowed to moderate
   * on. When null, it means that the user is allowed to moderate on all sites.
   */
  sites?: Array<GQLSite>;
}

/**
 * UserMediaSettings are the user's preferences around embed stream behaviour.
 */
export interface GQLUserMediaSettings {
  
  /**
   * unfurlEmbeds is whether the user has chosen to immediately show embed contents
   * without having to click "Show Tweet", "Show GIF", etc.
   */
  unfurlEmbeds: boolean;
}

export interface GQLEditInfo {
  
  /**
   * edited will be True when the Comment has been edited in the past.
   */
  edited: boolean;
  
  /**
   * editableUntil is the time that the comment is editable until. This will return
   * null if the current viewer is not the author of the Comment.
   */
  editableUntil?: GQLTime;
}

export interface GQLReactionsConnection {
  
  /**
   * edges are a subset of FlagEdge's.
   */
  edges: Array<GQLReactionEdge>;
  
  /**
   * nodes is a list of Flags.
   */
  nodes: Array<GQLReaction>;
  
  /**
   * pageInfo is information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

export interface GQLReactionEdge {
  
  /**
   * node is the Flag for this edge.
   */
  node: GQLReaction;
  
  /**
   * cursor is used in pagination.
   */
  cursor: GQLCursor;
}

export interface GQLReaction {
  id?: string;
  reacter?: GQLReacter;
}

export interface GQLReacter {
  username?: string;
  userID?: string;
}

export interface GQLFlagsConnection {
  
  /**
   * edges are a subset of FlagEdge's.
   */
  edges: Array<GQLFlagEdge>;
  
  /**
   * nodes is a list of Flags.
   */
  nodes: Array<GQLFlag>;
  
  /**
   * pageInfo is information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

export interface GQLFlagEdge {
  
  /**
   * node is the Flag for this edge.
   */
  node: GQLFlag;
  
  /**
   * cursor is used in pagination.
   */
  cursor: GQLCursor;
}

export interface GQLFlag {
  
  /**
   * id is the identifier for this flag action.
   */
  id: string;
  
  /**
   * flagger is the User that created the Flag. If this is null, then the system
   * created the Flag.
   */
  flagger?: GQLUser;
  
  /**
   * comment is the comment this flag was created on.
   */
  comment: GQLComment;
  
  /**
   * revision is the comment revision this flag was generated upon.
   */
  revision?: GQLCommentRevision;
  
  /**
   * reason is the selected reason why the Flag is being created. If the reason is
   * not defined, or existed from a previous version of Coral, it will return null
   * to avoid errors.
   */
  reason?: GQLCOMMENT_FLAG_REASON;
  
  /**
   * additionalDetails stores information from the User as to why the Flag was
   * created or is relevant.
   */
  additionalDetails?: string;
  
  /**
   * reviewed is whether this flag reason and details have been reviewed by a
   * moderator.
   */
  reviewed: boolean;
  
  /**
   * createdAt is when this flag was created.
   */
  createdAt: GQLTime;
}

/**
 * ActionPresence returns whether or not a given item has one of the following
 * actions on it. This is typically used to determine if a given user has left
 * one of the following actions.
 */
export interface GQLActionPresence {
  
  /**
   * reaction is true when a reaction action was left on an item.
   */
  reaction: boolean;
  
  /**
   * dontAgree is true when a dontAgree action was left on an item.
   */
  dontAgree: boolean;
  
  /**
   * flag is true when a flag action was left on an item.
   */
  flag: boolean;
}

/**
 * Tag is a simple text message that can be displayed to segment tagable entities.
 */
export interface GQLTag {
  
  /**
   * code is the machine representation of the tag name.
   */
  code: GQLTAG;
  
  /**
   * createdBy is the User that assigned the Tag. This is null when the Tag is
   * assigned by the System.
   */
  createdBy?: GQLUser;
  
  /**
   * createdAt is the time that the Tag was assigned on.
   */
  createdAt: GQLTime;
}

export interface GQLSectionFilter {
  
  /**
   * name when provided will filter only those comments/stories that have this
   * section. When name is not provided or is null, only comments/stories without
   * a section (uncategorized) will be returned. In order to return all
   * comments/stories regardless of section, specify null or undefined for this
   * filter option.
   */
  name?: string;
}

/**
 * StoriesConnection represents a subset of a stories list.
 */
export interface GQLStoriesConnection {
  
  /**
   * edges are a subset of StoryEdge's.
   */
  edges: Array<GQLStoryEdge>;
  
  /**
   * nodes is a list of Story's.
   */
  nodes: Array<GQLStory>;
  
  /**
   * pageInfo is information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * StoryEdge represents a unique Story in a StoriesConnection.
 */
export interface GQLStoryEdge {
  
  /**
   * node is the Story for this edge.
   */
  node: GQLStory;
  
  /**
   * cursor is used in pagination.
   */
  cursor: GQLCursor;
}

export enum GQLUSER_STATUS_FILTER {
  
  /**
   * ACTIVE is used when a User is not suspended or banned.
   */
  ACTIVE = 'ACTIVE',
  
  /**
   * BANNED is used when a User is banned.
   */
  BANNED = 'BANNED',
  
  /**
   * SUSPENDED is used when a User is currently suspended.
   */
  SUSPENDED = 'SUSPENDED',
  
  /**
   * PREMOD is used when a User is currently set to require pre-moderation.
   */
  PREMOD = 'PREMOD',
  
  /**
   * WARNED is used when a user has been warned about behaviour and has not acknowledged
   */
  WARNED = 'WARNED',
  
  /**
   * SITE_BANNED is used when a User is site banned.
   */
  SITE_BANNED = 'SITE_BANNED'
}

/**
 * UsersConnection represents a subset of a stories list.
 */
export interface GQLUsersConnection {
  
  /**
   * edges are a subset of UserEdge's.
   */
  edges: Array<GQLUserEdge>;
  
  /**
   * nodes is a list of User's.
   */
  nodes: Array<GQLUser>;
  
  /**
   * pageInfo is information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * UserEdge represents a unique User in a UsersConnection.
 */
export interface GQLUserEdge {
  
  /**
   * node is the User for this edge.
   */
  node: GQLUser;
  
  /**
   * cursor is used in pagination.
   */
  cursor: GQLCursor;
}

/**
 * UsersConnection represents a subset of a stories list.
 */
export interface GQLSitesConnection {
  
  /**
   * edges are a subset of SiteEdge's.
   */
  edges: Array<GQLSiteEdge>;
  
  /**
   * nodes is a list of Site's.
   */
  nodes: Array<GQLSite>;
  
  /**
   * pageInfo is information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * SiteEdge represents a unique Site in a SitesConnection.
 */
export interface GQLSiteEdge {
  
  /**
   * node is the Site for this edge.
   */
  node: GQLSite;
  
  /**
   * cursor is used in pagination.
   */
  cursor: GQLCursor;
}

/**
 * Settings stores the global settings for a given Tenant.
 */
export interface GQLSettings {
  
  /**
   * id is a canonical identifier for this Tenant.
   */
  id: string;
  
  /**
   * domain is the domain that is associated with this Tenant.
   */
  domain: string;
  
  /**
   * webhooks store the webhook configuration.
   */
  webhooks: GQLWebhookConfiguration;
  
  /**
   * webhookEvents returns all the events that can trigger webhooks.
   */
  webhookEvents: Array<GQLWEBHOOK_EVENT_NAME>;
  
  /**
   * staticURI if configured, is the static URI used to serve static files from.
   */
  staticURI?: string;
  
  /**
   * locale is the specified locale for this Tenant.
   */
  locale: GQLLocale;
  
  /**
   * live provides configuration options related to live updates for stories on
   * this site.
   */
  live: GQLLiveConfiguration;
  
  /**
   * moderation is the moderation mode for all Stories on the site.
   */
  moderation?: GQLMODERATION_MODE;
  
  /**
   * communityGuidelines will be shown in the comments stream.
   */
  communityGuidelines: GQLCommunityGuidelines;
  
  /**
   * premodLinksEnable will put all comments that contain links into premod.
   */
  premodLinksEnable?: boolean;
  
  /**
   * closeCommenting contains settings related to the automatic closing of commenting on
   * Stories.
   */
  closeCommenting: GQLCloseCommenting;
  
  /**
   * customCSSURL is the URL of the custom CSS used to display on the frontend.
   */
  customCSSURL?: string;
  
  /**
   * disableCommenting will disable commenting site-wide.
   */
  disableCommenting: GQLDisableCommenting;
  
  /**
   * editCommentWindowLength is the length of time (in seconds) after a comment is
   * posted that it can still be edited by the author.
   */
  editCommentWindowLength: number;
  
  /**
   * charCount stores the character count moderation settings.
   */
  charCount: GQLCharCount;
  
  /**
   * organization stores information about the organization behind this specific
   * instance of Coral.
   */
  organization: GQLOrganization;
  
  /**
   * email is the set of credentials and settings associated with the organization.
   */
  email: GQLEmailConfiguration;
  
  /**
   * slack is the configuration for slack communication
   */
  slack: GQLSlackConfiguration;
  
  /**
   * wordList will return a given list of words.
   */
  wordList: GQLWordList;
  
  /**
   * auth contains all the settings related to authentication and authorization.
   */
  auth: GQLAuth;
  
  /**
   * integrations contains all the external integrations that can be enabled.
   */
  integrations: GQLExternalIntegrations;
  
  /**
   * recentCommentHistory is the set of settings related to how automatic
   * pre-moderation is controlled.
   */
  recentCommentHistory: GQLRecentCommentHistoryConfiguration;
  
  /**
   * reaction specifies the configuration for reactions.
   */
  reaction: GQLReactionConfiguration;
  
  /**
   * staff specifies the configuration for the staff badges assigned to users with
   * any role above COMMENTER.
   */
  staff: GQLStaffConfiguration;
  
  /**
   * accountFeatures stores the configuration for commenter account features.
   */
  accountFeatures: GQLCommenterAccountFeatures;
  
  /**
   * stories stores the configuration around stories.
   */
  stories: GQLStoryConfiguration;
  
  /**
   * media is the configuration media content attached to Comment's.
   */
  media: GQLMediaConfiguration;
  
  /**
   * featureFlags provides the enabled feature flags.
   */
  featureFlags: Array<GQLFEATURE_FLAG>;
  
  /**
   * createdAt is the time that the Settings was created at.
   */
  createdAt: GQLTime;
  
  /**
   * newCommenters is the configuration for how new commenters comments are treated.
   */
  newCommenters: GQLNewCommentersConfiguration;
  
  /**
   * premoderateSuspectWords when enabled will cause any comments that contain
   * suspect words to be sent to pre-moderation to be reviewed by a moderator prior
   * to being presented in stream.
   */
  premoderateSuspectWords: boolean;
  
  /**
   * announcement is the currently active Announcement.
   */
  announcement?: GQLAnnouncement;
  
  /**
   * multisite is whether multiple sites exist for this tenant.
   */
  multisite: boolean;
  
  /**
   * rte is the configuration of the Rich-Text-Editor.
   */
  rte: GQLRTEConfiguration;
  
  /**
   * memberBios is whether members can define a bio for their account.
   */
  memberBios: boolean;
}

export interface GQLWebhookConfiguration {
  
  /**
   * endpoints is all the configured endpoints that should receive events.
   */
  endpoints: Array<GQLWebhookEndpoint>;
}

export interface GQLWebhookEndpoint {
  
  /**
   * id is the unique identifier for this specific endpoint.
   */
  id: string;
  
  /**
   * enabled when true will enable events to be sent to this endpoint.
   */
  enabled: boolean;
  
  /**
   * url is the URL that we will POST event data to.
   */
  url: string;
  
  /**
   * signingSecret is the current secret used to sign the events sent out.
   */
  signingSecret: GQLSigningSecret;
  
  /**
   * deliveries store the deliveries for each event sent for the last 50 events.
   */
  deliveries: Array<GQLWebhookDelivery>;
  
  /**
   * all is true when all events are subscribed to.
   */
  all: boolean;
  
  /**
   * events are the specific event names that this endpoint is configured to send
   * for.
   */
  events: Array<GQLWEBHOOK_EVENT_NAME>;
}

export interface GQLSigningSecret {
  
  /**
   * kid is the identifier for the key used when verifying tokens issued by the
   * provider.
   */
  kid: string;
  
  /**
   * secret is the actual underlying secret used to verify the tokens with.
   */
  secret: string;
  
  /**
   * createdAt is the date that the key was created at.
   */
  createdAt: GQLTime;
  
  /**
   * lastUsedAt is the time that the
   */
  lastUsedAt?: GQLTime;
  
  /**
   * rotatedAt is the time that the token was rotated out.
   */
  rotatedAt?: GQLTime;
  
  /**
   * inactiveAt is the date that the token can no longer be used to validate
   * tokens.
   */
  inactiveAt?: GQLTime;
}

export interface GQLWebhookDelivery {
  success: boolean;
  status: number;
  statusText: string;
  request: string;
  response: string;
  createdAt: GQLTime;
}

export enum GQLWEBHOOK_EVENT_NAME {
  STORY_CREATED = 'STORY_CREATED'
}

/**
 * Locale represents a language code in the BCP 47 format.
 */
export type GQLLocale = any;

export interface GQLCommunityGuidelines {
  
  /**
   * enable set to true will show the guidelines above the message box.
   */
  enabled: boolean;
  
  /**
   * content of the guidelines.
   */
  content?: string;
}

/**
 * CloseCommenting contains settings related to the automatic closing of commenting
 * on Stories.
 */
export interface GQLCloseCommenting {
  
  /**
   * auto when true will configure the automatic close on each story as they are
   * created based on the current configured timeout option.
   */
  auto: boolean;
  
  /**
   * timeout is the amount of seconds from the `createdAt` timestamp that a given
   * story will be considered closed.
   */
  timeout: number;
  
  /**
   * message when provided will be the message that shows when the comment stream
   * is closed for commenting.
   */
  message: string;
}

export interface GQLDisableCommenting {
  
  /**
   * enabled when true will disable commenting site-wide.
   */
  enabled: boolean;
  
  /**
   * message will be shown above the comment stream while
   * commenting is disabled site-wide.
   */
  message: string;
}

export interface GQLCharCount {
  
  /**
   * enabled when true, enables the character count moderation phase.
   */
  enabled: boolean;
  
  /**
   * min is the smallest length of a Comment that may be posted.
   */
  min?: number;
  
  /**
   * max is the largest length of a Comment that may be posted.
   */
  max?: number;
}

/**
 * Organization stores information about the organization behind this specific
 * instance of Coral.
 */
export interface GQLOrganization {
  
  /**
   * name is the name of the organization.
   */
  name: string;
  
  /**
   * contactEmail is the email of the organization.
   */
  contactEmail: string;
  
  /**
   * url is the URL to the organizations home page.
   */
  url: string;
}

export interface GQLEmailConfiguration {
  
  /**
   * enabled when true, will enable the emailing functionality in Coral.
   */
  enabled: boolean;
  fromName?: string;
  fromEmail?: string;
  smtp: GQLSMTP;
}

export interface GQLSMTP {
  secure?: boolean;
  host?: string;
  port?: number;
  authentication?: boolean;
  username?: string;
  password?: string;
}

export interface GQLSlackConfiguration {
  
  /**
   * channels is the set of Slack channels configured to receive comments
   */
  channels: Array<GQLSlackChannel>;
}

export interface GQLSlackChannel {
  
  /**
   * enabled is whether this Slack channel is enabled to send comments to its
   * correlated web hook
   */
  enabled: boolean;
  
  /**
   * name is the name assigned to the Slack channel
   */
  name?: string;
  
  /**
   * hookURL defines the URL that comments will be sent to
   */
  hookURL?: string;
  
  /**
   * triggers are the filters of types of comments that will be sent to
   * the correlated channel
   */
  triggers: GQLSlackChannelTriggers;
}

export interface GQLSlackChannelTriggers {
  
  /**
   * reportedComments is whether this channel will receive reported comments
   */
  reportedComments?: boolean;
  
  /**
   * pendingComments is whether this channel will receive pending comments
   */
  pendingComments?: boolean;
  
  /**
   * featuredComments is whether this channel will receive featured comments
   */
  featuredComments?: boolean;
  
  /**
   * allComents is whether the channel will receive all comments
   */
  allComments?: boolean;
  
  /**
   * staffComments is whether the channel will receive staff comments
   */
  staffComments?: boolean;
}

/**
 * WordList describes all the available wordLists.
 */
export interface GQLWordList {
  
  /**
   * banned words will by default reject the comment if it is found.
   */
  banned: Array<string>;
  
  /**
   * suspect words will simply flag the comment.
   */
  suspect: Array<string>;
}

/**
 * Auth contains all the settings related to authentication and
 * authorization.
 */
export interface GQLAuth {
  
  /**
   * integrations are the set of configurations for the variations of
   * authentication solutions.
   */
  integrations: GQLAuthIntegrations;
  
  /**
   * sessionDuration determines the duration in seconds for which an access token is valid
   */
  sessionDuration: number;
}

export interface GQLAuthIntegrations {
  
  /**
   * local stores configuration related to email/password based logins.
   */
  local: GQLLocalAuthIntegration;
  
  /**
   * sso stores configuration related to Single Sign On based logins.
   */
  sso: GQLSSOAuthIntegration;
  
  /**
   * oidc stores configuration related to OpenID Connect based logins.
   */
  oidc: GQLOIDCAuthIntegration;
  
  /**
   * google stores configuration related to Google based logins.
   */
  google: GQLGoogleAuthIntegration;
  
  /**
   * facebook stores configuration related to Facebook based logins.
   */
  facebook: GQLFacebookAuthIntegration;
}

export interface GQLLocalAuthIntegration {
  enabled: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter: GQLAuthenticationTargetFilter;
}

/**
 * AuthenticationTargetFilter when non-null, will specify the targets that a
 * specific authentication integration will be enabled on.
 */
export interface GQLAuthenticationTargetFilter {
  admin: boolean;
  stream: boolean;
}

/**
 * SSOAuthIntegration is an AuthIntegration that provides a secret to the admins
 * of a tenant, where they can sign a SSO payload with it to provide to the
 * embed to allow single sign on.
 */
export interface GQLSSOAuthIntegration {
  enabled: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter: GQLAuthenticationTargetFilter;
  
  /**
   * signingSecrets are the different SigningSecret's used by this Tenant.
   */
  signingSecrets: Array<GQLSigningSecret>;
  
  /**
   * key is the secret that is used to sign tokens.
   * @deprecated field is deprecated in favour of `signingSecrets`
   */
  key?: string;
  
  /**
   * keyGeneratedAt is the Time that the key was effective from.
   * @deprecated field is deprecated in favour of `signingSecrets`
   */
  keyGeneratedAt?: GQLTime;
}

/**
 * OIDCAuthIntegration provides a way to store Open ID Connect credentials. This
 * will be used in the admin to provide staff logins for users.
 */
export interface GQLOIDCAuthIntegration {
  
  /**
   * enabled, when true, allows the integration to be enabled.
   */
  enabled: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter: GQLAuthenticationTargetFilter;
  
  /**
   * name is the label assigned to reference the provider of the OIDC integration,
   * and will be used in situations where the name of the provider needs to be
   * displayed, like the login button.
   */
  name?: string;
  
  /**
   * callbackURL is the URL that the user should be redirected to in order to continue
   * the authentication flow with the given integration. This field is not stored,
   * and is instead computed from the Tenant.
   */
  callbackURL: string;
  
  /**
   * redirectURL is the URL that the user should be redirected to in order to start
   * an authentication flow with the given integration. This field is not stored,
   * and is instead computed from the Tenant.
   */
  redirectURL?: string;
  
  /**
   * clientID is the Client Identifier as defined in:
   * 
   * https://tools.ietf.org/html/rfc6749#section-2.2
   */
  clientID?: string;
  
  /**
   * clientSecret is the Client Secret as defined in:
   * 
   * https://tools.ietf.org/html/rfc6749#section-2.3.1
   */
  clientSecret?: string;
  
  /**
   * authorizationURL is defined as the `authorization_endpoint` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  authorizationURL?: string;
  
  /**
   * tokenURL is defined as the `token_endpoint` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  tokenURL?: string;
  
  /**
   * jwksURI is defined as the `jwks_uri` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  jwksURI?: string;
  
  /**
   * issuer is defined as the `issuer` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  issuer?: string;
}

export interface GQLGoogleAuthIntegration {
  
  /**
   * enabled, when true, will enable Google as an authentication integration.
   */
  enabled: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter: GQLAuthenticationTargetFilter;
  
  /**
   * clientID is the Client Identifier as provided by the Google API Console.
   */
  clientID?: string;
  
  /**
   * clientSecret is the Client Secret as provided by the Google API Console.
   */
  clientSecret?: string;
  
  /**
   * callbackURL is the URL that the user should be redirected to in order to continue
   * the authentication flow. This field is not stored, and is instead computed from
   * the Tenant.
   */
  callbackURL: string;
  
  /**
   * redirectURL is the URL that the user should be redirected to in order to start
   * an authentication flow with the given integration. This field is not stored,
   * and is instead computed from the Tenant.
   */
  redirectURL: string;
}

export interface GQLFacebookAuthIntegration {
  
  /**
   * enabled, when true, will enable Facebook as an authentication integration.
   */
  enabled: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter: GQLAuthenticationTargetFilter;
  
  /**
   * clientID is the Client Identifier as provided by the Facebook Developer
   * Console.
   */
  clientID?: string;
  
  /**
   * clientSecret is the Client Secret as provided by the Facebook Developer
   * Console.
   */
  clientSecret?: string;
  
  /**
   * callbackURL is the URL that the user should be redirected to in order to continue
   * the authentication flow. This field is not stored, and is instead computed from
   * the Tenant.
   */
  callbackURL: string;
  
  /**
   * redirectURL is the URL that the user should be redirected to in order to start
   * an authentication flow with the given integration. This field is not stored,
   * and is instead computed from the Tenant.
   */
  redirectURL: string;
}

export interface GQLExternalIntegrations {
  
  /**
   * akismet provides integration with the Akismet Spam detection service.
   */
  akismet: GQLAkismetExternalIntegration;
  
  /**
   * perspective provides integration with the Perspective API comment analysis
   * platform.
   */
  perspective: GQLPerspectiveExternalIntegration;
  
  /**
   * external provides integration details for external moderation phases that can be
   * used in the moderation pipeline.
   */
  external?: GQLCustomExternalIntegration;
}

export interface GQLAkismetExternalIntegration {
  
  /**
   * enabled when True will enable the integration.
   */
  enabled: boolean;
  
  /**
   * ipBased when True will enable IP-based spam detection.
   */
  ipBased: boolean;
  
  /**
   * The key for the Akismet integration.
   */
  key?: string;
  
  /**
   * The site (blog) for the Akismet integration.
   */
  site?: string;
}

export interface GQLPerspectiveExternalIntegration {
  
  /**
   * enabled when True will enable the integration.
   */
  enabled: boolean;
  
  /**
   * The endpoint that Coral should use to communicate with the perspective API.
   */
  endpoint?: string;
  
  /**
   * The key for the Perspective API integration.
   */
  key?: string;
  
  /**
   * The threshold that given a specific toxic comment score, the comment will
   * be marked by Coral as toxic.
   */
  threshold?: number;
  
  /**
   * model is the Perspective model to use.
   */
  model?: string;
  
  /**
   * When True, comments sent will not be stored by the Google Perspective API.
   */
  doNotStore?: boolean;
  
  /**
   * When True, comment moderation decisions will be sent to the Google
   * Perspective API to help improve the comment analysis algorithms.
   */
  sendFeedback?: boolean;
}

export interface GQLCustomExternalIntegration {
  
  /**
   * phases is all the external moderation phases for this Tenant.
   */
  phases: Array<GQLExternalModerationPhase>;
}

/**
 * ExternalModerationPhase describes a phase use in the moderation pipeline that
 * calls out to an external resource as defined by the provided URL.
 */
export interface GQLExternalModerationPhase {
  
  /**
   * id identifies this particular External Moderation Phase.
   */
  id: string;
  
  /**
   * name is the name assigned to this ExternalModerationPhase for identification
   * purposes.
   */
  name: string;
  
  /**
   * enabled when true, will use this phase in the moderation pipeline.
   */
  enabled: boolean;
  
  /**
   * url is the actual URL that should be called.
   */
  url: string;
  
  /**
   * format is the format of the comment body sent.
   */
  format: GQLCOMMENT_BODY_FORMAT;
  
  /**
   * timeout is the number of milliseconds that this moderation is maximum expected
   * to take before it is skipped.
   */
  timeout: number;
  
  /**
   * signingSecret is the secret used to sign outgoing requests to the url during
   * the moderation pipeline.
   */
  signingSecret: GQLSigningSecret;
}

/**
 * COMMENT_BODY_FORMAT describes the various formats that a comment body can be
 * provided in.
 */
export enum GQLCOMMENT_BODY_FORMAT {
  
  /**
   * HTML describes the format of the comment body using HTML.
   */
  HTML = 'HTML',
  
  /**
   * PLAIN_TEXT describes the format of the comment body with the HTML stripped.
   */
  PLAIN_TEXT = 'PLAIN_TEXT'
}

/**
 * RecentCommentHistoryConfiguration controls the beheviour around when comments
 * from Users should be marked for pre-moderation automatically once they have
 * reached the trigger rate for rejected comments.
 */
export interface GQLRecentCommentHistoryConfiguration {
  
  /**
   * enabled when true will pre-moderate users new comments once they have reached
   * the trigger rejection rate.
   */
  enabled: boolean;
  
  /**
   * timeFrame specifies the number of seconds that comments from a given User will
   * be taken into account when computing their rejection rate.
   */
  timeFrame: number;
  
  /**
   * triggerRejectionRate specifies the percentage of comments that a given User
   * may have before their comments will then be placed into pre-moderation until
   * the rejection rate decreases.
   */
  triggerRejectionRate: number;
}

/**
 * ReactionConfiguration stores the configuration for reactions used across this
 * Tenant.
 */
export interface GQLReactionConfiguration {
  
  /**
   * icon is the string representing the icon to be used for the reactions.
   */
  icon: string;
  
  /**
   * iconActive is the string representing the icon that should be used when the
   * icon should be considered active.
   */
  iconActive?: string;
  
  /**
   * label is the string placed beside the reaction icon to provide better context.
   */
  label: string;
  
  /**
   * labelActive is the string placed beside the reaction icon to provide better
   * context when it has been selected.
   */
  labelActive: string;
  
  /**
   * sortLabel is the string placed inside of the sort menu to sort for comment
   * with most reactions.
   */
  sortLabel: string;
  
  /**
   * color is the hex color code that can be used to change the color of the button.
   */
  color?: string;
}

/**
 * StaffConfiguration specifies the configuration for the staff badges assigned to
 * users with any role above COMMENTER.
 */
export interface GQLStaffConfiguration {
  
  /**
   * label is the string used when displaying the STAFF badge to users.
   * @deprecated deprecated in favour of staffLabel
   */
  label: string;
  
  /**
   * staffLabel is the string used when displaying the STAFF badge to users.
   */
  staffLabel: string;
  
  /**
   * moderatorLabel is the string used when displaying the MODERATOR badge to users.
   */
  moderatorLabel: string;
  
  /**
   * adminLabel is the string used when displaying the ADMIN badge to users
   */
  adminLabel: string;
}

/**
 * CommenterAccountFeatures stores the configuration for commenter account features.
 */
export interface GQLCommenterAccountFeatures {
  
  /**
   * changeUsername when true, non-sso user may change username every 14 days
   */
  changeUsername: boolean;
  
  /**
   * downloadComments when true, user may download their comment history
   */
  downloadComments: boolean;
  
  /**
   * deleteAccount when true, non-sso user may permanently delete their account
   */
  deleteAccount: boolean;
}

/**
 * StoryConfiguration stores the configuration for working with stories.
 */
export interface GQLStoryConfiguration {
  
  /**
   * scraping stores configuration around story scraping.
   */
  scraping: GQLStoryScrapingConfiguration;
  
  /**
   * disableLazy when true, will only allow lookups of stories created via the API.
   */
  disableLazy: boolean;
}

/**
 * StoryScrapingConfiguration stores the configuration around story scraping.
 */
export interface GQLStoryScrapingConfiguration {
  
  /**
   * enabled, when true, enables stories to be scraped. When disabled, stories will
   * only be looked up instead, and must be created via the API directly.
   */
  enabled: boolean;
  
  /**
   * proxyURL when specified, allows scraping requests to use the provided proxy.
   * All requests will then be passed through the appropriote proxy as parsed by
   * the [proxy-agent](https://www.npmjs.com/package/proxy-agent) package.
   */
  proxyURL?: string;
  
  /**
   * customUserAgent when specified will override the user agent used by fetch
   * requests made during the scraping process.
   */
  customUserAgent?: string;
  
  /**
   * authentication is whether alternative authentication credentials have been
   * provided for scraping activities.
   */
  authentication: boolean;
  
  /**
   * username is the username to use with basic authentication for scraping jobs.
   */
  username?: string;
  
  /**
   * password is the password to use with basic authentication for scraping jobs.
   */
  password?: string;
}

export interface GQLMediaConfiguration {
  
  /**
   * twitter is the configuration for Twitter support.
   */
  twitter: GQLTwitterMediaConfiguration;
  
  /**
   * youtube is the configuration for YouTube support.
   */
  youtube: GQLYouTubeMediaConfiguration;
  
  /**
   * giphy is the configuration for Giphy support.
   */
  giphy: GQLGiphyMediaConfiguration;
  
  /**
   * external is the configuration for external images.
   */
  external: GQLExternalMediaConfiguration;
}

export interface GQLTwitterMediaConfiguration {
  
  /**
   * enabled is true when twitter media objects are enabled.
   */
  enabled: boolean;
}

export interface GQLYouTubeMediaConfiguration {
  
  /**
   * enabled is true when youtube media objects are enabled.
   */
  enabled: boolean;
}

export interface GQLGiphyMediaConfiguration {
  
  /**
   * enabled is true when gif search via giphy and giphy media objects are enabled.
   */
  enabled: boolean;
  
  /**
   * maximum allowed rating for gifs, g, pg, pg-13, r.
   */
  maxRating?: string;
  
  /**
   * key is the API key for Giphy.
   */
  key?: string;
}

export interface GQLExternalMediaConfiguration {
  
  /**
   * enabled is true when external media objects are enabled.
   */
  enabled: boolean;
}

export enum GQLFEATURE_FLAG {
  
  /**
   * SECTIONS when enabled will allow filtering comments in the moderation queue
   * by section.
   */
  SECTIONS = 'SECTIONS',
  
  /**
   * DISABLE_WARN_USER_OF_TOXIC_COMMENT when enabled will turn off warnings for
   * toxic comments.
   */
  DISABLE_WARN_USER_OF_TOXIC_COMMENT = 'DISABLE_WARN_USER_OF_TOXIC_COMMENT',
  
  /**
   * ENABLE_QA when enabled will turn off Q&A features client side.
   */
  ENABLE_QA = 'ENABLE_QA',
  
  /**
   * DEFAULT_QA_STORY_MODE will set the story mode to QA by default.
   */
  DEFAULT_QA_STORY_MODE = 'DEFAULT_QA_STORY_MODE',
  
  /**
   * SITE_MODERATOR will enable the enhanced Site Moderator role by assigning a new
   * modeartion scope to a user.
   */
  SITE_MODERATOR = 'SITE_MODERATOR',
  
  /**
   * REDUCED_SECURITY_MODE when true will allow unpersisted queries to be executed
   * in production environments.
   */
  REDUCED_SECURITY_MODE = 'REDUCED_SECURITY_MODE',
  
  /**
   * DISCUSSIONS will enable the discussions tab for the comment stream.
   */
  DISCUSSIONS = 'DISCUSSIONS',
  
  /**
   * READ_MORE_NEW_TAB will enable opening a new tab when a user clicks on
   * "read more of this conversation" in the comment stream.
   */
  READ_MORE_NEW_TAB = 'READ_MORE_NEW_TAB',
  
  /**
   * AVATARS will enable pulling an avatar URL from sso token and displaying it
   * next to user comments
   */
  AVATARS = 'AVATARS',
  
  /**
   * NEW_COMMENT_COUNT enables the comment count update feature.
   */
  NEW_COMMENT_COUNT = 'NEW_COMMENT_COUNT',
  
  /**
   * EXTERNAL_MEDIA enables embedding external images
   */
  EXTERNAL_MEDIA = 'EXTERNAL_MEDIA',
  
  /**
   * RTE_SARCASM enables sarcasm RTE feature
   */
  RTE_SARCASM = 'RTE_SARCASM',
  
  /**
   * VIEWER_COUNT when true will enable the display and tracking of the viewer
   * count.
   */
  VIEWER_COUNT = 'VIEWER_COUNT',
  
  /**
   * ALTERNATE_OLDEST_FIRST_VIEW when enabled will move the create comment form to
   * the bottom of the stream when sorting the comment stream by oldest first.
   */
  ALTERNATE_OLDEST_FIRST_VIEW = 'ALTERNATE_OLDEST_FIRST_VIEW',
  
  /**
   * ENABLE_RATINGS_AND_REVIEWS when enabled will allow for the ratings and reviews
   * functionality to be enabled.
   */
  ENABLE_RATINGS_AND_REVIEWS = 'ENABLE_RATINGS_AND_REVIEWS',
  
  /**
   * FLATTEN_REPLIES when enabled, will cause all replies that would normally be
   * hidden by a "Show more of this conversation" button to be displayed linearly
   * sorted by date.
   */
  FLATTEN_REPLIES = 'FLATTEN_REPLIES',
  
  /**
   * ENABLE_AMP will enable support for embedding Coral within AMP pages.
   */
  ENABLE_AMP = 'ENABLE_AMP',
  
  /**
   * DISABLE_LIVE_UPDATES will disable live updates at the tenant level and
   * overrides the configuration option available in the Admin UI for that tenant.
   */
  DISABLE_LIVE_UPDATES = 'DISABLE_LIVE_UPDATES',
  
  /**
   * EMAIL_META will add the email template context as a header to the SMTP as the
   * `X-Coral-Template` header.
   */
  EMAIL_META = 'EMAIL_META',
  
  /**
   * COMMENT_SEEN will mark comment that has been seen/unseen.
   */
  COMMENT_SEEN = 'COMMENT_SEEN',
  
  /**
   * FOR_REVIEW will add a "For Review" Queue that allows moderators to review every flag
   * that has been put on a comment by a user. This feature shall help complying with European Law
   * (European Directive 2000/31/CE).
   */
  FOR_REVIEW = 'FOR_REVIEW'
}

/**
 * NewCommenterConfiguration specifies the features that apply to new commenters
 */
export interface GQLNewCommentersConfiguration {
  
  /**
   * premodEnabled ensures that new commenters' comments are pre-moderated until they have
   * enough approved comments
   */
  premodEnabled: boolean;
  
  /**
   * approvedCommentsThreshold is the number of comments a user must have approved before their
   * comments do not require premoderation
   */
  approvedCommentsThreshold: number;
}

/**
 * Announcement is an organization-wide announcement displayed above the stream
 * for a set duration
 */
export interface GQLAnnouncement {
  
  /**
   * id is a canonical identifier for this Annoucnement, used to dismiss on front-end.
   */
  id: string;
  
  /**
   * content is the content displayed for the announcement.
   */
  content: string;
  
  /**
   * createdAt is the creation date.
   */
  createdAt: GQLTime;
  
  /**
   * disableAt is the computed date at which announcement will be invalid.
   */
  disableAt: GQLTime;
  
  /**
   * duration determines how long the announcement will be valid for.
   */
  duration: number;
}

export interface GQLRTEConfiguration {
  
  /**
   * enabled when true turns on basic RTE features including
   * bold, italic, quote, and bullet list.
   */
  enabled: boolean;
  
  /**
   * strikethrough when true turns on the strikethrough feature.
   */
  strikethrough: boolean;
  
  /**
   * spoiler when true turns on the spoiler feature.
   */
  spoiler: boolean;
  
  /**
   * sarcasm when true turns on the sarcasm feature.
   */
  sarcasm: boolean;
}

/**
 * DiscoveredOIDCConfiguration contains the discovered Provider Metadata as defined
 * in:
 * 
 * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
 * 
 * Discovery is not supported on all providers, and is described in the OpenID
 * Connect Discovery 1.0 incorporating errata set 1:
 * 
 * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfig
 */
export interface GQLDiscoveredOIDCConfiguration {
  
  /**
   * issuer is defined as the `issuer` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  issuer: string;
  
  /**
   * authorizationURL is defined as the `authorization_endpoint` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  authorizationURL: string;
  
  /**
   * tokenURL is defined as the `token_endpoint` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  tokenURL?: string;
  
  /**
   * jwksURI is defined as the `jwks_uri` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  jwksURI: string;
}

export interface GQLQueues {
  
  /**
   * mailer is the Queue associated with the Mailer queue.
   */
  mailer: GQLQueue;
  
  /**
   * scraper is the Queue associated with the Scraper queue.
   */
  scraper: GQLQueue;
  
  /**
   * notifier is the Queue associated with the Notifier queue.
   */
  notifier: GQLQueue;
  
  /**
   * webhook is the Queue associated with the Webhook queue.
   */
  webhook: GQLQueue;
  
  /**
   * rejector is the Queue associated with the Rejector queue.
   */
  rejector: GQLQueue;
}

export interface GQLQueue {
  
  /**
   * counts is the current counts associated with the Queue.
   */
  counts: GQLQueueCounts;
}

export interface GQLQueueCounts {
  
  /**
   * waiting is the number of jobs that are in line to be processed.
   */
  waiting: number;
  
  /**
   * active is the number of jobs that are being activly processed.
   */
  active: number;
  
  /**
   * delayed is the number of jobs that have been delayed due to a failure and are
   * waiting for a backoff.
   */
  delayed: number;
}

export interface GQLMutation {
  
  /**
   * createComment will create a Comment as the current logged in User.
   */
  createComment: GQLCreateCommentPayload;
  
  /**
   * createCommentReply will create a Comment as the current logged in User that is
   * in reply to another Comment.
   */
  createCommentReply: GQLCreateCommentReplyPayload;
  
  /**
   * editComment will allow the author of a comment to change the body within the
   * time allotment.
   */
  editComment: GQLEditCommentPayload;
  
  /**
   * updateSettings will update the Settings for the given Tenant.
   */
  updateSettings: GQLUpdateSettingsPayload;
  
  /**
   * rotateSSOSigningSecret can be used to rotate a given active SigningSecret.
   */
  rotateSSOSigningSecret: GQLRotateSSOSigningSecretPayload;
  
  /**
   * deactivateSSOSigningSecret will deactivate a given deactivated SigningSecret.
   */
  deactivateSSOSigningSecret: GQLDeactivateSSOSigningSecretPayload;
  
  /**
   * deleteSSOSigningSecret will delete a given inactive SigningSecret.
   */
  deleteSSOSigningSecret: GQLDeleteSSOSigningSecretPayload;
  
  /**
   * createCommentReaction will create a Reaction authored by the current logged in
   * User on a Comment.
   */
  createCommentReaction?: GQLCreateCommentReactionPayload;
  
  /**
   * removeCommentReaction will remove a Reaction authored by the current logged in
   * User on a Comment if it exists.
   */
  removeCommentReaction?: GQLRemoveCommentReactionPayload;
  
  /**
   * createCommentDontAgree will create a DontAgree authored by the current logged in
   * User on a Comment.
   */
  createCommentDontAgree?: GQLCreateCommentDontAgreePayload;
  
  /**
   * removeCommentDontAgree will remove a DontAgree authored by the current logged in
   * User on a Comment if it exists.
   */
  removeCommentDontAgree?: GQLRemoveCommentDontAgreePayload;
  
  /**
   * createCommentFlag will create a Flag authored by the current logged in User on
   * a given Comment.
   */
  createCommentFlag: GQLCreateCommentFlagPayload;
  
  /**
   * featureComment will mark a given Comment as featured.
   */
  featureComment: GQLFeatureCommentPayload;
  
  /**
   * unfeatureComment will remove the featured tag from a Comment that is featured.
   */
  unfeatureComment: GQLUnfeatureCommentPayload;
  
  /**
   * createStory will create the provided Story.
   */
  createStory: GQLCreateStoryPayload;
  
  /**
   * updateStory will update the given Story.
   */
  updateStory: GQLUpdateStoryPayload;
  
  /**
   * updateStory will update the given Story's settings.
   */
  updateStorySettings: GQLUpdateStorySettingsPayload;
  
  /**
   * closeStory will close the given story for commenting.
   */
  closeStory: GQLCloseStoryPayload;
  
  /**
   * openStory will open the given story for commenting.
   */
  openStory: GQLOpenStoryPayload;
  
  /**
   * mergeStories will merge two stories together, merging their comment streams.
   * This operation is irreversible.
   */
  mergeStories: GQLMergeStoriesPayload;
  
  /**
   * removeStory will remove the given Story.
   */
  removeStory: GQLRemoveStoryPayload;
  
  /**
   * scrapeStory will scrape the given Story and update the scraped metadata.
   */
  scrapeStory: GQLScrapeStoryPayload;
  
  /**
   * approveComment will mark the Comment as APPROVED.
   */
  approveComment: GQLApproveCommentPayload;
  
  /**
   * rejectComment will mark the Comment as REJECTED.
   */
  rejectComment: GQLRejectCommentPayload;
  
  /**
   * inviteUsers will send emails to the users with a new account at the designated
   * role.
   */
  inviteUsers: GQLInviteUsersPayload;
  
  /**
   * setUsername will set the username on the current User if they have not set one
   * before. This mutation will fail if the username is already set.
   */
  setUsername: GQLSetUsernamePayload;
  
  /**
   * updateBio will update the users bio.
   */
  updateBio: GQLUpdateBioPayload;
  
  /**
   * updateUsername will update the users username.
   */
  updateUsername: GQLUpdateUsernamePayload;
  
  /**
   * setEmail will set the email address on the current User if they have not set
   * one already. This mutation will fail if the email address is already set.
   */
  setEmail: GQLSetEmailPayload;
  
  /**
   * setPassword will set the password on the current User if they have not set
   * one already. This mutation will fail if the password is already set.
   */
  setPassword: GQLSetPasswordPayload;
  
  /**
   * updatePassword allows the current logged in User to change their password if
   * they already have one associated with them.
   */
  updatePassword: GQLUpdatePasswordPayload;
  
  /**
   * requestAccountDeletion allows the current logged in User to request to
   * delete their account.
   */
  requestAccountDeletion: GQLRequestAccountDeletionPayload;
  
  /**
   * deleteUserAccount will delete the target user now.
   */
  deleteUserAccount: GQLDeleteUserAccountPayload;
  
  /**
   * cancelAccountDeletion allows the current logged in User to cancel the
   * request to delete their account
   */
  cancelAccountDeletion: GQLCancelAccountDeletionPayload;
  
  /**
   * createToken allows an administrator to create a Token based on the current
   * logged in User.
   */
  createToken: GQLCreateTokenPayload;
  
  /**
   * deactivateToken will deactivate the current logged in User's Token based on
   * the input.
   */
  deactivateToken: GQLDeactivateTokenPayload;
  
  /**
   * updateUserUsername allows administrators to update a given User's username to
   * the one provided.
   */
  updateUserUsername: GQLUpdateUserUsernamePayload;
  
  /**
   * updateEmail will update the current users email address.
   */
  updateEmail: GQLUpdateEmailPayload;
  
  /**
   * updateNotificationSettings can be used to update the notification settings for
   * the current logged in user.
   */
  updateNotificationSettings: GQLUpdateNotificationSettingsPayload;
  
  /**
   * updateUserMediaSettings can be used to update the media preferences for the
   * current logged in user.
   */
  updateUserMediaSettings: GQLUpdateUserMediaSettingsPayload;
  
  /**
   * updateUserEmail allows administrators to update a given User's email address
   * to the one provided.
   */
  updateUserEmail: GQLUpdateUserEmailPayload;
  
  /**
   * updateUserAvatar allows administrators to update a given User's avatar to the
   * one provided.
   */
  updateUserAvatar: GQLUpdateUserAvatarPayload;
  
  /**
   * updateUserRole will update a given User's role.
   */
  updateUserRole: GQLUpdateUserRolePayload;
  
  /**
   * promoteUser will allow the viewer to add one or many scopes that applies to
   * the viewer. If the target user was not already a site moderator, their role is
   * set to site moderator.
   */
  promoteUser: GQLPromoteUserPayload;
  
  /**
   * demoteUser will allow the viewer to remove one or many scopes that applies to
   * the viewer and the target user. If the target user does not have any remaining
   * scopes, they are set to commenter.
   */
  demoteUser: GQLDemoteUserPayload;
  
  /**
   * updateUserModerationScopes will update the moderation scopes for a given user.
   * This is used to limit the scopes for which a given moderator can moderate if
   * they also have the moderator role.
   */
  updateUserModerationScopes: GQLUpdateUserModerationScopesPayload;
  
  /**
   * banUser will ban a specific User from interacting with Comments.
   */
  banUser: GQLBanUserPayload;
  
  /**
   * removeUserBan will remove an active ban from a User if they have one.
   */
  removeUserBan: GQLRemoveUserBanPayload;
  
  /**
   * suspendUser will suspend a specific User from interacting with Comments.
   */
  suspendUser: GQLSuspendUserPayload;
  
  /**
   * warnUser will warn a user and prevent them from commenting until they acknowledge
   */
  warnUser: GQLWarnUserPayload;
  
  /**
   * removeUserWarning will remove a user warning
   */
  removeUserWarning: GQLRemoveUserWarningPayload;
  
  /**
   * acknowledgWarning will remove a warning
   */
  acknowledgeWarning?: GQLAcknowledgeWarningPayload;
  
  /**
   * removeUserSuspension will remove an active suspension from a User if they have
   * one.
   */
  removeUserSuspension: GQLRemoveUserSuspensionPayload;
  
  /**
   * ignoreUser will mark the given User as ignored by the current logged in User.
   */
  ignoreUser: GQLIgnoreUserPayload;
  
  /**
   * removeUserIgnore will remove the given User from the ignored user list from
   * the current logged in User.
   */
  removeUserIgnore: GQLRemoveUserIgnorePayload;
  
  /**
   * requestCommentsDownload allows a user to request to download their comments.
   */
  requestCommentsDownload: GQLRequestCommentsDownloadPayload;
  
  /**
   * requestUserCommentsDownload allows a user to request to download their comments.
   */
  requestUserCommentsDownload: GQLRequestUserCommentsDownloadPayload;
  
  /**
   * premodUser sets a user to mandatory premod
   */
  premodUser: GQLPremodUserPayload;
  
  /**
   * removeUserPremod removes a user from mandatory premod
   */
  removeUserPremod: GQLRemovePremodUserPayload;
  
  /**
   * createModeratorNote creates a note on a user account.
   */
  createModeratorNote: GQLCreateModeratorNotePayload;
  
  /**
   * deleteModeratorNote deletes a note on a user account.
   */
  deleteModeratorNote: GQLDeleteModeratorNotePayload;
  
  /**
   * enableFeatureFlag will enable a given FEATURE_FLAG.
   */
  enableFeatureFlag: GQLEnableFeatureFlagPayload;
  
  /**
   * disableFeatureFlag will disable a given FEATURE_FLAG
   */
  disableFeatureFlag: GQLDisableFeatureFlagPayload;
  
  /**
   * createAnnouncement creates a global announcement.
   */
  createAnnouncement: GQLCreateAnnouncementPayload;
  
  /**
   * deleteAnnouncement removes a global announcement.
   */
  deleteAnnouncement: GQLDeleteAnnouncementPayload;
  createSite: GQLCreateSitePayload;
  updateSite: GQLUpdateSitePayload;
  
  /**
   * createWebhookEndpoint will create a new WebhookEndpoint.
   */
  createWebhookEndpoint: GQLCreateWebhookEndpointPayload;
  
  /**
   * updateWebhookEndpoint will update a WebhookEndpoint.
   */
  updateWebhookEndpoint: GQLUpdateWebhookEndpointPayload;
  
  /**
   * enableWebhookEndpoint will enable a WebhookEndpoint to recieve new events.
   */
  enableWebhookEndpoint: GQLEnableWebhookEndpointPayload;
  
  /**
   * disableWebhookEndpoint will disable a WebhookEndpoint from recieving new
   * events.
   */
  disableWebhookEndpoint: GQLDisableWebhookEndpointPayload;
  
  /**
   * deleteWebhookEndpoint will delete a WebhookEndpoint.
   */
  deleteWebhookEndpoint: GQLDeleteWebhookEndpointPayload;
  
  /**
   * rotateWebhookEndpointSigningSecret will roll the current active secret to a new key.
   */
  rotateWebhookEndpointSigningSecret: GQLRotateWebhookEndpointSigningSecretPayload;
  
  /**
   * createExternalModerationPhase will create a new ExternalModerationPhase.
   */
  createExternalModerationPhase: GQLCreateExternalModerationPhasePayload;
  
  /**
   * updateExternalModerationPhase will update a ExternalModerationPhase.
   */
  updateExternalModerationPhase: GQLUpdateExternalModerationPhasePayload;
  
  /**
   * enableExternalModerationPhase will enable a ExternalModerationPhase to recieve
   * new comments.
   */
  enableExternalModerationPhase: GQLEnableExternalModerationPhasePayload;
  
  /**
   * disableExternalModerationPhase will disable a ExternalModerationPhase from
   * recieving new comments.
   */
  disableExternalModerationPhase: GQLDisableExternalModerationPhasePayload;
  
  /**
   * deleteExternalModerationPhase will delete a ExternalModerationPhase.
   */
  deleteExternalModerationPhase: GQLDeleteExternalModerationPhasePayload;
  
  /**
   * rotateExternalModerationPhaseSigningSecret will roll the current active secret
   * to a new key.
   */
  rotateExternalModerationPhaseSigningSecret: GQLRotateExternalModerationPhaseSigningSecretPayload;
  
  /**
   * updateStoryMode will set the story mode.
   */
  updateStoryMode: GQLUpdateStoryModePayload;
  
  /**
   * addStoryExpert adds an expert to a story.
   */
  addStoryExpert: GQLAddStoryExpertPayload;
  
  /**
   * removeStoryExpert removes an expert from a story.
   */
  removeStoryExpert: GQLRemoveStoryExpertPayload;
  
  /**
   * testSMTP sends a test email.
   */
  testSMTP: GQLTestSMTPPayload;
  
  /**
   * reviewCommentFlag marks comment flag as reviewed
   */
  reviewCommentFlag: GQLReviewCommentFlagPayload;
}

/**
 * CreateCommentInput provides the input for the createComment Mutation.
 */
export interface GQLCreateCommentInput {
  
  /**
   * nudge when true will instead return an error related to recoverable moderation
   * faults such as a toxic comment or spam comment to provide user feedback to
   * nudge the user to correct the comment.
   */
  nudge?: boolean;
  
  /**
   * storyID is the ID of the Story where we are creating a comment on.
   */
  storyID: string;
  
  /**
   * body is the Comment body, the content of the Comment.
   */
  body: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * media is the optional media attachment to be added to a Comment.
   */
  media?: GQLCreateCommentMediaInput;
  
  /**
   * rating is the optional rating that can be added to a Comment.
   */
  rating?: number;
}

/**
 * CreateCommentMediaInput is used for creating media to be attached to a Comment.
 */
export interface GQLCreateCommentMediaInput {
  
  /**
   * type specifies the type of media that can be attached. Valid values for this
   * are: `giphy`, `external`, `twitter`, and `youtube`.
   */
  type: string;
  
  /**
   * id refers to a foreign id for the specific media provider.
   */
  id?: string;
  
  /**
   * url is the URL to the media resource.
   */
  url: string;
  
  /**
   * width is the width to the media resource.
   */
  width?: string;
  
  /**
   * height is the height to the media resource.
   */
  height?: string;
}

/**
 * CreateCommentPayload contains the created Comment after the createComment
 * mutation.
 */
export interface GQLCreateCommentPayload {
  
  /**
   * edge is the possibly created comment edge.
   */
  edge: GQLCommentEdge;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * CreateCommentReplyInput provides the input for the createCommentReply Mutation.
 */
export interface GQLCreateCommentReplyInput {
  
  /**
   * nudge when true will instead return an error related to recoverable moderation
   * faults such as a toxic comment or spam comment to provide user feedback to
   * nudge the user to correct the comment.
   */
  nudge?: boolean;
  
  /**
   * storyID is the ID of the Story where we are creating a comment on.
   */
  storyID: string;
  
  /**
   * parentID is the ID of the Comment that we are replying to.
   */
  parentID: string;
  
  /**
   * parentRevisionID is the ID of the CommentRevision that we are replying to.
   */
  parentRevisionID: string;
  
  /**
   * body is the Comment body, the content of the Comment.
   */
  body: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * media is the optional media attachment to be added to a Comment.
   */
  media?: GQLCreateCommentMediaInput;
}

/**
 * CreateCommentReplyPayload contains the created Comment after the createCommentReply
 * mutation.
 */
export interface GQLCreateCommentReplyPayload {
  
  /**
   * edge is the possibly created comment edge.
   */
  edge: GQLCommentEdge;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * EditCommentInput provides the input for the editComment Mutation.
 */
export interface GQLEditCommentInput {
  
  /**
   * commentID is the ID of the comment being edited.
   */
  commentID: string;
  
  /**
   * body is the Comment body, the content of the Comment.
   */
  body: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * media is the optional media attachment to be added to a Comment.
   */
  media?: GQLCreateCommentMediaInput;
}

/**
 * EditCommentPayload contains the edited Comment after the editComment
 * mutation.
 */
export interface GQLEditCommentPayload {
  
  /**
   * comment is the possibly edited comment.
   */
  comment: GQLComment;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * UpdateSettingsInput provides the input for the updateSettings Mutation.
 */
export interface GQLUpdateSettingsInput {
  
  /**
   * settings is the partial set of settings that will be used as a patch against
   * the existing settings object.
   */
  settings: GQLSettingsInput;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * SettingsInput is the partial type of the Settings type for performing mutations.
 */
export interface GQLSettingsInput {
  
  /**
   * live provides configuration options related to live updates for stories on
   * this site.
   */
  live?: GQLLiveConfigurationInput;
  
  /**
   * moderation is the moderation mode for all Stories on the site.
   */
  moderation?: GQLMODERATION_MODE;
  
  /**
   * communityGuidelines will be shown in the comments stream.
   */
  communityGuidelines?: GQLSettingsCommunityGuidelinesInput;
  
  /**
   * premodLinksEnable will put all comments that contain links into premod.
   */
  premodLinksEnable?: boolean;
  
  /**
   * customCSSURL is the URL of the custom CSS used to display on the frontend.
   */
  customCSSURL?: string;
  
  /**
   * disableCommenting will disable commenting site-wide.
   */
  disableCommenting?: GQLSettingsDisableCommentingInput;
  
  /**
   * editCommentWindowLength is the length of time (in seconds) after a comment is
   * posted that it can still be edited by the author.
   */
  editCommentWindowLength?: number;
  
  /**
   * organization stores information about the organization behind this specific
   * instance of Coral.
   */
  organization?: GQLSettingsOrganizationInput;
  
  /**
   * closeCommenting contains settings related to the automatic closing of commenting on
   * Stories.
   */
  closeCommenting?: GQLSettingsCloseCommentingInput;
  
  /**
   * wordList will return a given list of words.
   */
  wordList?: GQLSettingsWordListInput;
  
  /**
   * email is the set of credentials and settings associated with the organization.
   */
  email?: GQLSettingsEmailConfigurationInput;
  
  /**
   * auth contains all the settings related to authentication and authorization.
   */
  auth?: GQLSettingsAuthInput;
  
  /**
   * integrations contains all the external integrations that can be enabled.
   */
  integrations?: GQLSettingsExternalIntegrationsInput;
  
  /**
   * recentCommentHistory is the set of settings related to how automatic
   * pre-moderation is controlled.
   */
  recentCommentHistory?: GQLRecentCommentHistoryConfigurationInput;
  
  /**
   * charCount stores the character count moderation settings.
   */
  charCount?: GQLSettingsCharCountInput;
  
  /**
   * stories stores the configuration around stories.
   */
  stories?: GQLStoryConfigurationInput;
  
  /**
   * reaction specifies the configuration for reactions.
   */
  reaction?: GQLReactionConfigurationInput;
  
  /**
   * staff specifies the configuration for the staff badges assigned to users with
   * any role above COMMENTER.
   */
  staff?: GQLStaffConfigurationInput;
  
  /**
   * accountFeatures specifies the configuration for accounts.
   */
  accountFeatures?: GQLCommenterAccountFeaturesInput;
  
  /**
   * slack specifies the configuration for Slack integration.
   */
  slack?: GQLSlackConfigurationInput;
  
  /**
   * locale specifies the locale for this Tenant.
   */
  locale?: GQLLocale;
  
  /**
   * newCommenters is the configuration for how new commenters comments are treated.
   */
  newCommenters?: GQLNewCommentersConfigurationInput;
  
  /**
   * premoderateSuspectWords when enabled will cause any comments that contain
   * suspect words to be sent to pre-moderation to be reviewed by a moderator prior
   * to being presented in stream.
   */
  premoderateSuspectWords?: boolean;
  
  /**
   * rte is the configuration of the Rich-Text-Editor.
   */
  rte?: GQLRTEConfigurationInput;
  
  /**
   * media is the configuration media content attached to Comment's.
   */
  media?: GQLMediaConfigurationInput;
  
  /**
   * memberBios is whether members can define a bio for their account.
   */
  memberBios?: boolean;
}

/**
 * LiveConfigurationInput provides configuration options related to live updates.
 */
export interface GQLLiveConfigurationInput {
  
  /**
   * enabled when true will allow live updates.
   */
  enabled?: boolean;
}

export interface GQLSettingsCommunityGuidelinesInput {
  
  /**
   * enable set to true will show the guidelines above the message box.
   */
  enabled?: boolean;
  
  /**
   * content of the guidelines.
   */
  content?: string;
}

export interface GQLSettingsDisableCommentingInput {
  
  /**
   * enabled when true will disable commenting site-wide.
   */
  enabled?: boolean;
  
  /**
   * message will be shown above the comment stream while
   * commenting is disabled site-wide.
   */
  message?: string;
}

export interface GQLSettingsOrganizationInput {
  
  /**
   * name is the name of the organization.
   */
  name?: string;
  
  /**
   * contactEmail is the email of the organization.
   */
  contactEmail?: string;
  
  /**
   * url is the URL to the organizations home page.
   */
  url?: string;
}

export interface GQLSettingsCloseCommentingInput {
  
  /**
   * auto when true will configure the automatic close on each story as they are
   * created based on the current configured timeout option.
   */
  auto?: boolean;
  
  /**
   * timeout is the amount of seconds from the `createdAt` timestamp that a given
   * story will be considered closed.
   */
  timeout?: number;
  
  /**
   * message when provided will be the message that shows when the comment stream
   * is closed for commenting.
   */
  message?: string;
}

export interface GQLSettingsWordListInput {
  
  /**
   * banned words will by default reject the comment if it is found.
   */
  banned?: Array<string>;
  
  /**
   * suspect words will simply flag the comment.
   */
  suspect?: Array<string>;
}

export interface GQLSettingsEmailConfigurationInput {
  
  /**
   * enabled when True, will enable the emailing functionality in Coral.
   */
  enabled?: boolean;
  smtp?: GQLSettingsSMTPInput;
  fromName?: string;
  fromEmail?: string;
}

export interface GQLSettingsSMTPInput {
  secure?: boolean;
  host?: string;
  port?: number;
  authentication?: boolean;
  username?: string;
  password?: string;
}

/**
 * Auth contains all the settings related to authentication and
 * authorization.
 */
export interface GQLSettingsAuthInput {
  
  /**
   * integrations are the set of configurations for the variations of
   * authentication solutions.
   */
  integrations?: GQLSettingsAuthIntegrationsInput;
  
  /**
   * sessionDuration determines the duration in seconds for which an access token is valid
   */
  sessionDuration: number;
}

export interface GQLSettingsAuthIntegrationsInput {
  
  /**
   * local stores configuration related to email/password based logins.
   */
  local?: GQLSettingsLocalAuthIntegrationInput;
  
  /**
   * sso stores configuration related to Single Sign On based logins.
   */
  sso?: GQLSettingsSSOAuthIntegrationInput;
  
  /**
   * oidc stores configuration related to OpenID Connect based logins.
   */
  oidc?: GQLSettingsOIDCAuthIntegrationInput;
  
  /**
   * google stores configuration related to Google based logins.
   */
  google?: GQLSettingsGoogleAuthIntegrationInput;
  
  /**
   * facebook stores configuration related to Facebook based logins.
   */
  facebook?: GQLSettingsFacebookAuthIntegrationInput;
}

export interface GQLSettingsLocalAuthIntegrationInput {
  enabled?: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration?: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter?: GQLSettingsAuthenticationTargetFilterInput;
}

export interface GQLSettingsAuthenticationTargetFilterInput {
  admin: boolean;
  stream: boolean;
}

export interface GQLSettingsSSOAuthIntegrationInput {
  enabled?: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration?: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter?: GQLSettingsAuthenticationTargetFilterInput;
}

export interface GQLSettingsOIDCAuthIntegrationInput {
  
  /**
   * enabled, when true, allows the integration to be enabled.
   */
  enabled?: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration?: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter?: GQLSettingsAuthenticationTargetFilterInput;
  
  /**
   * name is the label assigned to reference the provider of the OIDC integration,
   * and will be used in situations where the name of the provider needs to be
   * displayed, like the login button.
   */
  name?: string;
  
  /**
   * clientID is the Client Identifier as defined in:
   * 
   * https://tools.ietf.org/html/rfc6749#section-2.2
   */
  clientID?: string;
  
  /**
   * clientSecret is the Client Secret as defined in:
   * 
   * https://tools.ietf.org/html/rfc6749#section-2.3.1
   */
  clientSecret?: string;
  
  /**
   * authorizationURL is defined as the `authorization_endpoint` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  authorizationURL?: string;
  
  /**
   * tokenURL is defined as the `token_endpoint` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  tokenURL?: string;
  
  /**
   * jwksURI is defined as the `jwks_uri` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  jwksURI?: string;
  
  /**
   * issuer is defined as the `issuer` in:
   * 
   * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
   */
  issuer?: string;
}

export interface GQLSettingsGoogleAuthIntegrationInput {
  
  /**
   * enabled, when true, will enable Google as an authentication integration.
   */
  enabled?: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration?: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter?: GQLSettingsAuthenticationTargetFilterInput;
  
  /**
   * clientID is the Client Identifier as provided by the Google API Console.
   */
  clientID?: string;
  
  /**
   * clientSecret is the Client Secret as provided by the Google API Console.
   */
  clientSecret?: string;
}

export interface GQLSettingsFacebookAuthIntegrationInput {
  
  /**
   * enabled, when true, will enable Facebook as an authentication integration.
   */
  enabled?: boolean;
  
  /**
   * allowRegistration when true will allow users that have not signed up
   * before with this authentication integration to sign up.
   */
  allowRegistration?: boolean;
  
  /**
   * targetFilter will restrict where the authentication integration should be
   * displayed. If the value of targetFilter is null, then the authentication
   * integration should be displayed in all targets.
   */
  targetFilter?: GQLSettingsAuthenticationTargetFilterInput;
  
  /**
   * clientID is the Client Identifier as provided by the Facebook Developer
   * Console.
   */
  clientID?: string;
  
  /**
   * clientSecret is the Client Secret as provided by the Facebook Developer
   * Console.
   */
  clientSecret?: string;
}

export interface GQLSettingsExternalIntegrationsInput {
  
  /**
   * akismet provides integration with the Akismet Spam detection service.
   */
  akismet?: GQLSettingsAkismetExternalIntegrationInput;
  
  /**
   * perspective provides integration with the Perspective API comment analysis
   * platform.
   */
  perspective?: GQLSettingsPerspectiveExternalIntegrationInput;
}

export interface GQLSettingsAkismetExternalIntegrationInput {
  
  /**
   * enabled when True will enable the integration.
   */
  enabled?: boolean;
  
  /**
   * ipBased when True will enable IP-based spam detection.
   */
  ipBased?: boolean;
  
  /**
   * The key for the Akismet integration.
   */
  key?: string;
  
  /**
   * The site (blog) for the Akismet integration.
   */
  site?: string;
}

export interface GQLSettingsPerspectiveExternalIntegrationInput {
  
  /**
   * enabled when True will enable the integration.
   */
  enabled?: boolean;
  
  /**
   * The endpoint that Coral should use to communicate with the perspective API.
   */
  endpoint?: string;
  
  /**
   * The key for the Perspective API integration.
   */
  key?: string;
  
  /**
   * model is the name of the Perspective model to use.
   */
  model?: string;
  
  /**
   * The threshold that given a specific toxic comment score, the comment will
   * be marked by Coral as toxic.
   */
  threshold?: number;
  
  /**
   * When True, comments sent will not be stored by the Google Perspective API.
   */
  doNotStore?: boolean;
  
  /**
   * When True, moderation actions will be sent to the Google Perspective API.
   */
  sendFeedback?: boolean;
}

/**
 * RecentCommentHistoryConfigurationInput controls the beheviour around when comments from Users
 * should be marked for pre-moderation automatically once they have reached the
 * trigger rate for rejected comments.
 */
export interface GQLRecentCommentHistoryConfigurationInput {
  
  /**
   * enabled when true will pre-moderate users new comments once they have reached
   * the trigger rejection rate.
   */
  enabled?: boolean;
  
  /**
   * timeFrame specifies the number of seconds that comments from a given User will
   * be taken into account when computing their rejection rate.
   */
  timeFrame?: number;
  
  /**
   * triggerRejectionRate specifies the percentage of comments that a given User
   * may have before their comments will then be placed into pre-moderation until
   * the rejection rate decreases.
   */
  triggerRejectionRate?: number;
}

export interface GQLSettingsCharCountInput {
  
  /**
   * enabled when true, enables the character count moderation phase.
   */
  enabled?: boolean;
  
  /**
   * min is the smallest length of a Comment that may be posted.
   */
  min?: number;
  
  /**
   * max is the largest length of a Comment that may be posted.
   */
  max?: number;
}

/**
 * StoryConfiguration stores the configuration for working with stories.
 */
export interface GQLStoryConfigurationInput {
  
  /**
   * scraping stores configuration around story scraping.
   */
  scraping?: GQLStoryScrapingConfigurationInput;
  
  /**
   * disableLazy when true, will only allow lookups of stories created via the API.
   */
  disableLazy?: boolean;
}

/**
 * StoryScrapingConfigurationInput stores the configuration around story scraping.
 */
export interface GQLStoryScrapingConfigurationInput {
  
  /**
   * enabled, when true, enables stories to be scraped. When disabled, stories will
   * only be looked up instead, and must be created via the API directly.
   */
  enabled?: boolean;
  
  /**
   * proxyURL when specified, allows scraping requests to use the provided proxy.
   * All requests will then be passed through the appropriote proxy as parsed by
   * the [proxy-agent](https://www.npmjs.com/package/proxy-agent) package.
   */
  proxyURL?: string;
  
  /**
   * customUserAgent when specified will override the user agent used by fetch
   * requests made during the scraping process.
   */
  customUserAgent?: string;
  
  /**
   * authentication is whether alternative authentication credentials have been
   * provided for scraping activities.
   */
  authentication: boolean;
  
  /**
   * username is the username to use with basic authentication for scraping jobs.
   */
  username?: string;
  
  /**
   * password is the password to use with basic authentication for scraping jobs.
   */
  password?: string;
}

/**
 * ReactionConfigurationInput stores the configuration for reactions used across
 * this Tenant.
 */
export interface GQLReactionConfigurationInput {
  
  /**
   * icon is the string representing the icon to be used for the reactions.
   */
  icon?: string;
  
  /**
   * iconActive is the string representing the icon that should be used when the
   * icon should be considered active.
   */
  iconActive?: string;
  
  /**
   * label is the string placed beside the reaction icon to provide better context.
   */
  label?: string;
  
  /**
   * labelActive is the string placed beside the reaction icon to provide better
   * context when it has been selected.
   */
  labelActive?: string;
  
  /**
   * sortLabel is the string placed inside of the sort menu to sort for comment
   * with most reactions.
   */
  sortLabel?: string;
  
  /**
   * color is the hex color code that can be used to change the color of the button.
   */
  color?: string;
}

/**
 * StaffConfigurationInput specifies the configuration for the staff badges
 * assigned to users with any role above COMMENTER.
 */
export interface GQLStaffConfigurationInput {
  
  /**
   * staffLabel is the string used when displaying the STAFF badge to users.
   */
  staffLabel?: string;
  
  /**
   * adminLabel is the string used when displaying the ADMIN badge to users.
   */
  adminLabel?: string;
  
  /**
   * moderatorLabel is the string used when displaying the MODERATOR badge to users.
   */
  moderatorLabel?: string;
}

/**
 * CommenterAccountFeatures stores the configuration for commenter account features.
 */
export interface GQLCommenterAccountFeaturesInput {
  
  /**
   * changeUsername when true, non-sso user may change username every 14 days
   */
  changeUsername?: boolean;
  
  /**
   * downloadComments when true, user may download their comment history
   */
  downloadComments?: boolean;
  
  /**
   * deleteAccount when true, non-sso user may permanently delete their account
   */
  deleteAccount?: boolean;
}

export interface GQLSlackConfigurationInput {
  
  /**
   * channels are the channels configured for Slack integration
   */
  channels?: Array<GQLSlackChannelConfigurationInput>;
}

export interface GQLSlackChannelConfigurationInput {
  
  /**
   * enabled is whether this Slack channel is enabled to send comments to its
   * correlated web hook
   */
  enabled?: boolean;
  
  /**
   * name is the name assigned to the Slack channel
   */
  name?: string;
  
  /**
   * hookURL defines the URL that comments will be sent to
   */
  hookURL?: string;
  
  /**
   * triggers are the filters of types of comments that will be sent to
   * the correlated channel
   */
  triggers?: GQLSlackTriggersConfigurationInput;
}

export interface GQLSlackTriggersConfigurationInput {
  
  /**
   * reportedComments is whether this channel will receive reported comments
   */
  reportedComments?: boolean;
  
  /**
   * pendingComments is whether this channel will receive pending comments
   */
  pendingComments?: boolean;
  
  /**
   * featuredComments is whether this channel will receive featured comments
   */
  featuredComments?: boolean;
  
  /**
   * allComents is whether the channel will receive all comments
   */
  allComments?: boolean;
  
  /**
   * staffComments is whether the channel will receive staff comments
   */
  staffComments?: boolean;
}

/**
 * NewCommenterConfigurationInput specifies the features that apply to new commenters
 */
export interface GQLNewCommentersConfigurationInput {
  
  /**
   * premodEnabled ensures that new commenters' comments are pre-moderated until they have
   * enough approved comments
   */
  premodEnabled?: boolean;
  
  /**
   * approvedCommentsThreshold is the number of comments a user must have approved before their
   * comments do not require premoderation
   */
  approvedCommentsThreshold?: number;
}

/**
 * RTEConfigurationInput specifies the configuration for the rte.
 */
export interface GQLRTEConfigurationInput {
  
  /**
   * enabled when true turns on basic RTE features including
   * bold, italic, quote, and bullet list.
   */
  enabled: boolean;
  
  /**
   * strikethrough when true turns on the strikethrough feature.
   */
  strikethrough: boolean;
  
  /**
   * spoiler when true turns on the spoiler feature.
   */
  spoiler: boolean;
}

export interface GQLMediaConfigurationInput {
  
  /**
   * twitter is the configuration for Twitter support.
   */
  twitter?: GQLTwitterMediaConfigurationInput;
  
  /**
   * youtube is the configuration for YouTube support.
   */
  youtube?: GQLYouTubeMediaConfigurationInput;
  
  /**
   * giphy is the configuration for Giphy support.
   */
  giphy?: GQLGiphyMediaConfigurationInput;
}

export interface GQLTwitterMediaConfigurationInput {
  
  /**
   * enabled is true when twitter media objects are enabled.
   */
  enabled?: boolean;
}

export interface GQLYouTubeMediaConfigurationInput {
  
  /**
   * enabled is true when youtube media objects are enabled.
   */
  enabled?: boolean;
}

export interface GQLGiphyMediaConfigurationInput {
  
  /**
   * enabled is true when gif search via giphy and giphy media objects are enabled.
   */
  enabled?: boolean;
  
  /**
   * maximum allowed rating for gifs, g, pg, pg-13, r
   */
  maxRating?: string;
  
  /**
   * key is the API key for Giphy.
   */
  key?: string;
}

/**
 * UpdateSettingsPayload contains the updated Settings after the updateSettings
 * mutation.
 */
export interface GQLUpdateSettingsPayload {
  
  /**
   * settings is the updated Settings.
   */
  settings?: GQLSettings;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRotateSSOSigningSecretInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * inactiveIn is the number of seconds that the current active SigningSecret
   * should be kept active (allow signed tokens signed with this secret) before
   * rejecting them.
   */
  inactiveIn: number;
}

export interface GQLRotateSSOSigningSecretPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * settings is the Settings that the SSO secret was regenerated on.
   */
  settings?: GQLSettings;
}

export interface GQLDeactivateSSOSigningSecretInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * kid is the ID of the SigningSecret being deactivated.
   */
  kid: string;
}

export interface GQLDeactivateSSOSigningSecretPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * settings is the Settings that the SSO secret was regenerated on.
   */
  settings?: GQLSettings;
}

export interface GQLDeleteSSOSigningSecretInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * kid is the ID of the SigningSecret being deleted.
   */
  kid: string;
}

export interface GQLDeleteSSOSigningSecretPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * settings is the Settings that the SSO secret was regenerated on.
   */
  settings?: GQLSettings;
}

export interface GQLCreateCommentReactionInput {
  
  /**
   * commentID is the Comment's ID that we want to create a Reaction on.
   */
  commentID: string;
  
  /**
   * commentRevisionID is the revision ID of the Comment that we're creating the
   * Reaction on.
   */
  commentRevisionID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCreateCommentReactionPayload {
  
  /**
   * comment is the Comment that the Reaction was created on.
   */
  comment?: GQLComment;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveCommentReactionInput {
  
  /**
   * commentID is the Comment's ID that we want to remove a Reaction on.
   */
  commentID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveCommentReactionPayload {
  
  /**
   * comment is the Comment that the Reaction was removed on.
   */
  comment?: GQLComment;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCreateCommentDontAgreeInput {
  
  /**
   * commentID is the Comment's ID that we want to create a DontAgree on.
   */
  commentID: string;
  
  /**
   * commentRevisionID is the revision ID of the Comment that we're creating the
   * DontAgree on.
   */
  commentRevisionID: string;
  
  /**
   * additionalDetails stores information from the User as to why the Flag was
   * created or is relevant.
   */
  additionalDetails?: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCreateCommentDontAgreePayload {
  
  /**
   * comment is the Comment that the DontAgree was created on.
   */
  comment?: GQLComment;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveCommentDontAgreeInput {
  
  /**
   * commentID is the Comment's ID that we want to remove a DontAgree on.
   */
  commentID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveCommentDontAgreePayload {
  
  /**
   * comment is the Comment that the DontAgree was removed on.
   */
  comment?: GQLComment;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCreateCommentFlagInput {
  
  /**
   * commentID is the Comment's ID that we want to create a Flag on.
   */
  commentID: string;
  
  /**
   * commentRevisionID is the revision ID of the Comment that we're creating the
   * Flag on.
   */
  commentRevisionID: string;
  
  /**
   * reason is the selected reason why the Flag is being created.
   */
  reason: GQLCOMMENT_FLAG_REPORTED_REASON;
  
  /**
   * additionalDetails stores information from the User as to why the Flag was
   * created or is relevant.
   */
  additionalDetails?: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * COMMENT_FLAG_REPORTED_REASON is a reason that is reported by a User on a
 * Comment.
 */
export enum GQLCOMMENT_FLAG_REPORTED_REASON {
  
  /**
   * COMMENT_REPORTED_OFFENSIVE is used when a User reported a Comment as being
   * offensive.
   */
  COMMENT_REPORTED_OFFENSIVE = 'COMMENT_REPORTED_OFFENSIVE',
  
  /**
   * COMMENT_REPORTED_ABUSIVE is used when a User reported a Comment as being
   * abusive.
   */
  COMMENT_REPORTED_ABUSIVE = 'COMMENT_REPORTED_ABUSIVE',
  
  /**
   * COMMENT_REPORTED_SPAM is used when a User reported a Comment as appearing like
   * spam.
   */
  COMMENT_REPORTED_SPAM = 'COMMENT_REPORTED_SPAM',
  
  /**
   * COMMENT_REPORTED_OTHER is used when a User reported a Comment that doesn't
   * fit into the other reported reasons.
   */
  COMMENT_REPORTED_OTHER = 'COMMENT_REPORTED_OTHER',
  
  /**
   * COMMENT_REPORTED_BIO is used when a User reports a bio that is offensive or abusive.
   */
  COMMENT_REPORTED_BIO = 'COMMENT_REPORTED_BIO'
}

export interface GQLCreateCommentFlagPayload {
  
  /**
   * comment is the Comment that the Flag was created on.
   */
  comment?: GQLComment;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLFeatureCommentInput {
  
  /**
   * commentID is the ID of the Comment that should be featured.
   */
  commentID: string;
  
  /**
   * commentRevisionID is the ID of the CommentRevision that should be featured
   */
  commentRevisionID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLFeatureCommentPayload {
  
  /**
   * comment is the Comment that was featured.
   */
  comment?: GQLComment;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * moderationQueues will return the selected moderation queues. If the `storyID`
   * is provided, it will filter the moderation queues for only comments in that
   * Story.
   */
  moderationQueues?: GQLModerationQueues;
}

export interface GQLUnfeatureCommentInput {
  
  /**
   * commentID is the ID of the featured Comment that should be unfeatured.
   */
  commentID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUnfeatureCommentPayload {
  
  /**
   * comment is the Comment that was unfeatured.
   */
  comment?: GQLComment;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCreateStoryInput {
  
  /**
   * story is the Story input needed to create a Story.
   */
  story: GQLCreateStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * CreateStory is the input required to create a Story.
 */
export interface GQLCreateStory {
  
  /**
   * id is the identifier of the Story.
   */
  id: string;
  
  /**
   * url is the url that the Story is located on.
   */
  url: string;
  
  /**
   * mode is the specified mode that the story should be created with.
   */
  mode?: GQLSTORY_MODE;
  
  /**
   * metadata is the set of information relating to this Story that would normally
   * be scraped, but can be provided here.
   */
  metadata?: GQLStoryMetadataInput;
  
  /**
   * closedAt when provided specifies the date that the given story will be closed
   * at. If not provided, the story close will use the settings to determine the
   * automatic close date.
   */
  closedAt?: GQLTime;
}

/**
 * StoryMetadataInput is the metadata for a given Story as provided via this API.
 */
export interface GQLStoryMetadataInput {
  
  /**
   * title stores the title from the Story page.
   */
  title?: string;
  
  /**
   * author stores the author from the Story page.
   */
  author?: string;
  
  /**
   * description stores the description from the Story page.
   */
  description?: string;
  
  /**
   * image stores the image from the Story page.
   */
  image?: string;
  
  /**
   * publishedAt stores the publication date from the Story page.
   */
  publishedAt?: GQLTime;
  
  /**
   * modifiedAt stores the modified date from the Story page.
   */
  modifiedAt?: GQLTime;
  
  /**
   * section stores the section from the Story page.
   */
  section?: string;
}

export interface GQLCreateStoryPayload {
  
  /**
   * story is the Story that was possibly created.
   */
  story?: GQLStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateStoryInput {
  
  /**
   * id is the identifier of the Story used either when the Story was created via
   * the API or from Coral when it was lazily created.
   */
  id: string;
  
  /**
   * story contains the fields that should be updated. Any fields not specified
   * will not be changed.
   */
  story: GQLUpdateStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * UpdateStory is the input required to update a Story.
 */
export interface GQLUpdateStory {
  
  /**
   * url is the url that the Story is located on.
   */
  url?: string;
  
  /**
   * metadata is the set of information relating to this Story that would normally
   * be scraped, but can be provided here.
   */
  metadata?: GQLStoryMetadataInput;
}

export interface GQLUpdateStoryPayload {
  
  /**
   * story is the Story that was possibly updated.
   */
  story?: GQLStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateStorySettingsInput {
  
  /**
   * id is the identifier of the Story used either when the Story was created via
   * the API or from Coral when it was lazily created.
   */
  id: string;
  
  /**
   * settings contains the fields on the story settings that should be updated. Any
   * fields not specified will not be changed.
   */
  settings: GQLUpdateStorySettings;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * UpdateStorySettings is the input required to update a Story's Settings.
 */
export interface GQLUpdateStorySettings {
  
  /**
   * live provides configuration options related to live updates on this Story.
   */
  live?: GQLLiveConfigurationInput;
  
  /**
   * moderation determines whether or not this is a PRE or POST moderated story.
   */
  moderation?: GQLMODERATION_MODE;
  
  /**
   * premodLinksEnable will put all comments that contain links into premod.
   */
  premodLinksEnable?: boolean;
  
  /**
   * messageBox stores settings related to the Story Message Box.
   */
  messageBox?: GQLStoryMessageBoxInput;
}

/**
 * StoryMessageBoxInput stores settings related to the Story Message Box.
 */
export interface GQLStoryMessageBoxInput {
  
  /**
   * enable when true will enable the Message Box on the comment stream.
   */
  enabled?: boolean;
  
  /**
   * icon when set will reference the string for the Message box used by the
   * Message Box.
   */
  icon?: string;
  
  /**
   * content when set contains the actual markup for the Message Box.
   */
  content?: string;
}

export interface GQLUpdateStorySettingsPayload {
  
  /**
   * story is the Story that was possibly updated.
   */
  story?: GQLStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCloseStoryInput {
  
  /**
   * id is the identifier of the Story used either when the Story was created via
   * the API or from Coral when it was lazily created.
   */
  id: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCloseStoryPayload {
  
  /**
   * story is the Story that was possibly updated.
   */
  story?: GQLStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLOpenStoryInput {
  
  /**
   * id is the identifier of the Story used either when the Story was created via
   * the API or from Coral when it was lazily created.
   */
  id: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLOpenStoryPayload {
  
  /**
   * story is the Story that was possibly updated.
   */
  story?: GQLStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLMergeStoriesInput {
  
  /**
   * sourceIDs are the list of Story ID's that should have their Comment's moved
   * onto the Story indicated by `destinationID`. The Stories indicated by the
   * `sourceIDs` field will be removed after the Comment's have been moved.
   */
  sourceIDs: Array<string>;
  
  /**
   * destinationID is the ID of the Story where all the other "source" Stories will
   * have their Comment's moved onto.
   */
  destinationID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLMergeStoriesPayload {
  
  /**
   * story is the Story that all the source stories were merged into.
   */
  story?: GQLStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveStoryInput {
  
  /**
   * id is the identifier of the Story used either when the Story was created via
   * the API or from Coral when it was lazily created.
   */
  id: string;
  
  /**
   * includeComments when true will remove any Comment's that were left on the
   * Story. This option should be used rarely, instead preferring to updating the
   * Story URL and/or merging with the correct Story.
   */
  includeComments?: boolean;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveStoryPayload {
  
  /**
   * story is the Story that was possibly removed.
   */
  story?: GQLStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLScrapeStoryInput {
  
  /**
   * id is the identifier of the Story used either when the Story was created via
   * the API or from Coral when it was lazily created.
   */
  id: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLScrapeStoryPayload {
  
  /**
   * story is the Story that was possibly scraped.
   */
  story?: GQLStory;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLApproveCommentInput {
  
  /**
   * commentID is the ID of the Comment that was approved.
   */
  commentID: string;
  
  /**
   * commentRevisionID is the ID of the CommentRevision that is being approved.
   */
  commentRevisionID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLApproveCommentPayload {
  
  /**
   * comment is the Comment that was approved.
   */
  comment?: GQLComment;
  
  /**
   * moderationQueues will return the selected moderation queues. If the `storyID`
   * is provided, it will filter the moderation queues for only comments in that
   * Story.
   */
  moderationQueues?: GQLModerationQueues;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRejectCommentInput {
  
  /**
   * commentID is the ID of the Comment that was rejected.
   */
  commentID: string;
  
  /**
   * commentRevisionID is the ID of the CommentRevision that is being rejected.
   */
  commentRevisionID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRejectCommentPayload {
  
  /**
   * comment is the Comment that was rejected.
   */
  comment?: GQLComment;
  
  /**
   * moderationQueues will return the selected moderation queues. If the `storyID`
   * is provided, it will filter the moderation queues for only comments in that
   * Story.
   */
  moderationQueues?: GQLModerationQueues;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLInviteUsersInput {
  
  /**
   * emails is the email addresses of the Users to be invited.
   */
  emails: Array<string>;
  
  /**
   * role is the designated role of the User being invited.
   */
  role: GQLUSER_ROLE;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLInviteUsersPayload {
  
  /**
   * invites is the references to the invited Users.
   */
  invites: Array<GQLInvite | null>;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * Invite represents a given User that is pending registration that has been
 * invited by an Administrator.
 */
export interface GQLInvite {
  
  /**
   * id is the identifier for the Invite.
   */
  id: string;
  
  /**
   * email is the email address that will be assigned and used for the
   * invited User.
   */
  email: string;
  
  /**
   * role is the USER_ROLE that the User will be assigned upon
   * account creation.
   */
  role: GQLUSER_ROLE;
  
  /**
   * createdBy is the User that created the Invite.
   */
  createdBy: GQLUser;
  
  /**
   * createdAt is the time that the Invite was created on.
   */
  createdAt: GQLTime;
}

export interface GQLSetUsernameInput {
  
  /**
   * username is the desired username that should be set to the current User.
   */
  username: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLSetUsernamePayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateBioInput {
  
  /**
   * bio is the desired bio that should be set to the current User.
   */
  bio?: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateBioPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUsernameInput {
  
  /**
   * username is the desired username that should be set to the current User.
   */
  username: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUsernamePayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLSetEmailInput {
  
  /**
   * email is the email address to be associated with the User.
   */
  email: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLSetEmailPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLSetPasswordInput {
  
  /**
   * password is the password that should be associated with the User.
   */
  password: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLSetPasswordPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdatePasswordInput {
  
  /**
   * oldPassword is the old password that that should be compared against when
   * trying to change the password before the change.
   */
  oldPassword: string;
  
  /**
   * newPassword is the new password that should be associated with the User.
   */
  newPassword: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdatePasswordPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRequestAccountDeletionInput {
  
  /**
   * password to verify for the current User.
   */
  password: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRequestAccountDeletionPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLDeleteUserAccountInput {
  
  /**
   * userID is the ID of the User being deleted.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLDeleteUserAccountPayload {
  
  /**
   * user is the User that was deleted.
   */
  user?: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCancelAccountDeletionInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCancelAccountDeletionPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCreateTokenInput {
  
  /**
   * name is the desired name for the Token.
   */
  name: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCreateTokenPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * token is the Token that was created.
   */
  token: GQLToken;
  
  /**
   * signedToken is the signed Token associated with the account.
   */
  signedToken: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLDeactivateTokenInput {
  
  /**
   * id is the ID of the Token that should be deactivated.
   */
  id: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLDeactivateTokenPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * token is the Token that was deleted.
   */
  token?: GQLToken;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUserUsernameInput {
  
  /**
   * userID is the ID of the User that should have their username updated.
   */
  userID: string;
  
  /**
   * username is the desired username to set for the User.
   */
  username: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUserUsernamePayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateEmailInput {
  
  /**
   * email is the email address to set for the User.
   */
  email: string;
  
  /**
   * password is the users password.
   */
  password: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateEmailPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateNotificationSettingsInput {
  
  /**
   * onReply, when true, will enable notifications to be sent to users that have
   * replies to their comments.
   */
  onReply?: boolean;
  
  /**
   * onFeatured, when true, will enable notifications to be sent to users that have
   * their comment's featured.
   */
  onFeatured?: boolean;
  
  /**
   * onStaffReplies when true, will enable notifications to be sent to users that
   * have a staff member reply to their comments. These notifications will
   * supercede notifications that would have been sent for a basic reply
   * notification.
   */
  onStaffReplies?: boolean;
  
  /**
   * onModeration when true, will enable notifications to be sent to users when a
   * comment that they wrote that was previously unpublished, becomes published due
   * to a moderator action.
   */
  onModeration?: boolean;
  
  /**
   * digestFrequency is the frequency to send notifications.
   */
  digestFrequency?: GQLDIGEST_FREQUENCY;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateNotificationSettingsPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUserMediaSettingsInput {
  unfurlEmbeds?: boolean;
  clientMutationId: string;
}

export interface GQLUpdateUserMediaSettingsPayload {
  user: GQLUser;
  clientMutationId: string;
}

export interface GQLUpdateUserEmailInput {
  
  /**
   * userID is the ID of the User that should have their email address updated.
   */
  userID: string;
  
  /**
   * email is the email address to set for the User.
   */
  email: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUserEmailPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUserAvatarInput {
  
  /**
   * userID is the ID of the User that should have their avatar updated.
   */
  userID: string;
  
  /**
   * avatar is the URL to the avatar to set for the User. If set to `null` or not
   * provided, it will be unset.
   */
  avatar?: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUserAvatarPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUserRoleInput {
  
  /**
   * userID is the ID of the User that should have their role updated.
   */
  userID: string;
  
  /**
   * role is the `USER_ROLE` that the User should be set to.
   */
  role: GQLUSER_ROLE;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateUserRolePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
}

export interface GQLPromoteUserInput {
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLPromoteUserPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
}

export interface GQLDemoteUserInput {
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLDemoteUserPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
}

export interface GQLUpdateUserModerationScopesInput {
  
  /**
   * userID is the ID of the User that should have their role updated.
   */
  userID: string;
  
  /**
   * moderationScopes defines the scopes that a given moderator should be limited
   * to when
   */
  moderationScopes: GQLModerationScopesInput;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

/**
 * ModerationScopesInput describes the different scopes that a given moderator
 * could be assigned.
 */
export interface GQLModerationScopesInput {
  
  /**
   * siteIDs is an array of ID's that should be the list of sites that a moderator
   * is limited to. If none are passed, it will remove the scoping for this User.
   */
  siteIDs?: Array<string>;
}

export interface GQLUpdateUserModerationScopesPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLBanUserInput {
  
  /**
   * userID is the ID of the User that should have their account banned.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * message is sent to banned user via email.
   */
  message: string;
  
  /**
   * site ID's to scope the ban to.
   */
  siteIDs?: Array<string>;
  
  /**
   * whether or not to reject all the user's previous comments when banning them.
   */
  rejectExistingComments?: boolean;
}

export interface GQLBanUserPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveUserBanInput {
  
  /**
   * userID is the ID of the User that should have their account un-banned.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveUserBanPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLSuspendUserInput {
  
  /**
   * userID is the ID of the User that should be suspended.
   */
  userID: string;
  
  /**
   * timeout is the length of time (in seconds) that a User should be suspended
   * for.
   */
  timeout: number;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * message is sent to suspended user via email.
   */
  message: string;
}

export interface GQLSuspendUserPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLWarnUserInput {
  
  /**
   * userID is the ID of the User that should have their account banned.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * message is displayed to the user in the stream
   */
  message: string;
}

export interface GQLWarnUserPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
}

export interface GQLRemoveUserWarningInput {
  
  /**
   * userID is the ID of the User that should be warned.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveUserWarningPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
}

export interface GQLAcknowledgeWarningInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLAcknowledgeWarningPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
}

export interface GQLRemoveUserSuspensionInput {
  
  /**
   * userID is the ID of the User that should have their active suspensions
   * removed.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveUserSuspensionPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLIgnoreUserInput {
  
  /**
   * userID is the ID of the User that should be ignored.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLIgnoreUserPayload {
  
  /**
   * user is the User that we just ignored.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveUserIgnoreInput {
  
  /**
   * userID is the ID of the User that should have the ignore removed.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemoveUserIgnorePayload {
  
  /**
   * user is the User that we removed the ignore from.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRequestCommentsDownloadInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRequestCommentsDownloadPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRequestUserCommentsDownloadInput {
  
  /**
   * userID specifies user to download comments for
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRequestUserCommentsDownloadPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * archiveURL is the archive url
   */
  archiveURL: string;
}

export interface GQLPremodUserInput {
  
  /**
   * userID is the ID of the User that should be premodded.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLPremodUserPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemovePremodUserInput {
  
  /**
   * userID is the ID of the User that should be premodded.
   */
  userID: string;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLRemovePremodUserPayload {
  
  /**
   * user is the possibly modified User.
   */
  user: GQLUser;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCreateModeratorNoteInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * body is the content of the Note
   */
  body: string;
  
  /**
   * userID the id of the User who is the subject of the note.
   */
  userID: string;
}

export interface GQLCreateModeratorNotePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * createdBy is the moderator who created the note
   * user is the updated user.
   */
  user: GQLUser;
}

export interface GQLDeleteModeratorNoteInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * userID is the user who is the subject of the note
   */
  userID: string;
  
  /**
   * id is the identifier of the note
   */
  id: string;
}

export interface GQLDeleteModeratorNotePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * user is the updated user.
   */
  user: GQLUser;
}

export interface GQLEnableFeatureFlagInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * flag is the feature flag to create.
   */
  flag: GQLFEATURE_FLAG;
}

export interface GQLEnableFeatureFlagPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * flags is the current set of flags enabled.
   */
  flags: Array<GQLFEATURE_FLAG>;
}

export interface GQLDisableFeatureFlagInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * flag is the feature flag to delete.
   */
  flag: GQLFEATURE_FLAG;
}

export interface GQLDisableFeatureFlagPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * flags is the current set of flags enabled.
   */
  flags: Array<GQLFEATURE_FLAG>;
}

export interface GQLCreateAnnouncementInput {
  
  /**
   * content of the announcement.
   */
  content: string;
  duration: number;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLCreateAnnouncementPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  settings: GQLSettings;
}

export interface GQLDeleteAnnouncementInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLDeleteAnnouncementPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  settings: GQLSettings;
}

export interface GQLCreateSiteInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * site is the input for the Site to create.
   */
  site: GQLCreateSite;
}

export interface GQLCreateSite {
  
  /**
   * name is the name of the Site.
   */
  name: string;
  
  /**
   * allowedOrigins are the allowed origins for embeds.
   */
  allowedOrigins: Array<string>;
}

export interface GQLCreateSitePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * site is the Site that was newly created.
   */
  site: GQLSite;
}

export interface GQLUpdateSiteInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the Site to update.
   */
  id: string;
  
  /**
   * site is the updates for the Site.
   */
  site: GQLUpdateSite;
}

export interface GQLUpdateSite {
  
  /**
   * name is the name of the Site.
   */
  name?: string;
  
  /**
   * url is the Site URL, seen in email communications.
   */
  url?: string;
  
  /**
   * contactEmail is the contact email for the Site, seen in email communications.
   */
  contactEmail?: string;
  
  /**
   * allowedOrigins are the allowed origins for embeds.
   */
  allowedOrigins?: Array<string>;
}

export interface GQLUpdateSitePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * site is the newly updated Site.
   */
  site: GQLSite;
}

export interface GQLCreateWebhookEndpointInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * url is the URL that Coral will POST event data to.
   */
  url: string;
  
  /**
   * all is true when all events are subscribed to.
   */
  all: boolean;
  
  /**
   * events are the specific event names that this endpoint is configured to send
   * for.
   */
  events: Array<GQLWEBHOOK_EVENT_NAME>;
}

export interface GQLCreateWebhookEndpointPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * endpoint is the endpoint that we just created.
   */
  endpoint: GQLWebhookEndpoint;
  
  /**
   * settings is the updated settings also containing the new endpoint.
   */
  settings: GQLSettings;
}

export interface GQLUpdateWebhookEndpointInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the WebhookEndpoint being updated.
   */
  id: string;
  
  /**
   * url is the URL that Coral will POST event data to.
   */
  url?: string;
  
  /**
   * all is true when all events are subscribed to.
   */
  all?: boolean;
  
  /**
   * events are the specific event names that this endpoint is configured to send
   * for.
   */
  events?: Array<GQLWEBHOOK_EVENT_NAME>;
}

export interface GQLUpdateWebhookEndpointPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * endpoint is the endpoint that we just created.
   */
  endpoint: GQLWebhookEndpoint;
}

export interface GQLEnableWebhookEndpointInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the WebhookEndpoint being enabled.
   */
  id: string;
}

export interface GQLEnableWebhookEndpointPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * endpoint is the endpoint that we just enabled.
   */
  endpoint: GQLWebhookEndpoint;
}

export interface GQLDisableWebhookEndpointInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the WebhookEndpoint being disabled.
   */
  id: string;
}

export interface GQLDisableWebhookEndpointPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * endpoint is the endpoint that we just disabled.
   */
  endpoint: GQLWebhookEndpoint;
}

export interface GQLDeleteWebhookEndpointInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the WebhookEndpoint being deleted.
   */
  id: string;
}

export interface GQLDeleteWebhookEndpointPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * endpoint is the endpoint that we just deleted.
   */
  endpoint: GQLWebhookEndpoint;
}

export interface GQLRotateWebhookEndpointSigningSecretInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the WebhookEndpoint being updated.
   */
  id: string;
  
  /**
   * inactiveIn is the number of seconds that the current active Secret should be
   * kept active.
   */
  inactiveIn: number;
}

export interface GQLRotateWebhookEndpointSigningSecretPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * endpoint is the endpoint that we just updated.
   */
  endpoint: GQLWebhookEndpoint;
}

export interface GQLCreateExternalModerationPhaseInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * name is the name assigned to this ExternalModerationPhase for identification
   * purposes.
   */
  name: string;
  
  /**
   * url is the URL that Coral will POST moderation queries to.
   */
  url: string;
  
  /**
   * format is the format of the comment body sent.
   */
  format: GQLCOMMENT_BODY_FORMAT;
  
  /**
   * timeout is the number of milliseconds that this moderation is maximum expected
   * to take before it is skipped.
   */
  timeout: number;
}

export interface GQLCreateExternalModerationPhasePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * phase is the ExternalModerationPhase that we just created.
   */
  phase: GQLExternalModerationPhase;
  
  /**
   * settings is the updated settings also containing the new phase.
   */
  settings: GQLSettings;
}

export interface GQLUpdateExternalModerationPhaseInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the ExternalModerationPhase being updated.
   */
  id: string;
  
  /**
   * name is the name assigned to this ExternalModerationPhase for identification
   * purposes.
   */
  name?: string;
  
  /**
   * url is the URL that Coral will POST moderation queries to.
   */
  url?: string;
  
  /**
   * format is the format of the comment body sent.
   */
  format?: GQLCOMMENT_BODY_FORMAT;
  
  /**
   * timeout is the number of milliseconds that this moderation is maximum expected
   * to take before it is skipped.
   */
  timeout?: number;
}

export interface GQLUpdateExternalModerationPhasePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * phase is the ExternalModerationPhase that we just updated.
   */
  phase: GQLExternalModerationPhase;
}

export interface GQLEnableExternalModerationPhaseInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the ExternalModerationPhase being enabled.
   */
  id: string;
}

export interface GQLEnableExternalModerationPhasePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * phase is the ExternalModerationPhase that we just enabled.
   */
  phase: GQLExternalModerationPhase;
}

export interface GQLDisableExternalModerationPhaseInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the ExternalModerationPhase being disabled.
   */
  id: string;
}

export interface GQLDisableExternalModerationPhasePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * phase is the ExternalModerationPhase that we just disabled.
   */
  phase: GQLExternalModerationPhase;
}

export interface GQLDeleteExternalModerationPhaseInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the ExternalModerationPhase being deleted.
   */
  id: string;
}

export interface GQLDeleteExternalModerationPhasePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * phase is the ExternalModerationPhase that we just deleted.
   */
  phase: GQLExternalModerationPhase;
}

export interface GQLRotateExternalModerationPhaseSigningSecretInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the ID of the ExternalModerationPhase being updated.
   */
  id: string;
  
  /**
   * inactiveIn is the number of seconds that the current active Secret should be
   * kept active.
   */
  inactiveIn: number;
}

export interface GQLRotateExternalModerationPhaseSigningSecretPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * phase is the ExternalModerationPhase that we just updated.
   */
  phase: GQLExternalModerationPhase;
}

export interface GQLUpdateStoryModeInput {
  
  /**
   * storyID is the story id to enable Q&A on.
   */
  storyID: string;
  
  /**
   * mode is the mode to set the story to.
   */
  mode: GQLSTORY_MODE;
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
}

export interface GQLUpdateStoryModePayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * story is the resultant story that Q&A was enabled on.
   */
  story: GQLStory;
}

export interface GQLAddStoryExpertInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * storyID is the story to add the expert to.
   */
  storyID: string;
  
  /**
   * userID is the user to add as an expert to the story.
   */
  userID: string;
}

export interface GQLAddStoryExpertPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * story is the resultant story the expert was added to.
   */
  story: GQLStory;
}

export interface GQLRemoveStoryExpertInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * storyID is the story to remove the expert from.
   */
  storyID: string;
  
  /**
   * userID is the user to remove as an expert from the story.
   */
  userID: string;
}

export interface GQLRemoveStoryExpertPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * story is the resultant story the expert was removed from.
   */
  story: GQLStory;
}

export interface GQLTestSMTPInput {
  clientMutationId: string;
}

export interface GQLTestSMTPPayload {
  clientMutationId: string;
}

export interface GQLReviewCommentFlagInput {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * id is the id of the Flag being reviewed.
   */
  id: string;
}

export interface GQLReviewCommentFlagPayload {
  
  /**
   * clientMutationId is required for Relay support.
   */
  clientMutationId: string;
  
  /**
   * flag is the flag that was reviewed by the review action.
   */
  flag: GQLFlag;
}

export interface GQLSubscription {
  
  /**
   * commentEnteredModerationQueue returns when a Comment enters a ModerationQueue.
   * Note that a Comment may enter multiple moderation queues.
   */
  commentEnteredModerationQueue: GQLCommentEnteredModerationQueuePayload;
  
  /**
   * commentLeftModerationQueue returns when a Comment leaves a ModerationQueue.
   * Note that a Comment may leave multiple moderation queues.
   */
  commentLeftModerationQueue: GQLCommentLeftModerationQueuePayload;
  
  /**
   * commentStatusUpdated returns when a Comment has it's status changed after
   * being created.
   */
  commentStatusUpdated: GQLCommentStatusUpdatedPayload;
  
  /**
   * commentEntered returns when a Comment is created or released anywhere in the Story.
   */
  commentEntered: GQLCommentEnteredPayload;
  
  /**
   * commentCreated returns when a Comment is created on the top level of a Story
   * that is visible.
   * @deprecated Use commentEntered instead
   */
  commentCreated: GQLCommentCreatedPayload;
  
  /**
   * commentReleased returns when a Comment on a premoderated stream is approved
   * @deprecated Use commentEntered instead
   */
  commentReleased: GQLCommentReleasedPayload;
  
  /**
   * commentReplyCreated returns when a Comment is posted in the ancestor chain of
   * comments.
   * @deprecated Use commentEntered instead
   */
  commentReplyCreated: GQLCommentReplyCreatedPayload;
  
  /**
   * commentFeatured returns when a Comment is featured.
   */
  commentFeatured: GQLCommentFeaturedPayload;
}

/**
 * MODERATION_QUEUE references the specific ModerationQueue that a given Comment
 * can be associated with.
 */
export enum GQLMODERATION_QUEUE {
  
  /**
   * UNMODERATED refers to the ModerationQueue for all Comments that have not been
   * moderated yet.
   */
  UNMODERATED = 'UNMODERATED',
  
  /**
   * REPORTED refers to the ModerationQueue for all Comments that have been
   * published, have not been moderated by a human yet, and have been reported by
   * a User via a flag.
   */
  REPORTED = 'REPORTED',
  
  /**
   * PENDING refers to the ModerationQueue for all Comments that were held back by
   * the system and require moderation in order to be published.
   */
  PENDING = 'PENDING'
}

/**
 * CommentEnteredModerationQueuePayload is returned when a Comment enters a
 * specific ModerationQueue.
 */
export interface GQLCommentEnteredModerationQueuePayload {
  
  /**
   * queue refers to the specific ModerationQueue that a given Comment entered.
   */
  queue: GQLMODERATION_QUEUE;
  
  /**
   * comment is the Comment that entered the ModerationQueue.
   */
  comment: GQLComment;
}

/**
 * CommentLeftModerationQueuePayload is returned when a Comment leaves a specific
 * ModerationQueue.
 */
export interface GQLCommentLeftModerationQueuePayload {
  
  /**
   * queue refers to the specific ModerationQueue that a given Comment left.
   */
  queue: GQLMODERATION_QUEUE;
  
  /**
   * comment is the Comment that left the ModerationQueue.
   */
  comment: GQLComment;
}

/**
 * CommentStatusUpdatedPayload is returned when a Comment has it's status updated
 * after it was created.
 */
export interface GQLCommentStatusUpdatedPayload {
  
  /**
   * newStatus is the new status assigned to the Comment. This status may not
   * match the status provided by `comment.status` due to race conditions in the
   * data loaders.
   */
  newStatus: GQLCOMMENT_STATUS;
  
  /**
   * oldStatus is the old status that was previously assigned to the Comment.
   */
  oldStatus: GQLCOMMENT_STATUS;
  
  /**
   * moderator is the User that updated the Comment's status. If null, then the
   * system assigned the new Comment status (for example, when a comment is edited
   * by the author, and now contains a banned word).
   */
  moderator?: GQLUser;
  
  /**
   * comment is the updated Comment after the status has been updated.
   */
  comment: GQLComment;
}

/**
 * CommentEnteredPayload is returned when a Comment is released on a Story.
 */
export interface GQLCommentEnteredPayload {
  
  /**
   * comment is the new Comment that was released on the Story.
   */
  comment: GQLComment;
}

/**
 * CommentCreatedPayload is returned when a new top level Comment is created on a
 * Story.
 */
export interface GQLCommentCreatedPayload {
  
  /**
   * comment is the new top level Comment that was created on the Story.
   */
  comment: GQLComment;
}

/**
 * CommentReleasedPayload is returned when a new top level Comment is approved from premod stream
 */
export interface GQLCommentReleasedPayload {
  
  /**
   * comment is the new top level Comment that was approved on the Story.
   */
  comment: GQLComment;
}

/**
 * CommentReplyCreatedPayload is returned when a Comment is created as a reply to
 * another Comment where the selected ancestor Comment is in the ancestor chain.
 */
export interface GQLCommentReplyCreatedPayload {
  
  /**
   * comment is the new reply Comment that was created.
   */
  comment: GQLComment;
}

/**
 * CommentFeaturedPayload is returned when a Comment is featured.
 */
export interface GQLCommentFeaturedPayload {
  
  /**
   * comment is the Comment that was featured.
   */
  comment: GQLComment;
}

/**
 * USER_AUTH_CONDITIONS describes conditions that would prevent a given User to
 * execute any set of mutations or reserved queries.
 */
export enum GQLUSER_AUTH_CONDITIONS {
  
  /**
   * MISSING_NAME is provided when the User does not have an associated username or
   * display name.
   */
  MISSING_NAME = 'MISSING_NAME',
  
  /**
   * MISSING_EMAIL is provided when the User does not have an associated email
   * address.
   */
  MISSING_EMAIL = 'MISSING_EMAIL',
  
  /**
   * BANNED is provided when the User is currently banned.
   */
  BANNED = 'BANNED',
  
  /**
   * SUSPENDED is provided when the User is currently under an active suspension.
   */
  SUSPENDED = 'SUSPENDED',
  
  /**
   * PENDING_DELETION is provided when the User is scheduled for deletion and will
   * remain after being deleted.
   */
  PENDING_DELETION = 'PENDING_DELETION',
  
  /**
   * WARNED
   */
  WARNED = 'WARNED'
}

export enum GQLCACHE_CONTROL_SCOPE {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}

/**
 * COMMENT_FLAG_DETECTED_REASON is a reason that is detected by the system on a
 * Comment.
 */
export enum GQLCOMMENT_FLAG_DETECTED_REASON {
  
  /**
   * COMMENT_DETECTED_TOXIC is used when the Comment was detected as being toxic by
   * the system.
   */
  COMMENT_DETECTED_TOXIC = 'COMMENT_DETECTED_TOXIC',
  
  /**
   * COMMENT_DETECTED_SPAM is used when the Comment was detected as having spam by
   * the system.
   */
  COMMENT_DETECTED_SPAM = 'COMMENT_DETECTED_SPAM',
  
  /**
   * COMMENT_DETECTED_LINKS is used when the Comment was detected as containing
   * links.
   */
  COMMENT_DETECTED_LINKS = 'COMMENT_DETECTED_LINKS',
  
  /**
   * COMMENT_DETECTED_BANNED_WORD is used when the Comment was detected as
   * containing a banned word.
   */
  COMMENT_DETECTED_BANNED_WORD = 'COMMENT_DETECTED_BANNED_WORD',
  
  /**
   * COMMENT_DETECTED_SUSPECT_WORD is used when the Comment was detected as
   * containing a suspect word.
   */
  COMMENT_DETECTED_SUSPECT_WORD = 'COMMENT_DETECTED_SUSPECT_WORD',
  
  /**
   * COMMENT_DETECTED_RECENT_HISTORY is used when a Comment author has exhibited a
   * recent history of rejected comments.
   */
  COMMENT_DETECTED_RECENT_HISTORY = 'COMMENT_DETECTED_RECENT_HISTORY',
  
  /**
   * COMMENT_DETECTED_PREMOD_USER is used when a Comment author has been tagged as requiring premoderation
   */
  COMMENT_DETECTED_PREMOD_USER = 'COMMENT_DETECTED_PREMOD_USER',
  
  /**
   * COMMENT_DETECTED_REPEAT_POST is used when a Comment's text exactly matches a previous recent comment from the same author
   */
  COMMENT_DETECTED_REPEAT_POST = 'COMMENT_DETECTED_REPEAT_POST'
}

/*********************************
 *                               *
 *         TYPE RESOLVERS        *
 *                               *
 *********************************/
/**
 * This interface define the shape of your resolver
 * Note that this type is designed to be compatible with graphql-tools resolvers
 * However, you can still use other generated interfaces to make your resolver type-safed
 */
export interface GQLResolver {
  Query?: GQLQueryTypeResolver;
  Comment?: GQLCommentTypeResolver;
  CommentRevision?: GQLCommentRevisionTypeResolver;
  ActionCounts?: GQLActionCountsTypeResolver;
  ReactionActionCounts?: GQLReactionActionCountsTypeResolver;
  DontAgreeActionCounts?: GQLDontAgreeActionCountsTypeResolver;
  FlagActionCounts?: GQLFlagActionCountsTypeResolver;
  FlagReasonActionCounts?: GQLFlagReasonActionCountsTypeResolver;
  CommentMedia?: {
    __resolveType: GQLCommentMediaTypeResolver
  };
  
  GiphyMedia?: GQLGiphyMediaTypeResolver;
  TwitterMedia?: GQLTwitterMediaTypeResolver;
  YouTubeMedia?: GQLYouTubeMediaTypeResolver;
  ExternalMedia?: GQLExternalMediaTypeResolver;
  CommentRevisionMetadata?: GQLCommentRevisionMetadataTypeResolver;
  CommentRevisionPerspectiveMetadata?: GQLCommentRevisionPerspectiveMetadataTypeResolver;
  CommentRevisionWordListMetadata?: GQLCommentRevisionWordListMetadataTypeResolver;
  CommentRevisionExternalModerationPhaseMetadata?: GQLCommentRevisionExternalModerationPhaseMetadataTypeResolver;
  Time?: GraphQLScalarType;
  ExternalModerationPhaseResult?: GQLExternalModerationPhaseResultTypeResolver;
  ExternalModerationPhaseAction?: GQLExternalModerationPhaseActionTypeResolver;
  User?: GQLUserTypeResolver;
  Profile?: {
    __resolveType: GQLProfileTypeResolver
  };
  
  LocalProfile?: GQLLocalProfileTypeResolver;
  OIDCProfile?: GQLOIDCProfileTypeResolver;
  SSOProfile?: GQLSSOProfileTypeResolver;
  FacebookProfile?: GQLFacebookProfileTypeResolver;
  GoogleProfile?: GQLGoogleProfileTypeResolver;
  ModeratorNote?: GQLModeratorNoteTypeResolver;
  Cursor?: GraphQLScalarType;
  CommentsConnection?: GQLCommentsConnectionTypeResolver;
  CommentEdge?: GQLCommentEdgeTypeResolver;
  PageInfo?: GQLPageInfoTypeResolver;
  Story?: GQLStoryTypeResolver;
  StoryMetadata?: GQLStoryMetadataTypeResolver;
  ModerationQueues?: GQLModerationQueuesTypeResolver;
  ModerationQueue?: GQLModerationQueueTypeResolver;
  CommentCounts?: GQLCommentCountsTypeResolver;
  CommentTagCounts?: GQLCommentTagCountsTypeResolver;
  CommentStatusCounts?: GQLCommentStatusCountsTypeResolver;
  StorySettings?: GQLStorySettingsTypeResolver;
  LiveConfiguration?: GQLLiveConfigurationTypeResolver;
  StoryMessageBox?: GQLStoryMessageBoxTypeResolver;
  Site?: GQLSiteTypeResolver;
  StoryRatings?: GQLStoryRatingsTypeResolver;
  RecentCommentHistory?: GQLRecentCommentHistoryTypeResolver;
  CommentModerationActionConnection?: GQLCommentModerationActionConnectionTypeResolver;
  CommentModerationActionEdge?: GQLCommentModerationActionEdgeTypeResolver;
  CommentModerationAction?: GQLCommentModerationActionTypeResolver;
  UserStatus?: GQLUserStatusTypeResolver;
  UsernameStatus?: GQLUsernameStatusTypeResolver;
  UsernameHistory?: GQLUsernameHistoryTypeResolver;
  BanStatus?: GQLBanStatusTypeResolver;
  BanStatusHistory?: GQLBanStatusHistoryTypeResolver;
  SuspensionStatus?: GQLSuspensionStatusTypeResolver;
  SuspensionStatusHistory?: GQLSuspensionStatusHistoryTypeResolver;
  TimeRange?: GQLTimeRangeTypeResolver;
  PremodStatus?: GQLPremodStatusTypeResolver;
  PremodStatusHistory?: GQLPremodStatusHistoryTypeResolver;
  WarningStatus?: GQLWarningStatusTypeResolver;
  WarningStatusHistory?: GQLWarningStatusHistoryTypeResolver;
  Token?: GQLTokenTypeResolver;
  UserNotificationSettings?: GQLUserNotificationSettingsTypeResolver;
  UserModerationScopes?: GQLUserModerationScopesTypeResolver;
  UserMediaSettings?: GQLUserMediaSettingsTypeResolver;
  EditInfo?: GQLEditInfoTypeResolver;
  ReactionsConnection?: GQLReactionsConnectionTypeResolver;
  ReactionEdge?: GQLReactionEdgeTypeResolver;
  Reaction?: GQLReactionTypeResolver;
  Reacter?: GQLReacterTypeResolver;
  FlagsConnection?: GQLFlagsConnectionTypeResolver;
  FlagEdge?: GQLFlagEdgeTypeResolver;
  Flag?: GQLFlagTypeResolver;
  ActionPresence?: GQLActionPresenceTypeResolver;
  Tag?: GQLTagTypeResolver;
  StoriesConnection?: GQLStoriesConnectionTypeResolver;
  StoryEdge?: GQLStoryEdgeTypeResolver;
  UsersConnection?: GQLUsersConnectionTypeResolver;
  UserEdge?: GQLUserEdgeTypeResolver;
  SitesConnection?: GQLSitesConnectionTypeResolver;
  SiteEdge?: GQLSiteEdgeTypeResolver;
  Settings?: GQLSettingsTypeResolver;
  WebhookConfiguration?: GQLWebhookConfigurationTypeResolver;
  WebhookEndpoint?: GQLWebhookEndpointTypeResolver;
  SigningSecret?: GQLSigningSecretTypeResolver;
  WebhookDelivery?: GQLWebhookDeliveryTypeResolver;
  Locale?: GraphQLScalarType;
  CommunityGuidelines?: GQLCommunityGuidelinesTypeResolver;
  CloseCommenting?: GQLCloseCommentingTypeResolver;
  DisableCommenting?: GQLDisableCommentingTypeResolver;
  CharCount?: GQLCharCountTypeResolver;
  Organization?: GQLOrganizationTypeResolver;
  EmailConfiguration?: GQLEmailConfigurationTypeResolver;
  SMTP?: GQLSMTPTypeResolver;
  SlackConfiguration?: GQLSlackConfigurationTypeResolver;
  SlackChannel?: GQLSlackChannelTypeResolver;
  SlackChannelTriggers?: GQLSlackChannelTriggersTypeResolver;
  WordList?: GQLWordListTypeResolver;
  Auth?: GQLAuthTypeResolver;
  AuthIntegrations?: GQLAuthIntegrationsTypeResolver;
  LocalAuthIntegration?: GQLLocalAuthIntegrationTypeResolver;
  AuthenticationTargetFilter?: GQLAuthenticationTargetFilterTypeResolver;
  SSOAuthIntegration?: GQLSSOAuthIntegrationTypeResolver;
  OIDCAuthIntegration?: GQLOIDCAuthIntegrationTypeResolver;
  GoogleAuthIntegration?: GQLGoogleAuthIntegrationTypeResolver;
  FacebookAuthIntegration?: GQLFacebookAuthIntegrationTypeResolver;
  ExternalIntegrations?: GQLExternalIntegrationsTypeResolver;
  AkismetExternalIntegration?: GQLAkismetExternalIntegrationTypeResolver;
  PerspectiveExternalIntegration?: GQLPerspectiveExternalIntegrationTypeResolver;
  CustomExternalIntegration?: GQLCustomExternalIntegrationTypeResolver;
  ExternalModerationPhase?: GQLExternalModerationPhaseTypeResolver;
  RecentCommentHistoryConfiguration?: GQLRecentCommentHistoryConfigurationTypeResolver;
  ReactionConfiguration?: GQLReactionConfigurationTypeResolver;
  StaffConfiguration?: GQLStaffConfigurationTypeResolver;
  CommenterAccountFeatures?: GQLCommenterAccountFeaturesTypeResolver;
  StoryConfiguration?: GQLStoryConfigurationTypeResolver;
  StoryScrapingConfiguration?: GQLStoryScrapingConfigurationTypeResolver;
  MediaConfiguration?: GQLMediaConfigurationTypeResolver;
  TwitterMediaConfiguration?: GQLTwitterMediaConfigurationTypeResolver;
  YouTubeMediaConfiguration?: GQLYouTubeMediaConfigurationTypeResolver;
  GiphyMediaConfiguration?: GQLGiphyMediaConfigurationTypeResolver;
  ExternalMediaConfiguration?: GQLExternalMediaConfigurationTypeResolver;
  NewCommentersConfiguration?: GQLNewCommentersConfigurationTypeResolver;
  Announcement?: GQLAnnouncementTypeResolver;
  RTEConfiguration?: GQLRTEConfigurationTypeResolver;
  DiscoveredOIDCConfiguration?: GQLDiscoveredOIDCConfigurationTypeResolver;
  Queues?: GQLQueuesTypeResolver;
  Queue?: GQLQueueTypeResolver;
  QueueCounts?: GQLQueueCountsTypeResolver;
  Mutation?: GQLMutationTypeResolver;
  CreateCommentPayload?: GQLCreateCommentPayloadTypeResolver;
  CreateCommentReplyPayload?: GQLCreateCommentReplyPayloadTypeResolver;
  EditCommentPayload?: GQLEditCommentPayloadTypeResolver;
  UpdateSettingsPayload?: GQLUpdateSettingsPayloadTypeResolver;
  RotateSSOSigningSecretPayload?: GQLRotateSSOSigningSecretPayloadTypeResolver;
  DeactivateSSOSigningSecretPayload?: GQLDeactivateSSOSigningSecretPayloadTypeResolver;
  DeleteSSOSigningSecretPayload?: GQLDeleteSSOSigningSecretPayloadTypeResolver;
  CreateCommentReactionPayload?: GQLCreateCommentReactionPayloadTypeResolver;
  RemoveCommentReactionPayload?: GQLRemoveCommentReactionPayloadTypeResolver;
  CreateCommentDontAgreePayload?: GQLCreateCommentDontAgreePayloadTypeResolver;
  RemoveCommentDontAgreePayload?: GQLRemoveCommentDontAgreePayloadTypeResolver;
  CreateCommentFlagPayload?: GQLCreateCommentFlagPayloadTypeResolver;
  FeatureCommentPayload?: GQLFeatureCommentPayloadTypeResolver;
  UnfeatureCommentPayload?: GQLUnfeatureCommentPayloadTypeResolver;
  CreateStoryPayload?: GQLCreateStoryPayloadTypeResolver;
  UpdateStoryPayload?: GQLUpdateStoryPayloadTypeResolver;
  UpdateStorySettingsPayload?: GQLUpdateStorySettingsPayloadTypeResolver;
  CloseStoryPayload?: GQLCloseStoryPayloadTypeResolver;
  OpenStoryPayload?: GQLOpenStoryPayloadTypeResolver;
  MergeStoriesPayload?: GQLMergeStoriesPayloadTypeResolver;
  RemoveStoryPayload?: GQLRemoveStoryPayloadTypeResolver;
  ScrapeStoryPayload?: GQLScrapeStoryPayloadTypeResolver;
  ApproveCommentPayload?: GQLApproveCommentPayloadTypeResolver;
  RejectCommentPayload?: GQLRejectCommentPayloadTypeResolver;
  InviteUsersPayload?: GQLInviteUsersPayloadTypeResolver;
  Invite?: GQLInviteTypeResolver;
  SetUsernamePayload?: GQLSetUsernamePayloadTypeResolver;
  UpdateBioPayload?: GQLUpdateBioPayloadTypeResolver;
  UpdateUsernamePayload?: GQLUpdateUsernamePayloadTypeResolver;
  SetEmailPayload?: GQLSetEmailPayloadTypeResolver;
  SetPasswordPayload?: GQLSetPasswordPayloadTypeResolver;
  UpdatePasswordPayload?: GQLUpdatePasswordPayloadTypeResolver;
  RequestAccountDeletionPayload?: GQLRequestAccountDeletionPayloadTypeResolver;
  DeleteUserAccountPayload?: GQLDeleteUserAccountPayloadTypeResolver;
  CancelAccountDeletionPayload?: GQLCancelAccountDeletionPayloadTypeResolver;
  CreateTokenPayload?: GQLCreateTokenPayloadTypeResolver;
  DeactivateTokenPayload?: GQLDeactivateTokenPayloadTypeResolver;
  UpdateUserUsernamePayload?: GQLUpdateUserUsernamePayloadTypeResolver;
  UpdateEmailPayload?: GQLUpdateEmailPayloadTypeResolver;
  UpdateNotificationSettingsPayload?: GQLUpdateNotificationSettingsPayloadTypeResolver;
  UpdateUserMediaSettingsPayload?: GQLUpdateUserMediaSettingsPayloadTypeResolver;
  UpdateUserEmailPayload?: GQLUpdateUserEmailPayloadTypeResolver;
  UpdateUserAvatarPayload?: GQLUpdateUserAvatarPayloadTypeResolver;
  UpdateUserRolePayload?: GQLUpdateUserRolePayloadTypeResolver;
  PromoteUserPayload?: GQLPromoteUserPayloadTypeResolver;
  DemoteUserPayload?: GQLDemoteUserPayloadTypeResolver;
  UpdateUserModerationScopesPayload?: GQLUpdateUserModerationScopesPayloadTypeResolver;
  BanUserPayload?: GQLBanUserPayloadTypeResolver;
  RemoveUserBanPayload?: GQLRemoveUserBanPayloadTypeResolver;
  SuspendUserPayload?: GQLSuspendUserPayloadTypeResolver;
  WarnUserPayload?: GQLWarnUserPayloadTypeResolver;
  RemoveUserWarningPayload?: GQLRemoveUserWarningPayloadTypeResolver;
  AcknowledgeWarningPayload?: GQLAcknowledgeWarningPayloadTypeResolver;
  RemoveUserSuspensionPayload?: GQLRemoveUserSuspensionPayloadTypeResolver;
  IgnoreUserPayload?: GQLIgnoreUserPayloadTypeResolver;
  RemoveUserIgnorePayload?: GQLRemoveUserIgnorePayloadTypeResolver;
  RequestCommentsDownloadPayload?: GQLRequestCommentsDownloadPayloadTypeResolver;
  RequestUserCommentsDownloadPayload?: GQLRequestUserCommentsDownloadPayloadTypeResolver;
  PremodUserPayload?: GQLPremodUserPayloadTypeResolver;
  RemovePremodUserPayload?: GQLRemovePremodUserPayloadTypeResolver;
  CreateModeratorNotePayload?: GQLCreateModeratorNotePayloadTypeResolver;
  DeleteModeratorNotePayload?: GQLDeleteModeratorNotePayloadTypeResolver;
  EnableFeatureFlagPayload?: GQLEnableFeatureFlagPayloadTypeResolver;
  DisableFeatureFlagPayload?: GQLDisableFeatureFlagPayloadTypeResolver;
  CreateAnnouncementPayload?: GQLCreateAnnouncementPayloadTypeResolver;
  DeleteAnnouncementPayload?: GQLDeleteAnnouncementPayloadTypeResolver;
  CreateSitePayload?: GQLCreateSitePayloadTypeResolver;
  UpdateSitePayload?: GQLUpdateSitePayloadTypeResolver;
  CreateWebhookEndpointPayload?: GQLCreateWebhookEndpointPayloadTypeResolver;
  UpdateWebhookEndpointPayload?: GQLUpdateWebhookEndpointPayloadTypeResolver;
  EnableWebhookEndpointPayload?: GQLEnableWebhookEndpointPayloadTypeResolver;
  DisableWebhookEndpointPayload?: GQLDisableWebhookEndpointPayloadTypeResolver;
  DeleteWebhookEndpointPayload?: GQLDeleteWebhookEndpointPayloadTypeResolver;
  RotateWebhookEndpointSigningSecretPayload?: GQLRotateWebhookEndpointSigningSecretPayloadTypeResolver;
  CreateExternalModerationPhasePayload?: GQLCreateExternalModerationPhasePayloadTypeResolver;
  UpdateExternalModerationPhasePayload?: GQLUpdateExternalModerationPhasePayloadTypeResolver;
  EnableExternalModerationPhasePayload?: GQLEnableExternalModerationPhasePayloadTypeResolver;
  DisableExternalModerationPhasePayload?: GQLDisableExternalModerationPhasePayloadTypeResolver;
  DeleteExternalModerationPhasePayload?: GQLDeleteExternalModerationPhasePayloadTypeResolver;
  RotateExternalModerationPhaseSigningSecretPayload?: GQLRotateExternalModerationPhaseSigningSecretPayloadTypeResolver;
  UpdateStoryModePayload?: GQLUpdateStoryModePayloadTypeResolver;
  AddStoryExpertPayload?: GQLAddStoryExpertPayloadTypeResolver;
  RemoveStoryExpertPayload?: GQLRemoveStoryExpertPayloadTypeResolver;
  TestSMTPPayload?: GQLTestSMTPPayloadTypeResolver;
  ReviewCommentFlagPayload?: GQLReviewCommentFlagPayloadTypeResolver;
  Subscription?: GQLSubscriptionTypeResolver;
  CommentEnteredModerationQueuePayload?: GQLCommentEnteredModerationQueuePayloadTypeResolver;
  CommentLeftModerationQueuePayload?: GQLCommentLeftModerationQueuePayloadTypeResolver;
  CommentStatusUpdatedPayload?: GQLCommentStatusUpdatedPayloadTypeResolver;
  CommentEnteredPayload?: GQLCommentEnteredPayloadTypeResolver;
  CommentCreatedPayload?: GQLCommentCreatedPayloadTypeResolver;
  CommentReleasedPayload?: GQLCommentReleasedPayloadTypeResolver;
  CommentReplyCreatedPayload?: GQLCommentReplyCreatedPayloadTypeResolver;
  CommentFeaturedPayload?: GQLCommentFeaturedPayloadTypeResolver;
}
export interface GQLQueryTypeResolver<TParent = undefined> {
  comment?: QueryToCommentResolver<TParent>;
  comments?: QueryToCommentsResolver<TParent>;
  story?: QueryToStoryResolver<TParent>;
  stream?: QueryToStreamResolver<TParent>;
  stories?: QueryToStoriesResolver<TParent>;
  user?: QueryToUserResolver<TParent>;
  users?: QueryToUsersResolver<TParent>;
  site?: QueryToSiteResolver<TParent>;
  sites?: QueryToSitesResolver<TParent>;
  viewer?: QueryToViewerResolver<TParent>;
  settings?: QueryToSettingsResolver<TParent>;
  discoverOIDCConfiguration?: QueryToDiscoverOIDCConfigurationResolver<TParent>;
  debugScrapeStoryMetadata?: QueryToDebugScrapeStoryMetadataResolver<TParent>;
  moderationQueues?: QueryToModerationQueuesResolver<TParent>;
  sections?: QueryToSectionsResolver<TParent>;
  activeStories?: QueryToActiveStoriesResolver<TParent>;
  webhookEndpoint?: QueryToWebhookEndpointResolver<TParent>;
  queues?: QueryToQueuesResolver<TParent>;
  externalModerationPhase?: QueryToExternalModerationPhaseResolver<TParent>;
  flags?: QueryToFlagsResolver<TParent>;
}

export interface QueryToCommentArgs {
  id: string;
}
export interface QueryToCommentResolver<TParent = undefined, TResult = GQLComment | null> {
  (parent: TParent, args: QueryToCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCommentsArgs {
  first?: number;
  after?: GQLCursor;
  storyID?: string;
  siteID?: string;
  status?: GQLCOMMENT_STATUS;
  section?: GQLSectionFilter;
  tag?: GQLTAG;
  query?: string;
  orderBy?: GQLCOMMENT_SORT;
}
export interface QueryToCommentsResolver<TParent = undefined, TResult = GQLCommentsConnection> {
  (parent: TParent, args: QueryToCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToStoryArgs {
  id?: string;
  url?: string;
}
export interface QueryToStoryResolver<TParent = undefined, TResult = GQLStory | null> {
  (parent: TParent, args: QueryToStoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToStreamArgs {
  id?: string;
  url?: string;
  mode?: GQLSTORY_MODE;
}
export interface QueryToStreamResolver<TParent = undefined, TResult = GQLStory | null> {
  (parent: TParent, args: QueryToStreamArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToStoriesArgs {
  first?: number;
  after?: GQLCursor;
  status?: GQLSTORY_STATUS;
  query?: string;
  siteID?: string;
}
export interface QueryToStoriesResolver<TParent = undefined, TResult = GQLStoriesConnection> {
  (parent: TParent, args: QueryToStoriesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToUserArgs {
  id: string;
}
export interface QueryToUserResolver<TParent = undefined, TResult = GQLUser | null> {
  (parent: TParent, args: QueryToUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToUsersArgs {
  first?: number;
  after?: GQLCursor;
  role?: GQLUSER_ROLE;
  query?: string;
  status?: GQLUSER_STATUS_FILTER;
}
export interface QueryToUsersResolver<TParent = undefined, TResult = GQLUsersConnection> {
  (parent: TParent, args: QueryToUsersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSiteArgs {
  id: string;
}
export interface QueryToSiteResolver<TParent = undefined, TResult = GQLSite | null> {
  (parent: TParent, args: QueryToSiteArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSitesArgs {
  first?: number;
  after?: GQLCursor;
}
export interface QueryToSitesResolver<TParent = undefined, TResult = GQLSitesConnection> {
  (parent: TParent, args: QueryToSitesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToViewerResolver<TParent = undefined, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSettingsResolver<TParent = undefined, TResult = GQLSettings> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDiscoverOIDCConfigurationArgs {
  issuer: string;
}
export interface QueryToDiscoverOIDCConfigurationResolver<TParent = undefined, TResult = GQLDiscoveredOIDCConfiguration | null> {
  (parent: TParent, args: QueryToDiscoverOIDCConfigurationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDebugScrapeStoryMetadataArgs {
  url: string;
}
export interface QueryToDebugScrapeStoryMetadataResolver<TParent = undefined, TResult = GQLStoryMetadata | null> {
  (parent: TParent, args: QueryToDebugScrapeStoryMetadataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToModerationQueuesArgs {
  storyID?: string;
  siteID?: string;
  section?: GQLSectionFilter;
}
export interface QueryToModerationQueuesResolver<TParent = undefined, TResult = GQLModerationQueues> {
  (parent: TParent, args: QueryToModerationQueuesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSectionsResolver<TParent = undefined, TResult = Array<string> | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToActiveStoriesArgs {
  limit?: number;
}
export interface QueryToActiveStoriesResolver<TParent = undefined, TResult = Array<GQLStory>> {
  (parent: TParent, args: QueryToActiveStoriesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToWebhookEndpointArgs {
  id: string;
}
export interface QueryToWebhookEndpointResolver<TParent = undefined, TResult = GQLWebhookEndpoint | null> {
  (parent: TParent, args: QueryToWebhookEndpointArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToQueuesResolver<TParent = undefined, TResult = GQLQueues> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToExternalModerationPhaseArgs {
  id: string;
}
export interface QueryToExternalModerationPhaseResolver<TParent = undefined, TResult = GQLExternalModerationPhase | null> {
  (parent: TParent, args: QueryToExternalModerationPhaseArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFlagsArgs {
  first?: number;
  after?: GQLCursor;
  orderBy?: GQLCOMMENT_SORT;
  storyID?: string;
  siteID?: string;
  section?: GQLSectionFilter;
}
export interface QueryToFlagsResolver<TParent = undefined, TResult = GQLFlagsConnection> {
  (parent: TParent, args: QueryToFlagsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentTypeResolver<TParent = GQLComment> {
  id?: CommentToIdResolver<TParent>;
  body?: CommentToBodyResolver<TParent>;
  revision?: CommentToRevisionResolver<TParent>;
  revisionHistory?: CommentToRevisionHistoryResolver<TParent>;
  createdAt?: CommentToCreatedAtResolver<TParent>;
  author?: CommentToAuthorResolver<TParent>;
  status?: CommentToStatusResolver<TParent>;
  statusHistory?: CommentToStatusHistoryResolver<TParent>;
  parentCount?: CommentToParentCountResolver<TParent>;
  depth?: CommentToDepthResolver<TParent>;
  replyCount?: CommentToReplyCountResolver<TParent>;
  replies?: CommentToRepliesResolver<TParent>;
  parent?: CommentToParentResolver<TParent>;
  rootParent?: CommentToRootParentResolver<TParent>;
  parents?: CommentToParentsResolver<TParent>;
  editing?: CommentToEditingResolver<TParent>;
  actionCounts?: CommentToActionCountsResolver<TParent>;
  reactions?: CommentToReactionsResolver<TParent>;
  flags?: CommentToFlagsResolver<TParent>;
  viewerActionPresence?: CommentToViewerActionPresenceResolver<TParent>;
  story?: CommentToStoryResolver<TParent>;
  permalink?: CommentToPermalinkResolver<TParent>;
  tags?: CommentToTagsResolver<TParent>;
  deleted?: CommentToDeletedResolver<TParent>;
  canModerate?: CommentToCanModerateResolver<TParent>;
  site?: CommentToSiteResolver<TParent>;
  rating?: CommentToRatingResolver<TParent>;
}

export interface CommentToIdResolver<TParent = GQLComment, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToBodyResolver<TParent = GQLComment, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToRevisionResolver<TParent = GQLComment, TResult = GQLCommentRevision | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToRevisionHistoryResolver<TParent = GQLComment, TResult = Array<GQLCommentRevision>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToCreatedAtResolver<TParent = GQLComment, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToAuthorResolver<TParent = GQLComment, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToStatusResolver<TParent = GQLComment, TResult = GQLCOMMENT_STATUS> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToStatusHistoryArgs {
  first?: number;
  after?: GQLCursor;
}
export interface CommentToStatusHistoryResolver<TParent = GQLComment, TResult = GQLCommentModerationActionConnection> {
  (parent: TParent, args: CommentToStatusHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToParentCountResolver<TParent = GQLComment, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToDepthResolver<TParent = GQLComment, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToReplyCountResolver<TParent = GQLComment, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToRepliesArgs {
  first?: number;
  orderBy?: GQLCOMMENT_SORT;
  after?: GQLCursor;
  flatten?: boolean;
}
export interface CommentToRepliesResolver<TParent = GQLComment, TResult = GQLCommentsConnection> {
  (parent: TParent, args: CommentToRepliesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToParentResolver<TParent = GQLComment, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToRootParentResolver<TParent = GQLComment, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToParentsArgs {
  last?: number;
  before?: GQLCursor;
}
export interface CommentToParentsResolver<TParent = GQLComment, TResult = GQLCommentsConnection> {
  (parent: TParent, args: CommentToParentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToEditingResolver<TParent = GQLComment, TResult = GQLEditInfo> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToActionCountsResolver<TParent = GQLComment, TResult = GQLActionCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToReactionsArgs {
  first?: number;
  after?: GQLCursor;
}
export interface CommentToReactionsResolver<TParent = GQLComment, TResult = GQLReactionsConnection> {
  (parent: TParent, args: CommentToReactionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToFlagsArgs {
  first?: number;
  after?: GQLCursor;
}
export interface CommentToFlagsResolver<TParent = GQLComment, TResult = GQLFlagsConnection> {
  (parent: TParent, args: CommentToFlagsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToViewerActionPresenceResolver<TParent = GQLComment, TResult = GQLActionPresence | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToStoryResolver<TParent = GQLComment, TResult = GQLStory> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToPermalinkResolver<TParent = GQLComment, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToTagsResolver<TParent = GQLComment, TResult = Array<GQLTag>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToDeletedResolver<TParent = GQLComment, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToCanModerateResolver<TParent = GQLComment, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToSiteResolver<TParent = GQLComment, TResult = GQLSite> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToRatingResolver<TParent = GQLComment, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentRevisionTypeResolver<TParent = GQLCommentRevision> {
  id?: CommentRevisionToIdResolver<TParent>;
  comment?: CommentRevisionToCommentResolver<TParent>;
  actionCounts?: CommentRevisionToActionCountsResolver<TParent>;
  body?: CommentRevisionToBodyResolver<TParent>;
  media?: CommentRevisionToMediaResolver<TParent>;
  metadata?: CommentRevisionToMetadataResolver<TParent>;
  createdAt?: CommentRevisionToCreatedAtResolver<TParent>;
}

export interface CommentRevisionToIdResolver<TParent = GQLCommentRevision, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionToCommentResolver<TParent = GQLCommentRevision, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionToActionCountsResolver<TParent = GQLCommentRevision, TResult = GQLActionCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionToBodyResolver<TParent = GQLCommentRevision, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionToMediaResolver<TParent = GQLCommentRevision, TResult = GQLCommentMedia | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionToMetadataResolver<TParent = GQLCommentRevision, TResult = GQLCommentRevisionMetadata> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionToCreatedAtResolver<TParent = GQLCommentRevision, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLActionCountsTypeResolver<TParent = GQLActionCounts> {
  reaction?: ActionCountsToReactionResolver<TParent>;
  dontAgree?: ActionCountsToDontAgreeResolver<TParent>;
  flag?: ActionCountsToFlagResolver<TParent>;
}

export interface ActionCountsToReactionResolver<TParent = GQLActionCounts, TResult = GQLReactionActionCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActionCountsToDontAgreeResolver<TParent = GQLActionCounts, TResult = GQLDontAgreeActionCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActionCountsToFlagResolver<TParent = GQLActionCounts, TResult = GQLFlagActionCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReactionActionCountsTypeResolver<TParent = GQLReactionActionCounts> {
  total?: ReactionActionCountsToTotalResolver<TParent>;
}

export interface ReactionActionCountsToTotalResolver<TParent = GQLReactionActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDontAgreeActionCountsTypeResolver<TParent = GQLDontAgreeActionCounts> {
  total?: DontAgreeActionCountsToTotalResolver<TParent>;
}

export interface DontAgreeActionCountsToTotalResolver<TParent = GQLDontAgreeActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFlagActionCountsTypeResolver<TParent = GQLFlagActionCounts> {
  total?: FlagActionCountsToTotalResolver<TParent>;
  reasons?: FlagActionCountsToReasonsResolver<TParent>;
}

export interface FlagActionCountsToTotalResolver<TParent = GQLFlagActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagActionCountsToReasonsResolver<TParent = GQLFlagActionCounts, TResult = GQLFlagReasonActionCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFlagReasonActionCountsTypeResolver<TParent = GQLFlagReasonActionCounts> {
  COMMENT_REPORTED_OFFENSIVE?: FlagReasonActionCountsToCOMMENT_REPORTED_OFFENSIVEResolver<TParent>;
  COMMENT_REPORTED_ABUSIVE?: FlagReasonActionCountsToCOMMENT_REPORTED_ABUSIVEResolver<TParent>;
  COMMENT_REPORTED_SPAM?: FlagReasonActionCountsToCOMMENT_REPORTED_SPAMResolver<TParent>;
  COMMENT_REPORTED_OTHER?: FlagReasonActionCountsToCOMMENT_REPORTED_OTHERResolver<TParent>;
  COMMENT_REPORTED_BIO?: FlagReasonActionCountsToCOMMENT_REPORTED_BIOResolver<TParent>;
  COMMENT_DETECTED_TOXIC?: FlagReasonActionCountsToCOMMENT_DETECTED_TOXICResolver<TParent>;
  COMMENT_DETECTED_SPAM?: FlagReasonActionCountsToCOMMENT_DETECTED_SPAMResolver<TParent>;
  COMMENT_DETECTED_LINKS?: FlagReasonActionCountsToCOMMENT_DETECTED_LINKSResolver<TParent>;
  COMMENT_DETECTED_BANNED_WORD?: FlagReasonActionCountsToCOMMENT_DETECTED_BANNED_WORDResolver<TParent>;
  COMMENT_DETECTED_SUSPECT_WORD?: FlagReasonActionCountsToCOMMENT_DETECTED_SUSPECT_WORDResolver<TParent>;
  COMMENT_DETECTED_RECENT_HISTORY?: FlagReasonActionCountsToCOMMENT_DETECTED_RECENT_HISTORYResolver<TParent>;
  COMMENT_DETECTED_PREMOD_USER?: FlagReasonActionCountsToCOMMENT_DETECTED_PREMOD_USERResolver<TParent>;
  COMMENT_DETECTED_NEW_COMMENTER?: FlagReasonActionCountsToCOMMENT_DETECTED_NEW_COMMENTERResolver<TParent>;
  COMMENT_DETECTED_REPEAT_POST?: FlagReasonActionCountsToCOMMENT_DETECTED_REPEAT_POSTResolver<TParent>;
}

export interface FlagReasonActionCountsToCOMMENT_REPORTED_OFFENSIVEResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_REPORTED_ABUSIVEResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_REPORTED_SPAMResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_REPORTED_OTHERResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_REPORTED_BIOResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_DETECTED_TOXICResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_DETECTED_SPAMResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_DETECTED_LINKSResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_DETECTED_BANNED_WORDResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_DETECTED_SUSPECT_WORDResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_DETECTED_RECENT_HISTORYResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_DETECTED_PREMOD_USERResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_DETECTED_NEW_COMMENTERResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagReasonActionCountsToCOMMENT_DETECTED_REPEAT_POSTResolver<TParent = GQLFlagReasonActionCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentMediaTypeResolver<TParent = GQLCommentMedia> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'GiphyMedia' | 'TwitterMedia' | 'YouTubeMedia' | 'ExternalMedia';
}
export interface GQLGiphyMediaTypeResolver<TParent = GQLGiphyMedia> {
  url?: GiphyMediaToUrlResolver<TParent>;
  original?: GiphyMediaToOriginalResolver<TParent>;
  still?: GiphyMediaToStillResolver<TParent>;
  video?: GiphyMediaToVideoResolver<TParent>;
  width?: GiphyMediaToWidthResolver<TParent>;
  height?: GiphyMediaToHeightResolver<TParent>;
  title?: GiphyMediaToTitleResolver<TParent>;
}

export interface GiphyMediaToUrlResolver<TParent = GQLGiphyMedia, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GiphyMediaToOriginalResolver<TParent = GQLGiphyMedia, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GiphyMediaToStillResolver<TParent = GQLGiphyMedia, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GiphyMediaToVideoResolver<TParent = GQLGiphyMedia, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GiphyMediaToWidthResolver<TParent = GQLGiphyMedia, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GiphyMediaToHeightResolver<TParent = GQLGiphyMedia, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GiphyMediaToTitleResolver<TParent = GQLGiphyMedia, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTwitterMediaTypeResolver<TParent = GQLTwitterMedia> {
  url?: TwitterMediaToUrlResolver<TParent>;
  width?: TwitterMediaToWidthResolver<TParent>;
}

export interface TwitterMediaToUrlResolver<TParent = GQLTwitterMedia, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TwitterMediaToWidthResolver<TParent = GQLTwitterMedia, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLYouTubeMediaTypeResolver<TParent = GQLYouTubeMedia> {
  url?: YouTubeMediaToUrlResolver<TParent>;
  still?: YouTubeMediaToStillResolver<TParent>;
  title?: YouTubeMediaToTitleResolver<TParent>;
  width?: YouTubeMediaToWidthResolver<TParent>;
  height?: YouTubeMediaToHeightResolver<TParent>;
}

export interface YouTubeMediaToUrlResolver<TParent = GQLYouTubeMedia, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface YouTubeMediaToStillResolver<TParent = GQLYouTubeMedia, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface YouTubeMediaToTitleResolver<TParent = GQLYouTubeMedia, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface YouTubeMediaToWidthResolver<TParent = GQLYouTubeMedia, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface YouTubeMediaToHeightResolver<TParent = GQLYouTubeMedia, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLExternalMediaTypeResolver<TParent = GQLExternalMedia> {
  url?: ExternalMediaToUrlResolver<TParent>;
  extension?: ExternalMediaToExtensionResolver<TParent>;
  width?: ExternalMediaToWidthResolver<TParent>;
  height?: ExternalMediaToHeightResolver<TParent>;
}

export interface ExternalMediaToUrlResolver<TParent = GQLExternalMedia, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalMediaToExtensionResolver<TParent = GQLExternalMedia, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalMediaToWidthResolver<TParent = GQLExternalMedia, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalMediaToHeightResolver<TParent = GQLExternalMedia, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentRevisionMetadataTypeResolver<TParent = GQLCommentRevisionMetadata> {
  perspective?: CommentRevisionMetadataToPerspectiveResolver<TParent>;
  wordList?: CommentRevisionMetadataToWordListResolver<TParent>;
  externalModeration?: CommentRevisionMetadataToExternalModerationResolver<TParent>;
}

export interface CommentRevisionMetadataToPerspectiveResolver<TParent = GQLCommentRevisionMetadata, TResult = GQLCommentRevisionPerspectiveMetadata | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionMetadataToWordListResolver<TParent = GQLCommentRevisionMetadata, TResult = GQLCommentRevisionWordListMetadata | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionMetadataToExternalModerationResolver<TParent = GQLCommentRevisionMetadata, TResult = Array<GQLCommentRevisionExternalModerationPhaseMetadata> | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentRevisionPerspectiveMetadataTypeResolver<TParent = GQLCommentRevisionPerspectiveMetadata> {
  score?: CommentRevisionPerspectiveMetadataToScoreResolver<TParent>;
}

export interface CommentRevisionPerspectiveMetadataToScoreResolver<TParent = GQLCommentRevisionPerspectiveMetadata, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentRevisionWordListMetadataTypeResolver<TParent = GQLCommentRevisionWordListMetadata> {
  timedOut?: CommentRevisionWordListMetadataToTimedOutResolver<TParent>;
}

export interface CommentRevisionWordListMetadataToTimedOutResolver<TParent = GQLCommentRevisionWordListMetadata, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentRevisionExternalModerationPhaseMetadataTypeResolver<TParent = GQLCommentRevisionExternalModerationPhaseMetadata> {
  name?: CommentRevisionExternalModerationPhaseMetadataToNameResolver<TParent>;
  analyzedAt?: CommentRevisionExternalModerationPhaseMetadataToAnalyzedAtResolver<TParent>;
  result?: CommentRevisionExternalModerationPhaseMetadataToResultResolver<TParent>;
}

export interface CommentRevisionExternalModerationPhaseMetadataToNameResolver<TParent = GQLCommentRevisionExternalModerationPhaseMetadata, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionExternalModerationPhaseMetadataToAnalyzedAtResolver<TParent = GQLCommentRevisionExternalModerationPhaseMetadata, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentRevisionExternalModerationPhaseMetadataToResultResolver<TParent = GQLCommentRevisionExternalModerationPhaseMetadata, TResult = GQLExternalModerationPhaseResult> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLExternalModerationPhaseResultTypeResolver<TParent = GQLExternalModerationPhaseResult> {
  status?: ExternalModerationPhaseResultToStatusResolver<TParent>;
  tags?: ExternalModerationPhaseResultToTagsResolver<TParent>;
  actions?: ExternalModerationPhaseResultToActionsResolver<TParent>;
}

export interface ExternalModerationPhaseResultToStatusResolver<TParent = GQLExternalModerationPhaseResult, TResult = GQLCOMMENT_STATUS | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalModerationPhaseResultToTagsResolver<TParent = GQLExternalModerationPhaseResult, TResult = Array<GQLTAG> | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalModerationPhaseResultToActionsResolver<TParent = GQLExternalModerationPhaseResult, TResult = Array<GQLExternalModerationPhaseAction> | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLExternalModerationPhaseActionTypeResolver<TParent = GQLExternalModerationPhaseAction> {
  reason?: ExternalModerationPhaseActionToReasonResolver<TParent>;
}

export interface ExternalModerationPhaseActionToReasonResolver<TParent = GQLExternalModerationPhaseAction, TResult = GQLCOMMENT_FLAG_REASON | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserTypeResolver<TParent = GQLUser> {
  id?: UserToIdResolver<TParent>;
  username?: UserToUsernameResolver<TParent>;
  avatar?: UserToAvatarResolver<TParent>;
  badges?: UserToBadgesResolver<TParent>;
  email?: UserToEmailResolver<TParent>;
  duplicateEmail?: UserToDuplicateEmailResolver<TParent>;
  emailVerified?: UserToEmailVerifiedResolver<TParent>;
  profiles?: UserToProfilesResolver<TParent>;
  role?: UserToRoleResolver<TParent>;
  moderatorNotes?: UserToModeratorNotesResolver<TParent>;
  ignoreable?: UserToIgnoreableResolver<TParent>;
  comments?: UserToCommentsResolver<TParent>;
  allComments?: UserToAllCommentsResolver<TParent>;
  rejectedComments?: UserToRejectedCommentsResolver<TParent>;
  ongoingDiscussions?: UserToOngoingDiscussionsResolver<TParent>;
  recentCommentHistory?: UserToRecentCommentHistoryResolver<TParent>;
  commentModerationActionHistory?: UserToCommentModerationActionHistoryResolver<TParent>;
  status?: UserToStatusResolver<TParent>;
  tokens?: UserToTokensResolver<TParent>;
  ignoredUsers?: UserToIgnoredUsersResolver<TParent>;
  notifications?: UserToNotificationsResolver<TParent>;
  createdAt?: UserToCreatedAtResolver<TParent>;
  lastDownloadedAt?: UserToLastDownloadedAtResolver<TParent>;
  scheduledDeletionDate?: UserToScheduledDeletionDateResolver<TParent>;
  deletedAt?: UserToDeletedAtResolver<TParent>;
  moderationScopes?: UserToModerationScopesResolver<TParent>;
  ssoURL?: UserToSsoURLResolver<TParent>;
  mediaSettings?: UserToMediaSettingsResolver<TParent>;
  bio?: UserToBioResolver<TParent>;
}

export interface UserToIdResolver<TParent = GQLUser, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToUsernameResolver<TParent = GQLUser, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToAvatarResolver<TParent = GQLUser, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToBadgesResolver<TParent = GQLUser, TResult = Array<string> | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToEmailResolver<TParent = GQLUser, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToDuplicateEmailResolver<TParent = GQLUser, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToEmailVerifiedResolver<TParent = GQLUser, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToProfilesResolver<TParent = GQLUser, TResult = Array<GQLProfile>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToRoleResolver<TParent = GQLUser, TResult = GQLUSER_ROLE> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToModeratorNotesResolver<TParent = GQLUser, TResult = Array<GQLModeratorNote>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIgnoreableResolver<TParent = GQLUser, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCommentsArgs {
  first?: number;
  orderBy?: GQLCOMMENT_SORT;
  after?: GQLCursor;
}
export interface UserToCommentsResolver<TParent = GQLUser, TResult = GQLCommentsConnection> {
  (parent: TParent, args: UserToCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToAllCommentsArgs {
  first?: number;
  after?: GQLCursor;
}
export interface UserToAllCommentsResolver<TParent = GQLUser, TResult = GQLCommentsConnection> {
  (parent: TParent, args: UserToAllCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToRejectedCommentsArgs {
  first?: number;
  after?: GQLCursor;
}
export interface UserToRejectedCommentsResolver<TParent = GQLUser, TResult = GQLCommentsConnection> {
  (parent: TParent, args: UserToRejectedCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToOngoingDiscussionsArgs {
  limit?: number;
}
export interface UserToOngoingDiscussionsResolver<TParent = GQLUser, TResult = Array<GQLStory>> {
  (parent: TParent, args: UserToOngoingDiscussionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToRecentCommentHistoryResolver<TParent = GQLUser, TResult = GQLRecentCommentHistory> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCommentModerationActionHistoryArgs {
  first?: number;
  after?: GQLCursor;
}
export interface UserToCommentModerationActionHistoryResolver<TParent = GQLUser, TResult = GQLCommentModerationActionConnection> {
  (parent: TParent, args: UserToCommentModerationActionHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToStatusResolver<TParent = GQLUser, TResult = GQLUserStatus> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToTokensResolver<TParent = GQLUser, TResult = Array<GQLToken>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIgnoredUsersResolver<TParent = GQLUser, TResult = Array<GQLUser>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotificationsResolver<TParent = GQLUser, TResult = GQLUserNotificationSettings> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCreatedAtResolver<TParent = GQLUser, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToLastDownloadedAtResolver<TParent = GQLUser, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToScheduledDeletionDateResolver<TParent = GQLUser, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToDeletedAtResolver<TParent = GQLUser, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToModerationScopesResolver<TParent = GQLUser, TResult = GQLUserModerationScopes | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToSsoURLResolver<TParent = GQLUser, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToMediaSettingsResolver<TParent = GQLUser, TResult = GQLUserMediaSettings> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToBioResolver<TParent = GQLUser, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLProfileTypeResolver<TParent = GQLProfile> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'LocalProfile' | 'OIDCProfile' | 'SSOProfile' | 'FacebookProfile' | 'GoogleProfile';
}
export interface GQLLocalProfileTypeResolver<TParent = GQLLocalProfile> {
  id?: LocalProfileToIdResolver<TParent>;
}

export interface LocalProfileToIdResolver<TParent = GQLLocalProfile, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLOIDCProfileTypeResolver<TParent = GQLOIDCProfile> {
  id?: OIDCProfileToIdResolver<TParent>;
  provider?: OIDCProfileToProviderResolver<TParent>;
}

export interface OIDCProfileToIdResolver<TParent = GQLOIDCProfile, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCProfileToProviderResolver<TParent = GQLOIDCProfile, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSSOProfileTypeResolver<TParent = GQLSSOProfile> {
  id?: SSOProfileToIdResolver<TParent>;
}

export interface SSOProfileToIdResolver<TParent = GQLSSOProfile, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFacebookProfileTypeResolver<TParent = GQLFacebookProfile> {
  id?: FacebookProfileToIdResolver<TParent>;
}

export interface FacebookProfileToIdResolver<TParent = GQLFacebookProfile, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGoogleProfileTypeResolver<TParent = GQLGoogleProfile> {
  id?: GoogleProfileToIdResolver<TParent>;
}

export interface GoogleProfileToIdResolver<TParent = GQLGoogleProfile, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLModeratorNoteTypeResolver<TParent = GQLModeratorNote> {
  id?: ModeratorNoteToIdResolver<TParent>;
  body?: ModeratorNoteToBodyResolver<TParent>;
  createdAt?: ModeratorNoteToCreatedAtResolver<TParent>;
  createdBy?: ModeratorNoteToCreatedByResolver<TParent>;
}

export interface ModeratorNoteToIdResolver<TParent = GQLModeratorNote, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ModeratorNoteToBodyResolver<TParent = GQLModeratorNote, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ModeratorNoteToCreatedAtResolver<TParent = GQLModeratorNote, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ModeratorNoteToCreatedByResolver<TParent = GQLModeratorNote, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentsConnectionTypeResolver<TParent = GQLCommentsConnection> {
  edges?: CommentsConnectionToEdgesResolver<TParent>;
  nodes?: CommentsConnectionToNodesResolver<TParent>;
  pageInfo?: CommentsConnectionToPageInfoResolver<TParent>;
}

export interface CommentsConnectionToEdgesResolver<TParent = GQLCommentsConnection, TResult = Array<GQLCommentEdge>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentsConnectionToNodesResolver<TParent = GQLCommentsConnection, TResult = Array<GQLComment>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentsConnectionToPageInfoResolver<TParent = GQLCommentsConnection, TResult = GQLPageInfo> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentEdgeTypeResolver<TParent = GQLCommentEdge> {
  node?: CommentEdgeToNodeResolver<TParent>;
  cursor?: CommentEdgeToCursorResolver<TParent>;
}

export interface CommentEdgeToNodeResolver<TParent = GQLCommentEdge, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentEdgeToCursorResolver<TParent = GQLCommentEdge, TResult = GQLCursor> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPageInfoTypeResolver<TParent = GQLPageInfo> {
  hasNextPage?: PageInfoToHasNextPageResolver<TParent>;
  hasPreviousPage?: PageInfoToHasPreviousPageResolver<TParent>;
  startCursor?: PageInfoToStartCursorResolver<TParent>;
  endCursor?: PageInfoToEndCursorResolver<TParent>;
}

export interface PageInfoToHasNextPageResolver<TParent = GQLPageInfo, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToHasPreviousPageResolver<TParent = GQLPageInfo, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToStartCursorResolver<TParent = GQLPageInfo, TResult = GQLCursor | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToEndCursorResolver<TParent = GQLPageInfo, TResult = GQLCursor | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStoryTypeResolver<TParent = GQLStory> {
  id?: StoryToIdResolver<TParent>;
  status?: StoryToStatusResolver<TParent>;
  url?: StoryToUrlResolver<TParent>;
  metadata?: StoryToMetadataResolver<TParent>;
  scrapedAt?: StoryToScrapedAtResolver<TParent>;
  featuredComments?: StoryToFeaturedCommentsResolver<TParent>;
  comments?: StoryToCommentsResolver<TParent>;
  commentActionCounts?: StoryToCommentActionCountsResolver<TParent>;
  moderationQueues?: StoryToModerationQueuesResolver<TParent>;
  closedAt?: StoryToClosedAtResolver<TParent>;
  isClosed?: StoryToIsClosedResolver<TParent>;
  commentCounts?: StoryToCommentCountsResolver<TParent>;
  createdAt?: StoryToCreatedAtResolver<TParent>;
  settings?: StoryToSettingsResolver<TParent>;
  lastCommentedAt?: StoryToLastCommentedAtResolver<TParent>;
  canModerate?: StoryToCanModerateResolver<TParent>;
  site?: StoryToSiteResolver<TParent>;
  viewerCount?: StoryToViewerCountResolver<TParent>;
  ratings?: StoryToRatingsResolver<TParent>;
  viewerRating?: StoryToViewerRatingResolver<TParent>;
}

export interface StoryToIdResolver<TParent = GQLStory, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToStatusResolver<TParent = GQLStory, TResult = GQLSTORY_STATUS> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToUrlResolver<TParent = GQLStory, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToMetadataResolver<TParent = GQLStory, TResult = GQLStoryMetadata | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToScrapedAtResolver<TParent = GQLStory, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToFeaturedCommentsArgs {
  first?: number;
  orderBy?: GQLCOMMENT_SORT;
  after?: GQLCursor;
}
export interface StoryToFeaturedCommentsResolver<TParent = GQLStory, TResult = GQLCommentsConnection> {
  (parent: TParent, args: StoryToFeaturedCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToCommentsArgs {
  first?: number;
  orderBy?: GQLCOMMENT_SORT;
  after?: GQLCursor;
  rating?: number;
  tag?: GQLTAG;
}
export interface StoryToCommentsResolver<TParent = GQLStory, TResult = GQLCommentsConnection> {
  (parent: TParent, args: StoryToCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToCommentActionCountsResolver<TParent = GQLStory, TResult = GQLActionCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToModerationQueuesResolver<TParent = GQLStory, TResult = GQLModerationQueues> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToClosedAtResolver<TParent = GQLStory, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToIsClosedResolver<TParent = GQLStory, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToCommentCountsResolver<TParent = GQLStory, TResult = GQLCommentCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToCreatedAtResolver<TParent = GQLStory, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToSettingsResolver<TParent = GQLStory, TResult = GQLStorySettings> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToLastCommentedAtResolver<TParent = GQLStory, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToCanModerateResolver<TParent = GQLStory, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToSiteResolver<TParent = GQLStory, TResult = GQLSite> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToViewerCountResolver<TParent = GQLStory, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToRatingsResolver<TParent = GQLStory, TResult = GQLStoryRatings | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryToViewerRatingResolver<TParent = GQLStory, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStoryMetadataTypeResolver<TParent = GQLStoryMetadata> {
  title?: StoryMetadataToTitleResolver<TParent>;
  author?: StoryMetadataToAuthorResolver<TParent>;
  description?: StoryMetadataToDescriptionResolver<TParent>;
  image?: StoryMetadataToImageResolver<TParent>;
  publishedAt?: StoryMetadataToPublishedAtResolver<TParent>;
  modifiedAt?: StoryMetadataToModifiedAtResolver<TParent>;
  section?: StoryMetadataToSectionResolver<TParent>;
}

export interface StoryMetadataToTitleResolver<TParent = GQLStoryMetadata, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryMetadataToAuthorResolver<TParent = GQLStoryMetadata, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryMetadataToDescriptionResolver<TParent = GQLStoryMetadata, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryMetadataToImageResolver<TParent = GQLStoryMetadata, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryMetadataToPublishedAtResolver<TParent = GQLStoryMetadata, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryMetadataToModifiedAtResolver<TParent = GQLStoryMetadata, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryMetadataToSectionResolver<TParent = GQLStoryMetadata, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLModerationQueuesTypeResolver<TParent = GQLModerationQueues> {
  unmoderated?: ModerationQueuesToUnmoderatedResolver<TParent>;
  reported?: ModerationQueuesToReportedResolver<TParent>;
  pending?: ModerationQueuesToPendingResolver<TParent>;
}

export interface ModerationQueuesToUnmoderatedResolver<TParent = GQLModerationQueues, TResult = GQLModerationQueue> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ModerationQueuesToReportedResolver<TParent = GQLModerationQueues, TResult = GQLModerationQueue> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ModerationQueuesToPendingResolver<TParent = GQLModerationQueues, TResult = GQLModerationQueue> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLModerationQueueTypeResolver<TParent = GQLModerationQueue> {
  id?: ModerationQueueToIdResolver<TParent>;
  count?: ModerationQueueToCountResolver<TParent>;
  comments?: ModerationQueueToCommentsResolver<TParent>;
}

export interface ModerationQueueToIdResolver<TParent = GQLModerationQueue, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ModerationQueueToCountResolver<TParent = GQLModerationQueue, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ModerationQueueToCommentsArgs {
  first?: number;
  after?: GQLCursor;
  orderBy?: GQLCOMMENT_SORT;
}
export interface ModerationQueueToCommentsResolver<TParent = GQLModerationQueue, TResult = GQLCommentsConnection> {
  (parent: TParent, args: ModerationQueueToCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentCountsTypeResolver<TParent = GQLCommentCounts> {
  totalPublished?: CommentCountsToTotalPublishedResolver<TParent>;
  tags?: CommentCountsToTagsResolver<TParent>;
  statuses?: CommentCountsToStatusesResolver<TParent>;
}

export interface CommentCountsToTotalPublishedResolver<TParent = GQLCommentCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentCountsToTagsResolver<TParent = GQLCommentCounts, TResult = GQLCommentTagCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentCountsToStatusesResolver<TParent = GQLCommentCounts, TResult = GQLCommentStatusCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentTagCountsTypeResolver<TParent = GQLCommentTagCounts> {
  FEATURED?: CommentTagCountsToFEATUREDResolver<TParent>;
  UNANSWERED?: CommentTagCountsToUNANSWEREDResolver<TParent>;
  REVIEW?: CommentTagCountsToREVIEWResolver<TParent>;
  QUESTION?: CommentTagCountsToQUESTIONResolver<TParent>;
}

export interface CommentTagCountsToFEATUREDResolver<TParent = GQLCommentTagCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentTagCountsToUNANSWEREDResolver<TParent = GQLCommentTagCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentTagCountsToREVIEWResolver<TParent = GQLCommentTagCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentTagCountsToQUESTIONResolver<TParent = GQLCommentTagCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentStatusCountsTypeResolver<TParent = GQLCommentStatusCounts> {
  NONE?: CommentStatusCountsToNONEResolver<TParent>;
  APPROVED?: CommentStatusCountsToAPPROVEDResolver<TParent>;
  REJECTED?: CommentStatusCountsToREJECTEDResolver<TParent>;
  PREMOD?: CommentStatusCountsToPREMODResolver<TParent>;
  SYSTEM_WITHHELD?: CommentStatusCountsToSYSTEM_WITHHELDResolver<TParent>;
}

export interface CommentStatusCountsToNONEResolver<TParent = GQLCommentStatusCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentStatusCountsToAPPROVEDResolver<TParent = GQLCommentStatusCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentStatusCountsToREJECTEDResolver<TParent = GQLCommentStatusCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentStatusCountsToPREMODResolver<TParent = GQLCommentStatusCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentStatusCountsToSYSTEM_WITHHELDResolver<TParent = GQLCommentStatusCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStorySettingsTypeResolver<TParent = GQLStorySettings> {
  live?: StorySettingsToLiveResolver<TParent>;
  moderation?: StorySettingsToModerationResolver<TParent>;
  premodLinksEnable?: StorySettingsToPremodLinksEnableResolver<TParent>;
  messageBox?: StorySettingsToMessageBoxResolver<TParent>;
  mode?: StorySettingsToModeResolver<TParent>;
  experts?: StorySettingsToExpertsResolver<TParent>;
}

export interface StorySettingsToLiveResolver<TParent = GQLStorySettings, TResult = GQLLiveConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StorySettingsToModerationResolver<TParent = GQLStorySettings, TResult = GQLMODERATION_MODE> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StorySettingsToPremodLinksEnableResolver<TParent = GQLStorySettings, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StorySettingsToMessageBoxResolver<TParent = GQLStorySettings, TResult = GQLStoryMessageBox> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StorySettingsToModeResolver<TParent = GQLStorySettings, TResult = GQLSTORY_MODE> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StorySettingsToExpertsResolver<TParent = GQLStorySettings, TResult = Array<GQLUser>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLiveConfigurationTypeResolver<TParent = GQLLiveConfiguration> {
  configurable?: LiveConfigurationToConfigurableResolver<TParent>;
  enabled?: LiveConfigurationToEnabledResolver<TParent>;
}

export interface LiveConfigurationToConfigurableResolver<TParent = GQLLiveConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LiveConfigurationToEnabledResolver<TParent = GQLLiveConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStoryMessageBoxTypeResolver<TParent = GQLStoryMessageBox> {
  enabled?: StoryMessageBoxToEnabledResolver<TParent>;
  icon?: StoryMessageBoxToIconResolver<TParent>;
  content?: StoryMessageBoxToContentResolver<TParent>;
}

export interface StoryMessageBoxToEnabledResolver<TParent = GQLStoryMessageBox, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryMessageBoxToIconResolver<TParent = GQLStoryMessageBox, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryMessageBoxToContentResolver<TParent = GQLStoryMessageBox, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSiteTypeResolver<TParent = GQLSite> {
  id?: SiteToIdResolver<TParent>;
  name?: SiteToNameResolver<TParent>;
  allowedOrigins?: SiteToAllowedOriginsResolver<TParent>;
  canModerate?: SiteToCanModerateResolver<TParent>;
  topStories?: SiteToTopStoriesResolver<TParent>;
  createdAt?: SiteToCreatedAtResolver<TParent>;
}

export interface SiteToIdResolver<TParent = GQLSite, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SiteToNameResolver<TParent = GQLSite, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SiteToAllowedOriginsResolver<TParent = GQLSite, TResult = Array<string>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SiteToCanModerateResolver<TParent = GQLSite, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SiteToTopStoriesArgs {
  limit?: number;
}
export interface SiteToTopStoriesResolver<TParent = GQLSite, TResult = Array<GQLStory>> {
  (parent: TParent, args: SiteToTopStoriesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SiteToCreatedAtResolver<TParent = GQLSite, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStoryRatingsTypeResolver<TParent = GQLStoryRatings> {
  average?: StoryRatingsToAverageResolver<TParent>;
  count?: StoryRatingsToCountResolver<TParent>;
}

export interface StoryRatingsToAverageResolver<TParent = GQLStoryRatings, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryRatingsToCountResolver<TParent = GQLStoryRatings, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRecentCommentHistoryTypeResolver<TParent = GQLRecentCommentHistory> {
  statuses?: RecentCommentHistoryToStatusesResolver<TParent>;
}

export interface RecentCommentHistoryToStatusesResolver<TParent = GQLRecentCommentHistory, TResult = GQLCommentStatusCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentModerationActionConnectionTypeResolver<TParent = GQLCommentModerationActionConnection> {
  edges?: CommentModerationActionConnectionToEdgesResolver<TParent>;
  nodes?: CommentModerationActionConnectionToNodesResolver<TParent>;
  pageInfo?: CommentModerationActionConnectionToPageInfoResolver<TParent>;
}

export interface CommentModerationActionConnectionToEdgesResolver<TParent = GQLCommentModerationActionConnection, TResult = Array<GQLCommentModerationActionEdge>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentModerationActionConnectionToNodesResolver<TParent = GQLCommentModerationActionConnection, TResult = Array<GQLCommentModerationAction>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentModerationActionConnectionToPageInfoResolver<TParent = GQLCommentModerationActionConnection, TResult = GQLPageInfo> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentModerationActionEdgeTypeResolver<TParent = GQLCommentModerationActionEdge> {
  node?: CommentModerationActionEdgeToNodeResolver<TParent>;
  cursor?: CommentModerationActionEdgeToCursorResolver<TParent>;
}

export interface CommentModerationActionEdgeToNodeResolver<TParent = GQLCommentModerationActionEdge, TResult = GQLCommentModerationAction> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentModerationActionEdgeToCursorResolver<TParent = GQLCommentModerationActionEdge, TResult = GQLCursor> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentModerationActionTypeResolver<TParent = GQLCommentModerationAction> {
  id?: CommentModerationActionToIdResolver<TParent>;
  revision?: CommentModerationActionToRevisionResolver<TParent>;
  status?: CommentModerationActionToStatusResolver<TParent>;
  moderator?: CommentModerationActionToModeratorResolver<TParent>;
  createdAt?: CommentModerationActionToCreatedAtResolver<TParent>;
}

export interface CommentModerationActionToIdResolver<TParent = GQLCommentModerationAction, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentModerationActionToRevisionResolver<TParent = GQLCommentModerationAction, TResult = GQLCommentRevision> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentModerationActionToStatusResolver<TParent = GQLCommentModerationAction, TResult = GQLCOMMENT_STATUS> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentModerationActionToModeratorResolver<TParent = GQLCommentModerationAction, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentModerationActionToCreatedAtResolver<TParent = GQLCommentModerationAction, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserStatusTypeResolver<TParent = GQLUserStatus> {
  current?: UserStatusToCurrentResolver<TParent>;
  username?: UserStatusToUsernameResolver<TParent>;
  ban?: UserStatusToBanResolver<TParent>;
  suspension?: UserStatusToSuspensionResolver<TParent>;
  premod?: UserStatusToPremodResolver<TParent>;
  warning?: UserStatusToWarningResolver<TParent>;
}

export interface UserStatusToCurrentResolver<TParent = GQLUserStatus, TResult = Array<GQLUSER_STATUS>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserStatusToUsernameResolver<TParent = GQLUserStatus, TResult = GQLUsernameStatus> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserStatusToBanResolver<TParent = GQLUserStatus, TResult = GQLBanStatus> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserStatusToSuspensionResolver<TParent = GQLUserStatus, TResult = GQLSuspensionStatus> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserStatusToPremodResolver<TParent = GQLUserStatus, TResult = GQLPremodStatus> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserStatusToWarningResolver<TParent = GQLUserStatus, TResult = GQLWarningStatus> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUsernameStatusTypeResolver<TParent = GQLUsernameStatus> {
  history?: UsernameStatusToHistoryResolver<TParent>;
}

export interface UsernameStatusToHistoryResolver<TParent = GQLUsernameStatus, TResult = Array<GQLUsernameHistory>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUsernameHistoryTypeResolver<TParent = GQLUsernameHistory> {
  username?: UsernameHistoryToUsernameResolver<TParent>;
  createdBy?: UsernameHistoryToCreatedByResolver<TParent>;
  createdAt?: UsernameHistoryToCreatedAtResolver<TParent>;
}

export interface UsernameHistoryToUsernameResolver<TParent = GQLUsernameHistory, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UsernameHistoryToCreatedByResolver<TParent = GQLUsernameHistory, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UsernameHistoryToCreatedAtResolver<TParent = GQLUsernameHistory, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBanStatusTypeResolver<TParent = GQLBanStatus> {
  active?: BanStatusToActiveResolver<TParent>;
  sites?: BanStatusToSitesResolver<TParent>;
  history?: BanStatusToHistoryResolver<TParent>;
}

export interface BanStatusToActiveResolver<TParent = GQLBanStatus, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BanStatusToSitesResolver<TParent = GQLBanStatus, TResult = Array<GQLSite> | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BanStatusToHistoryResolver<TParent = GQLBanStatus, TResult = Array<GQLBanStatusHistory>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBanStatusHistoryTypeResolver<TParent = GQLBanStatusHistory> {
  active?: BanStatusHistoryToActiveResolver<TParent>;
  createdBy?: BanStatusHistoryToCreatedByResolver<TParent>;
  createdAt?: BanStatusHistoryToCreatedAtResolver<TParent>;
  message?: BanStatusHistoryToMessageResolver<TParent>;
  sites?: BanStatusHistoryToSitesResolver<TParent>;
}

export interface BanStatusHistoryToActiveResolver<TParent = GQLBanStatusHistory, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BanStatusHistoryToCreatedByResolver<TParent = GQLBanStatusHistory, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BanStatusHistoryToCreatedAtResolver<TParent = GQLBanStatusHistory, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BanStatusHistoryToMessageResolver<TParent = GQLBanStatusHistory, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BanStatusHistoryToSitesResolver<TParent = GQLBanStatusHistory, TResult = Array<GQLSite> | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSuspensionStatusTypeResolver<TParent = GQLSuspensionStatus> {
  active?: SuspensionStatusToActiveResolver<TParent>;
  until?: SuspensionStatusToUntilResolver<TParent>;
  history?: SuspensionStatusToHistoryResolver<TParent>;
}

export interface SuspensionStatusToActiveResolver<TParent = GQLSuspensionStatus, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SuspensionStatusToUntilResolver<TParent = GQLSuspensionStatus, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SuspensionStatusToHistoryResolver<TParent = GQLSuspensionStatus, TResult = Array<GQLSuspensionStatusHistory>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSuspensionStatusHistoryTypeResolver<TParent = GQLSuspensionStatusHistory> {
  active?: SuspensionStatusHistoryToActiveResolver<TParent>;
  from?: SuspensionStatusHistoryToFromResolver<TParent>;
  createdBy?: SuspensionStatusHistoryToCreatedByResolver<TParent>;
  createdAt?: SuspensionStatusHistoryToCreatedAtResolver<TParent>;
  modifiedBy?: SuspensionStatusHistoryToModifiedByResolver<TParent>;
  modifiedAt?: SuspensionStatusHistoryToModifiedAtResolver<TParent>;
  message?: SuspensionStatusHistoryToMessageResolver<TParent>;
}

export interface SuspensionStatusHistoryToActiveResolver<TParent = GQLSuspensionStatusHistory, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SuspensionStatusHistoryToFromResolver<TParent = GQLSuspensionStatusHistory, TResult = GQLTimeRange> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SuspensionStatusHistoryToCreatedByResolver<TParent = GQLSuspensionStatusHistory, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SuspensionStatusHistoryToCreatedAtResolver<TParent = GQLSuspensionStatusHistory, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SuspensionStatusHistoryToModifiedByResolver<TParent = GQLSuspensionStatusHistory, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SuspensionStatusHistoryToModifiedAtResolver<TParent = GQLSuspensionStatusHistory, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SuspensionStatusHistoryToMessageResolver<TParent = GQLSuspensionStatusHistory, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTimeRangeTypeResolver<TParent = GQLTimeRange> {
  start?: TimeRangeToStartResolver<TParent>;
  finish?: TimeRangeToFinishResolver<TParent>;
}

export interface TimeRangeToStartResolver<TParent = GQLTimeRange, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TimeRangeToFinishResolver<TParent = GQLTimeRange, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPremodStatusTypeResolver<TParent = GQLPremodStatus> {
  active?: PremodStatusToActiveResolver<TParent>;
  history?: PremodStatusToHistoryResolver<TParent>;
}

export interface PremodStatusToActiveResolver<TParent = GQLPremodStatus, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PremodStatusToHistoryResolver<TParent = GQLPremodStatus, TResult = Array<GQLPremodStatusHistory>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPremodStatusHistoryTypeResolver<TParent = GQLPremodStatusHistory> {
  active?: PremodStatusHistoryToActiveResolver<TParent>;
  createdBy?: PremodStatusHistoryToCreatedByResolver<TParent>;
  createdAt?: PremodStatusHistoryToCreatedAtResolver<TParent>;
}

export interface PremodStatusHistoryToActiveResolver<TParent = GQLPremodStatusHistory, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PremodStatusHistoryToCreatedByResolver<TParent = GQLPremodStatusHistory, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PremodStatusHistoryToCreatedAtResolver<TParent = GQLPremodStatusHistory, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWarningStatusTypeResolver<TParent = GQLWarningStatus> {
  active?: WarningStatusToActiveResolver<TParent>;
  message?: WarningStatusToMessageResolver<TParent>;
  history?: WarningStatusToHistoryResolver<TParent>;
}

export interface WarningStatusToActiveResolver<TParent = GQLWarningStatus, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WarningStatusToMessageResolver<TParent = GQLWarningStatus, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WarningStatusToHistoryResolver<TParent = GQLWarningStatus, TResult = Array<GQLWarningStatusHistory>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWarningStatusHistoryTypeResolver<TParent = GQLWarningStatusHistory> {
  active?: WarningStatusHistoryToActiveResolver<TParent>;
  createdBy?: WarningStatusHistoryToCreatedByResolver<TParent>;
  createdAt?: WarningStatusHistoryToCreatedAtResolver<TParent>;
  acknowledgedAt?: WarningStatusHistoryToAcknowledgedAtResolver<TParent>;
  message?: WarningStatusHistoryToMessageResolver<TParent>;
}

export interface WarningStatusHistoryToActiveResolver<TParent = GQLWarningStatusHistory, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WarningStatusHistoryToCreatedByResolver<TParent = GQLWarningStatusHistory, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WarningStatusHistoryToCreatedAtResolver<TParent = GQLWarningStatusHistory, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WarningStatusHistoryToAcknowledgedAtResolver<TParent = GQLWarningStatusHistory, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WarningStatusHistoryToMessageResolver<TParent = GQLWarningStatusHistory, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTokenTypeResolver<TParent = GQLToken> {
  id?: TokenToIdResolver<TParent>;
  name?: TokenToNameResolver<TParent>;
  createdAt?: TokenToCreatedAtResolver<TParent>;
}

export interface TokenToIdResolver<TParent = GQLToken, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TokenToNameResolver<TParent = GQLToken, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TokenToCreatedAtResolver<TParent = GQLToken, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserNotificationSettingsTypeResolver<TParent = GQLUserNotificationSettings> {
  onReply?: UserNotificationSettingsToOnReplyResolver<TParent>;
  onFeatured?: UserNotificationSettingsToOnFeaturedResolver<TParent>;
  onStaffReplies?: UserNotificationSettingsToOnStaffRepliesResolver<TParent>;
  onModeration?: UserNotificationSettingsToOnModerationResolver<TParent>;
  digestFrequency?: UserNotificationSettingsToDigestFrequencyResolver<TParent>;
}

export interface UserNotificationSettingsToOnReplyResolver<TParent = GQLUserNotificationSettings, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserNotificationSettingsToOnFeaturedResolver<TParent = GQLUserNotificationSettings, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserNotificationSettingsToOnStaffRepliesResolver<TParent = GQLUserNotificationSettings, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserNotificationSettingsToOnModerationResolver<TParent = GQLUserNotificationSettings, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserNotificationSettingsToDigestFrequencyResolver<TParent = GQLUserNotificationSettings, TResult = GQLDIGEST_FREQUENCY> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserModerationScopesTypeResolver<TParent = GQLUserModerationScopes> {
  scoped?: UserModerationScopesToScopedResolver<TParent>;
  sites?: UserModerationScopesToSitesResolver<TParent>;
}

export interface UserModerationScopesToScopedResolver<TParent = GQLUserModerationScopes, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserModerationScopesToSitesResolver<TParent = GQLUserModerationScopes, TResult = Array<GQLSite> | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserMediaSettingsTypeResolver<TParent = GQLUserMediaSettings> {
  unfurlEmbeds?: UserMediaSettingsToUnfurlEmbedsResolver<TParent>;
}

export interface UserMediaSettingsToUnfurlEmbedsResolver<TParent = GQLUserMediaSettings, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEditInfoTypeResolver<TParent = GQLEditInfo> {
  edited?: EditInfoToEditedResolver<TParent>;
  editableUntil?: EditInfoToEditableUntilResolver<TParent>;
}

export interface EditInfoToEditedResolver<TParent = GQLEditInfo, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EditInfoToEditableUntilResolver<TParent = GQLEditInfo, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReactionsConnectionTypeResolver<TParent = GQLReactionsConnection> {
  edges?: ReactionsConnectionToEdgesResolver<TParent>;
  nodes?: ReactionsConnectionToNodesResolver<TParent>;
  pageInfo?: ReactionsConnectionToPageInfoResolver<TParent>;
}

export interface ReactionsConnectionToEdgesResolver<TParent = GQLReactionsConnection, TResult = Array<GQLReactionEdge>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReactionsConnectionToNodesResolver<TParent = GQLReactionsConnection, TResult = Array<GQLReaction>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReactionsConnectionToPageInfoResolver<TParent = GQLReactionsConnection, TResult = GQLPageInfo> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReactionEdgeTypeResolver<TParent = GQLReactionEdge> {
  node?: ReactionEdgeToNodeResolver<TParent>;
  cursor?: ReactionEdgeToCursorResolver<TParent>;
}

export interface ReactionEdgeToNodeResolver<TParent = GQLReactionEdge, TResult = GQLReaction> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReactionEdgeToCursorResolver<TParent = GQLReactionEdge, TResult = GQLCursor> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReactionTypeResolver<TParent = GQLReaction> {
  id?: ReactionToIdResolver<TParent>;
  reacter?: ReactionToReacterResolver<TParent>;
}

export interface ReactionToIdResolver<TParent = GQLReaction, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReactionToReacterResolver<TParent = GQLReaction, TResult = GQLReacter | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReacterTypeResolver<TParent = GQLReacter> {
  username?: ReacterToUsernameResolver<TParent>;
  userID?: ReacterToUserIDResolver<TParent>;
}

export interface ReacterToUsernameResolver<TParent = GQLReacter, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReacterToUserIDResolver<TParent = GQLReacter, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFlagsConnectionTypeResolver<TParent = GQLFlagsConnection> {
  edges?: FlagsConnectionToEdgesResolver<TParent>;
  nodes?: FlagsConnectionToNodesResolver<TParent>;
  pageInfo?: FlagsConnectionToPageInfoResolver<TParent>;
}

export interface FlagsConnectionToEdgesResolver<TParent = GQLFlagsConnection, TResult = Array<GQLFlagEdge>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagsConnectionToNodesResolver<TParent = GQLFlagsConnection, TResult = Array<GQLFlag>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagsConnectionToPageInfoResolver<TParent = GQLFlagsConnection, TResult = GQLPageInfo> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFlagEdgeTypeResolver<TParent = GQLFlagEdge> {
  node?: FlagEdgeToNodeResolver<TParent>;
  cursor?: FlagEdgeToCursorResolver<TParent>;
}

export interface FlagEdgeToNodeResolver<TParent = GQLFlagEdge, TResult = GQLFlag> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagEdgeToCursorResolver<TParent = GQLFlagEdge, TResult = GQLCursor> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFlagTypeResolver<TParent = GQLFlag> {
  id?: FlagToIdResolver<TParent>;
  flagger?: FlagToFlaggerResolver<TParent>;
  comment?: FlagToCommentResolver<TParent>;
  revision?: FlagToRevisionResolver<TParent>;
  reason?: FlagToReasonResolver<TParent>;
  additionalDetails?: FlagToAdditionalDetailsResolver<TParent>;
  reviewed?: FlagToReviewedResolver<TParent>;
  createdAt?: FlagToCreatedAtResolver<TParent>;
}

export interface FlagToIdResolver<TParent = GQLFlag, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagToFlaggerResolver<TParent = GQLFlag, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagToCommentResolver<TParent = GQLFlag, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagToRevisionResolver<TParent = GQLFlag, TResult = GQLCommentRevision | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagToReasonResolver<TParent = GQLFlag, TResult = GQLCOMMENT_FLAG_REASON | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagToAdditionalDetailsResolver<TParent = GQLFlag, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagToReviewedResolver<TParent = GQLFlag, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FlagToCreatedAtResolver<TParent = GQLFlag, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLActionPresenceTypeResolver<TParent = GQLActionPresence> {
  reaction?: ActionPresenceToReactionResolver<TParent>;
  dontAgree?: ActionPresenceToDontAgreeResolver<TParent>;
  flag?: ActionPresenceToFlagResolver<TParent>;
}

export interface ActionPresenceToReactionResolver<TParent = GQLActionPresence, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActionPresenceToDontAgreeResolver<TParent = GQLActionPresence, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActionPresenceToFlagResolver<TParent = GQLActionPresence, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTagTypeResolver<TParent = GQLTag> {
  code?: TagToCodeResolver<TParent>;
  createdBy?: TagToCreatedByResolver<TParent>;
  createdAt?: TagToCreatedAtResolver<TParent>;
}

export interface TagToCodeResolver<TParent = GQLTag, TResult = GQLTAG> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TagToCreatedByResolver<TParent = GQLTag, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TagToCreatedAtResolver<TParent = GQLTag, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStoriesConnectionTypeResolver<TParent = GQLStoriesConnection> {
  edges?: StoriesConnectionToEdgesResolver<TParent>;
  nodes?: StoriesConnectionToNodesResolver<TParent>;
  pageInfo?: StoriesConnectionToPageInfoResolver<TParent>;
}

export interface StoriesConnectionToEdgesResolver<TParent = GQLStoriesConnection, TResult = Array<GQLStoryEdge>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoriesConnectionToNodesResolver<TParent = GQLStoriesConnection, TResult = Array<GQLStory>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoriesConnectionToPageInfoResolver<TParent = GQLStoriesConnection, TResult = GQLPageInfo> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStoryEdgeTypeResolver<TParent = GQLStoryEdge> {
  node?: StoryEdgeToNodeResolver<TParent>;
  cursor?: StoryEdgeToCursorResolver<TParent>;
}

export interface StoryEdgeToNodeResolver<TParent = GQLStoryEdge, TResult = GQLStory> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryEdgeToCursorResolver<TParent = GQLStoryEdge, TResult = GQLCursor> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUsersConnectionTypeResolver<TParent = GQLUsersConnection> {
  edges?: UsersConnectionToEdgesResolver<TParent>;
  nodes?: UsersConnectionToNodesResolver<TParent>;
  pageInfo?: UsersConnectionToPageInfoResolver<TParent>;
}

export interface UsersConnectionToEdgesResolver<TParent = GQLUsersConnection, TResult = Array<GQLUserEdge>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UsersConnectionToNodesResolver<TParent = GQLUsersConnection, TResult = Array<GQLUser>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UsersConnectionToPageInfoResolver<TParent = GQLUsersConnection, TResult = GQLPageInfo> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserEdgeTypeResolver<TParent = GQLUserEdge> {
  node?: UserEdgeToNodeResolver<TParent>;
  cursor?: UserEdgeToCursorResolver<TParent>;
}

export interface UserEdgeToNodeResolver<TParent = GQLUserEdge, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserEdgeToCursorResolver<TParent = GQLUserEdge, TResult = GQLCursor> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSitesConnectionTypeResolver<TParent = GQLSitesConnection> {
  edges?: SitesConnectionToEdgesResolver<TParent>;
  nodes?: SitesConnectionToNodesResolver<TParent>;
  pageInfo?: SitesConnectionToPageInfoResolver<TParent>;
}

export interface SitesConnectionToEdgesResolver<TParent = GQLSitesConnection, TResult = Array<GQLSiteEdge>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SitesConnectionToNodesResolver<TParent = GQLSitesConnection, TResult = Array<GQLSite>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SitesConnectionToPageInfoResolver<TParent = GQLSitesConnection, TResult = GQLPageInfo> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSiteEdgeTypeResolver<TParent = GQLSiteEdge> {
  node?: SiteEdgeToNodeResolver<TParent>;
  cursor?: SiteEdgeToCursorResolver<TParent>;
}

export interface SiteEdgeToNodeResolver<TParent = GQLSiteEdge, TResult = GQLSite> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SiteEdgeToCursorResolver<TParent = GQLSiteEdge, TResult = GQLCursor> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSettingsTypeResolver<TParent = GQLSettings> {
  id?: SettingsToIdResolver<TParent>;
  domain?: SettingsToDomainResolver<TParent>;
  webhooks?: SettingsToWebhooksResolver<TParent>;
  webhookEvents?: SettingsToWebhookEventsResolver<TParent>;
  staticURI?: SettingsToStaticURIResolver<TParent>;
  locale?: SettingsToLocaleResolver<TParent>;
  live?: SettingsToLiveResolver<TParent>;
  moderation?: SettingsToModerationResolver<TParent>;
  communityGuidelines?: SettingsToCommunityGuidelinesResolver<TParent>;
  premodLinksEnable?: SettingsToPremodLinksEnableResolver<TParent>;
  closeCommenting?: SettingsToCloseCommentingResolver<TParent>;
  customCSSURL?: SettingsToCustomCSSURLResolver<TParent>;
  disableCommenting?: SettingsToDisableCommentingResolver<TParent>;
  editCommentWindowLength?: SettingsToEditCommentWindowLengthResolver<TParent>;
  charCount?: SettingsToCharCountResolver<TParent>;
  organization?: SettingsToOrganizationResolver<TParent>;
  email?: SettingsToEmailResolver<TParent>;
  slack?: SettingsToSlackResolver<TParent>;
  wordList?: SettingsToWordListResolver<TParent>;
  auth?: SettingsToAuthResolver<TParent>;
  integrations?: SettingsToIntegrationsResolver<TParent>;
  recentCommentHistory?: SettingsToRecentCommentHistoryResolver<TParent>;
  reaction?: SettingsToReactionResolver<TParent>;
  staff?: SettingsToStaffResolver<TParent>;
  accountFeatures?: SettingsToAccountFeaturesResolver<TParent>;
  stories?: SettingsToStoriesResolver<TParent>;
  media?: SettingsToMediaResolver<TParent>;
  featureFlags?: SettingsToFeatureFlagsResolver<TParent>;
  createdAt?: SettingsToCreatedAtResolver<TParent>;
  newCommenters?: SettingsToNewCommentersResolver<TParent>;
  premoderateSuspectWords?: SettingsToPremoderateSuspectWordsResolver<TParent>;
  announcement?: SettingsToAnnouncementResolver<TParent>;
  multisite?: SettingsToMultisiteResolver<TParent>;
  rte?: SettingsToRteResolver<TParent>;
  memberBios?: SettingsToMemberBiosResolver<TParent>;
}

export interface SettingsToIdResolver<TParent = GQLSettings, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToDomainResolver<TParent = GQLSettings, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToWebhooksResolver<TParent = GQLSettings, TResult = GQLWebhookConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToWebhookEventsResolver<TParent = GQLSettings, TResult = Array<GQLWEBHOOK_EVENT_NAME>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToStaticURIResolver<TParent = GQLSettings, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToLocaleResolver<TParent = GQLSettings, TResult = GQLLocale> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToLiveResolver<TParent = GQLSettings, TResult = GQLLiveConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToModerationResolver<TParent = GQLSettings, TResult = GQLMODERATION_MODE | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToCommunityGuidelinesResolver<TParent = GQLSettings, TResult = GQLCommunityGuidelines> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToPremodLinksEnableResolver<TParent = GQLSettings, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToCloseCommentingResolver<TParent = GQLSettings, TResult = GQLCloseCommenting> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToCustomCSSURLResolver<TParent = GQLSettings, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToDisableCommentingResolver<TParent = GQLSettings, TResult = GQLDisableCommenting> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToEditCommentWindowLengthResolver<TParent = GQLSettings, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToCharCountResolver<TParent = GQLSettings, TResult = GQLCharCount> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToOrganizationResolver<TParent = GQLSettings, TResult = GQLOrganization> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToEmailResolver<TParent = GQLSettings, TResult = GQLEmailConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToSlackResolver<TParent = GQLSettings, TResult = GQLSlackConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToWordListResolver<TParent = GQLSettings, TResult = GQLWordList> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToAuthResolver<TParent = GQLSettings, TResult = GQLAuth> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToIntegrationsResolver<TParent = GQLSettings, TResult = GQLExternalIntegrations> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToRecentCommentHistoryResolver<TParent = GQLSettings, TResult = GQLRecentCommentHistoryConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToReactionResolver<TParent = GQLSettings, TResult = GQLReactionConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToStaffResolver<TParent = GQLSettings, TResult = GQLStaffConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToAccountFeaturesResolver<TParent = GQLSettings, TResult = GQLCommenterAccountFeatures> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToStoriesResolver<TParent = GQLSettings, TResult = GQLStoryConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToMediaResolver<TParent = GQLSettings, TResult = GQLMediaConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToFeatureFlagsResolver<TParent = GQLSettings, TResult = Array<GQLFEATURE_FLAG>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToCreatedAtResolver<TParent = GQLSettings, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToNewCommentersResolver<TParent = GQLSettings, TResult = GQLNewCommentersConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToPremoderateSuspectWordsResolver<TParent = GQLSettings, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToAnnouncementResolver<TParent = GQLSettings, TResult = GQLAnnouncement | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToMultisiteResolver<TParent = GQLSettings, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToRteResolver<TParent = GQLSettings, TResult = GQLRTEConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToMemberBiosResolver<TParent = GQLSettings, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWebhookConfigurationTypeResolver<TParent = GQLWebhookConfiguration> {
  endpoints?: WebhookConfigurationToEndpointsResolver<TParent>;
}

export interface WebhookConfigurationToEndpointsResolver<TParent = GQLWebhookConfiguration, TResult = Array<GQLWebhookEndpoint>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWebhookEndpointTypeResolver<TParent = GQLWebhookEndpoint> {
  id?: WebhookEndpointToIdResolver<TParent>;
  enabled?: WebhookEndpointToEnabledResolver<TParent>;
  url?: WebhookEndpointToUrlResolver<TParent>;
  signingSecret?: WebhookEndpointToSigningSecretResolver<TParent>;
  deliveries?: WebhookEndpointToDeliveriesResolver<TParent>;
  all?: WebhookEndpointToAllResolver<TParent>;
  events?: WebhookEndpointToEventsResolver<TParent>;
}

export interface WebhookEndpointToIdResolver<TParent = GQLWebhookEndpoint, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookEndpointToEnabledResolver<TParent = GQLWebhookEndpoint, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookEndpointToUrlResolver<TParent = GQLWebhookEndpoint, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookEndpointToSigningSecretResolver<TParent = GQLWebhookEndpoint, TResult = GQLSigningSecret> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookEndpointToDeliveriesResolver<TParent = GQLWebhookEndpoint, TResult = Array<GQLWebhookDelivery>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookEndpointToAllResolver<TParent = GQLWebhookEndpoint, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookEndpointToEventsResolver<TParent = GQLWebhookEndpoint, TResult = Array<GQLWEBHOOK_EVENT_NAME>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSigningSecretTypeResolver<TParent = GQLSigningSecret> {
  kid?: SigningSecretToKidResolver<TParent>;
  secret?: SigningSecretToSecretResolver<TParent>;
  createdAt?: SigningSecretToCreatedAtResolver<TParent>;
  lastUsedAt?: SigningSecretToLastUsedAtResolver<TParent>;
  rotatedAt?: SigningSecretToRotatedAtResolver<TParent>;
  inactiveAt?: SigningSecretToInactiveAtResolver<TParent>;
}

export interface SigningSecretToKidResolver<TParent = GQLSigningSecret, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SigningSecretToSecretResolver<TParent = GQLSigningSecret, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SigningSecretToCreatedAtResolver<TParent = GQLSigningSecret, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SigningSecretToLastUsedAtResolver<TParent = GQLSigningSecret, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SigningSecretToRotatedAtResolver<TParent = GQLSigningSecret, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SigningSecretToInactiveAtResolver<TParent = GQLSigningSecret, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWebhookDeliveryTypeResolver<TParent = GQLWebhookDelivery> {
  success?: WebhookDeliveryToSuccessResolver<TParent>;
  status?: WebhookDeliveryToStatusResolver<TParent>;
  statusText?: WebhookDeliveryToStatusTextResolver<TParent>;
  request?: WebhookDeliveryToRequestResolver<TParent>;
  response?: WebhookDeliveryToResponseResolver<TParent>;
  createdAt?: WebhookDeliveryToCreatedAtResolver<TParent>;
}

export interface WebhookDeliveryToSuccessResolver<TParent = GQLWebhookDelivery, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookDeliveryToStatusResolver<TParent = GQLWebhookDelivery, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookDeliveryToStatusTextResolver<TParent = GQLWebhookDelivery, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookDeliveryToRequestResolver<TParent = GQLWebhookDelivery, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookDeliveryToResponseResolver<TParent = GQLWebhookDelivery, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookDeliveryToCreatedAtResolver<TParent = GQLWebhookDelivery, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommunityGuidelinesTypeResolver<TParent = GQLCommunityGuidelines> {
  enabled?: CommunityGuidelinesToEnabledResolver<TParent>;
  content?: CommunityGuidelinesToContentResolver<TParent>;
}

export interface CommunityGuidelinesToEnabledResolver<TParent = GQLCommunityGuidelines, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityGuidelinesToContentResolver<TParent = GQLCommunityGuidelines, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCloseCommentingTypeResolver<TParent = GQLCloseCommenting> {
  auto?: CloseCommentingToAutoResolver<TParent>;
  timeout?: CloseCommentingToTimeoutResolver<TParent>;
  message?: CloseCommentingToMessageResolver<TParent>;
}

export interface CloseCommentingToAutoResolver<TParent = GQLCloseCommenting, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CloseCommentingToTimeoutResolver<TParent = GQLCloseCommenting, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CloseCommentingToMessageResolver<TParent = GQLCloseCommenting, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDisableCommentingTypeResolver<TParent = GQLDisableCommenting> {
  enabled?: DisableCommentingToEnabledResolver<TParent>;
  message?: DisableCommentingToMessageResolver<TParent>;
}

export interface DisableCommentingToEnabledResolver<TParent = GQLDisableCommenting, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DisableCommentingToMessageResolver<TParent = GQLDisableCommenting, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCharCountTypeResolver<TParent = GQLCharCount> {
  enabled?: CharCountToEnabledResolver<TParent>;
  min?: CharCountToMinResolver<TParent>;
  max?: CharCountToMaxResolver<TParent>;
}

export interface CharCountToEnabledResolver<TParent = GQLCharCount, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CharCountToMinResolver<TParent = GQLCharCount, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CharCountToMaxResolver<TParent = GQLCharCount, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLOrganizationTypeResolver<TParent = GQLOrganization> {
  name?: OrganizationToNameResolver<TParent>;
  contactEmail?: OrganizationToContactEmailResolver<TParent>;
  url?: OrganizationToUrlResolver<TParent>;
}

export interface OrganizationToNameResolver<TParent = GQLOrganization, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganizationToContactEmailResolver<TParent = GQLOrganization, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganizationToUrlResolver<TParent = GQLOrganization, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEmailConfigurationTypeResolver<TParent = GQLEmailConfiguration> {
  enabled?: EmailConfigurationToEnabledResolver<TParent>;
  fromName?: EmailConfigurationToFromNameResolver<TParent>;
  fromEmail?: EmailConfigurationToFromEmailResolver<TParent>;
  smtp?: EmailConfigurationToSmtpResolver<TParent>;
}

export interface EmailConfigurationToEnabledResolver<TParent = GQLEmailConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EmailConfigurationToFromNameResolver<TParent = GQLEmailConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EmailConfigurationToFromEmailResolver<TParent = GQLEmailConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EmailConfigurationToSmtpResolver<TParent = GQLEmailConfiguration, TResult = GQLSMTP> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSMTPTypeResolver<TParent = GQLSMTP> {
  secure?: SMTPToSecureResolver<TParent>;
  host?: SMTPToHostResolver<TParent>;
  port?: SMTPToPortResolver<TParent>;
  authentication?: SMTPToAuthenticationResolver<TParent>;
  username?: SMTPToUsernameResolver<TParent>;
  password?: SMTPToPasswordResolver<TParent>;
}

export interface SMTPToSecureResolver<TParent = GQLSMTP, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SMTPToHostResolver<TParent = GQLSMTP, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SMTPToPortResolver<TParent = GQLSMTP, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SMTPToAuthenticationResolver<TParent = GQLSMTP, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SMTPToUsernameResolver<TParent = GQLSMTP, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SMTPToPasswordResolver<TParent = GQLSMTP, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSlackConfigurationTypeResolver<TParent = GQLSlackConfiguration> {
  channels?: SlackConfigurationToChannelsResolver<TParent>;
}

export interface SlackConfigurationToChannelsResolver<TParent = GQLSlackConfiguration, TResult = Array<GQLSlackChannel>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSlackChannelTypeResolver<TParent = GQLSlackChannel> {
  enabled?: SlackChannelToEnabledResolver<TParent>;
  name?: SlackChannelToNameResolver<TParent>;
  hookURL?: SlackChannelToHookURLResolver<TParent>;
  triggers?: SlackChannelToTriggersResolver<TParent>;
}

export interface SlackChannelToEnabledResolver<TParent = GQLSlackChannel, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlackChannelToNameResolver<TParent = GQLSlackChannel, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlackChannelToHookURLResolver<TParent = GQLSlackChannel, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlackChannelToTriggersResolver<TParent = GQLSlackChannel, TResult = GQLSlackChannelTriggers> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSlackChannelTriggersTypeResolver<TParent = GQLSlackChannelTriggers> {
  reportedComments?: SlackChannelTriggersToReportedCommentsResolver<TParent>;
  pendingComments?: SlackChannelTriggersToPendingCommentsResolver<TParent>;
  featuredComments?: SlackChannelTriggersToFeaturedCommentsResolver<TParent>;
  allComments?: SlackChannelTriggersToAllCommentsResolver<TParent>;
  staffComments?: SlackChannelTriggersToStaffCommentsResolver<TParent>;
}

export interface SlackChannelTriggersToReportedCommentsResolver<TParent = GQLSlackChannelTriggers, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlackChannelTriggersToPendingCommentsResolver<TParent = GQLSlackChannelTriggers, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlackChannelTriggersToFeaturedCommentsResolver<TParent = GQLSlackChannelTriggers, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlackChannelTriggersToAllCommentsResolver<TParent = GQLSlackChannelTriggers, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlackChannelTriggersToStaffCommentsResolver<TParent = GQLSlackChannelTriggers, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWordListTypeResolver<TParent = GQLWordList> {
  banned?: WordListToBannedResolver<TParent>;
  suspect?: WordListToSuspectResolver<TParent>;
}

export interface WordListToBannedResolver<TParent = GQLWordList, TResult = Array<string>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WordListToSuspectResolver<TParent = GQLWordList, TResult = Array<string>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAuthTypeResolver<TParent = GQLAuth> {
  integrations?: AuthToIntegrationsResolver<TParent>;
  sessionDuration?: AuthToSessionDurationResolver<TParent>;
}

export interface AuthToIntegrationsResolver<TParent = GQLAuth, TResult = GQLAuthIntegrations> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthToSessionDurationResolver<TParent = GQLAuth, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAuthIntegrationsTypeResolver<TParent = GQLAuthIntegrations> {
  local?: AuthIntegrationsToLocalResolver<TParent>;
  sso?: AuthIntegrationsToSsoResolver<TParent>;
  oidc?: AuthIntegrationsToOidcResolver<TParent>;
  google?: AuthIntegrationsToGoogleResolver<TParent>;
  facebook?: AuthIntegrationsToFacebookResolver<TParent>;
}

export interface AuthIntegrationsToLocalResolver<TParent = GQLAuthIntegrations, TResult = GQLLocalAuthIntegration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthIntegrationsToSsoResolver<TParent = GQLAuthIntegrations, TResult = GQLSSOAuthIntegration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthIntegrationsToOidcResolver<TParent = GQLAuthIntegrations, TResult = GQLOIDCAuthIntegration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthIntegrationsToGoogleResolver<TParent = GQLAuthIntegrations, TResult = GQLGoogleAuthIntegration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthIntegrationsToFacebookResolver<TParent = GQLAuthIntegrations, TResult = GQLFacebookAuthIntegration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLocalAuthIntegrationTypeResolver<TParent = GQLLocalAuthIntegration> {
  enabled?: LocalAuthIntegrationToEnabledResolver<TParent>;
  allowRegistration?: LocalAuthIntegrationToAllowRegistrationResolver<TParent>;
  targetFilter?: LocalAuthIntegrationToTargetFilterResolver<TParent>;
}

export interface LocalAuthIntegrationToEnabledResolver<TParent = GQLLocalAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocalAuthIntegrationToAllowRegistrationResolver<TParent = GQLLocalAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocalAuthIntegrationToTargetFilterResolver<TParent = GQLLocalAuthIntegration, TResult = GQLAuthenticationTargetFilter> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAuthenticationTargetFilterTypeResolver<TParent = GQLAuthenticationTargetFilter> {
  admin?: AuthenticationTargetFilterToAdminResolver<TParent>;
  stream?: AuthenticationTargetFilterToStreamResolver<TParent>;
}

export interface AuthenticationTargetFilterToAdminResolver<TParent = GQLAuthenticationTargetFilter, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthenticationTargetFilterToStreamResolver<TParent = GQLAuthenticationTargetFilter, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSSOAuthIntegrationTypeResolver<TParent = GQLSSOAuthIntegration> {
  enabled?: SSOAuthIntegrationToEnabledResolver<TParent>;
  allowRegistration?: SSOAuthIntegrationToAllowRegistrationResolver<TParent>;
  targetFilter?: SSOAuthIntegrationToTargetFilterResolver<TParent>;
  signingSecrets?: SSOAuthIntegrationToSigningSecretsResolver<TParent>;
  key?: SSOAuthIntegrationToKeyResolver<TParent>;
  keyGeneratedAt?: SSOAuthIntegrationToKeyGeneratedAtResolver<TParent>;
}

export interface SSOAuthIntegrationToEnabledResolver<TParent = GQLSSOAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SSOAuthIntegrationToAllowRegistrationResolver<TParent = GQLSSOAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SSOAuthIntegrationToTargetFilterResolver<TParent = GQLSSOAuthIntegration, TResult = GQLAuthenticationTargetFilter> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SSOAuthIntegrationToSigningSecretsResolver<TParent = GQLSSOAuthIntegration, TResult = Array<GQLSigningSecret>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SSOAuthIntegrationToKeyResolver<TParent = GQLSSOAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SSOAuthIntegrationToKeyGeneratedAtResolver<TParent = GQLSSOAuthIntegration, TResult = GQLTime | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLOIDCAuthIntegrationTypeResolver<TParent = GQLOIDCAuthIntegration> {
  enabled?: OIDCAuthIntegrationToEnabledResolver<TParent>;
  allowRegistration?: OIDCAuthIntegrationToAllowRegistrationResolver<TParent>;
  targetFilter?: OIDCAuthIntegrationToTargetFilterResolver<TParent>;
  name?: OIDCAuthIntegrationToNameResolver<TParent>;
  callbackURL?: OIDCAuthIntegrationToCallbackURLResolver<TParent>;
  redirectURL?: OIDCAuthIntegrationToRedirectURLResolver<TParent>;
  clientID?: OIDCAuthIntegrationToClientIDResolver<TParent>;
  clientSecret?: OIDCAuthIntegrationToClientSecretResolver<TParent>;
  authorizationURL?: OIDCAuthIntegrationToAuthorizationURLResolver<TParent>;
  tokenURL?: OIDCAuthIntegrationToTokenURLResolver<TParent>;
  jwksURI?: OIDCAuthIntegrationToJwksURIResolver<TParent>;
  issuer?: OIDCAuthIntegrationToIssuerResolver<TParent>;
}

export interface OIDCAuthIntegrationToEnabledResolver<TParent = GQLOIDCAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToAllowRegistrationResolver<TParent = GQLOIDCAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToTargetFilterResolver<TParent = GQLOIDCAuthIntegration, TResult = GQLAuthenticationTargetFilter> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToNameResolver<TParent = GQLOIDCAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToCallbackURLResolver<TParent = GQLOIDCAuthIntegration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToRedirectURLResolver<TParent = GQLOIDCAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToClientIDResolver<TParent = GQLOIDCAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToClientSecretResolver<TParent = GQLOIDCAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToAuthorizationURLResolver<TParent = GQLOIDCAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToTokenURLResolver<TParent = GQLOIDCAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToJwksURIResolver<TParent = GQLOIDCAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OIDCAuthIntegrationToIssuerResolver<TParent = GQLOIDCAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGoogleAuthIntegrationTypeResolver<TParent = GQLGoogleAuthIntegration> {
  enabled?: GoogleAuthIntegrationToEnabledResolver<TParent>;
  allowRegistration?: GoogleAuthIntegrationToAllowRegistrationResolver<TParent>;
  targetFilter?: GoogleAuthIntegrationToTargetFilterResolver<TParent>;
  clientID?: GoogleAuthIntegrationToClientIDResolver<TParent>;
  clientSecret?: GoogleAuthIntegrationToClientSecretResolver<TParent>;
  callbackURL?: GoogleAuthIntegrationToCallbackURLResolver<TParent>;
  redirectURL?: GoogleAuthIntegrationToRedirectURLResolver<TParent>;
}

export interface GoogleAuthIntegrationToEnabledResolver<TParent = GQLGoogleAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GoogleAuthIntegrationToAllowRegistrationResolver<TParent = GQLGoogleAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GoogleAuthIntegrationToTargetFilterResolver<TParent = GQLGoogleAuthIntegration, TResult = GQLAuthenticationTargetFilter> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GoogleAuthIntegrationToClientIDResolver<TParent = GQLGoogleAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GoogleAuthIntegrationToClientSecretResolver<TParent = GQLGoogleAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GoogleAuthIntegrationToCallbackURLResolver<TParent = GQLGoogleAuthIntegration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GoogleAuthIntegrationToRedirectURLResolver<TParent = GQLGoogleAuthIntegration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFacebookAuthIntegrationTypeResolver<TParent = GQLFacebookAuthIntegration> {
  enabled?: FacebookAuthIntegrationToEnabledResolver<TParent>;
  allowRegistration?: FacebookAuthIntegrationToAllowRegistrationResolver<TParent>;
  targetFilter?: FacebookAuthIntegrationToTargetFilterResolver<TParent>;
  clientID?: FacebookAuthIntegrationToClientIDResolver<TParent>;
  clientSecret?: FacebookAuthIntegrationToClientSecretResolver<TParent>;
  callbackURL?: FacebookAuthIntegrationToCallbackURLResolver<TParent>;
  redirectURL?: FacebookAuthIntegrationToRedirectURLResolver<TParent>;
}

export interface FacebookAuthIntegrationToEnabledResolver<TParent = GQLFacebookAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacebookAuthIntegrationToAllowRegistrationResolver<TParent = GQLFacebookAuthIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacebookAuthIntegrationToTargetFilterResolver<TParent = GQLFacebookAuthIntegration, TResult = GQLAuthenticationTargetFilter> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacebookAuthIntegrationToClientIDResolver<TParent = GQLFacebookAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacebookAuthIntegrationToClientSecretResolver<TParent = GQLFacebookAuthIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacebookAuthIntegrationToCallbackURLResolver<TParent = GQLFacebookAuthIntegration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacebookAuthIntegrationToRedirectURLResolver<TParent = GQLFacebookAuthIntegration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLExternalIntegrationsTypeResolver<TParent = GQLExternalIntegrations> {
  akismet?: ExternalIntegrationsToAkismetResolver<TParent>;
  perspective?: ExternalIntegrationsToPerspectiveResolver<TParent>;
  external?: ExternalIntegrationsToExternalResolver<TParent>;
}

export interface ExternalIntegrationsToAkismetResolver<TParent = GQLExternalIntegrations, TResult = GQLAkismetExternalIntegration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalIntegrationsToPerspectiveResolver<TParent = GQLExternalIntegrations, TResult = GQLPerspectiveExternalIntegration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalIntegrationsToExternalResolver<TParent = GQLExternalIntegrations, TResult = GQLCustomExternalIntegration | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAkismetExternalIntegrationTypeResolver<TParent = GQLAkismetExternalIntegration> {
  enabled?: AkismetExternalIntegrationToEnabledResolver<TParent>;
  ipBased?: AkismetExternalIntegrationToIpBasedResolver<TParent>;
  key?: AkismetExternalIntegrationToKeyResolver<TParent>;
  site?: AkismetExternalIntegrationToSiteResolver<TParent>;
}

export interface AkismetExternalIntegrationToEnabledResolver<TParent = GQLAkismetExternalIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AkismetExternalIntegrationToIpBasedResolver<TParent = GQLAkismetExternalIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AkismetExternalIntegrationToKeyResolver<TParent = GQLAkismetExternalIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AkismetExternalIntegrationToSiteResolver<TParent = GQLAkismetExternalIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPerspectiveExternalIntegrationTypeResolver<TParent = GQLPerspectiveExternalIntegration> {
  enabled?: PerspectiveExternalIntegrationToEnabledResolver<TParent>;
  endpoint?: PerspectiveExternalIntegrationToEndpointResolver<TParent>;
  key?: PerspectiveExternalIntegrationToKeyResolver<TParent>;
  threshold?: PerspectiveExternalIntegrationToThresholdResolver<TParent>;
  model?: PerspectiveExternalIntegrationToModelResolver<TParent>;
  doNotStore?: PerspectiveExternalIntegrationToDoNotStoreResolver<TParent>;
  sendFeedback?: PerspectiveExternalIntegrationToSendFeedbackResolver<TParent>;
}

export interface PerspectiveExternalIntegrationToEnabledResolver<TParent = GQLPerspectiveExternalIntegration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PerspectiveExternalIntegrationToEndpointResolver<TParent = GQLPerspectiveExternalIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PerspectiveExternalIntegrationToKeyResolver<TParent = GQLPerspectiveExternalIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PerspectiveExternalIntegrationToThresholdResolver<TParent = GQLPerspectiveExternalIntegration, TResult = number | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PerspectiveExternalIntegrationToModelResolver<TParent = GQLPerspectiveExternalIntegration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PerspectiveExternalIntegrationToDoNotStoreResolver<TParent = GQLPerspectiveExternalIntegration, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PerspectiveExternalIntegrationToSendFeedbackResolver<TParent = GQLPerspectiveExternalIntegration, TResult = boolean | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCustomExternalIntegrationTypeResolver<TParent = GQLCustomExternalIntegration> {
  phases?: CustomExternalIntegrationToPhasesResolver<TParent>;
}

export interface CustomExternalIntegrationToPhasesResolver<TParent = GQLCustomExternalIntegration, TResult = Array<GQLExternalModerationPhase>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLExternalModerationPhaseTypeResolver<TParent = GQLExternalModerationPhase> {
  id?: ExternalModerationPhaseToIdResolver<TParent>;
  name?: ExternalModerationPhaseToNameResolver<TParent>;
  enabled?: ExternalModerationPhaseToEnabledResolver<TParent>;
  url?: ExternalModerationPhaseToUrlResolver<TParent>;
  format?: ExternalModerationPhaseToFormatResolver<TParent>;
  timeout?: ExternalModerationPhaseToTimeoutResolver<TParent>;
  signingSecret?: ExternalModerationPhaseToSigningSecretResolver<TParent>;
}

export interface ExternalModerationPhaseToIdResolver<TParent = GQLExternalModerationPhase, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalModerationPhaseToNameResolver<TParent = GQLExternalModerationPhase, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalModerationPhaseToEnabledResolver<TParent = GQLExternalModerationPhase, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalModerationPhaseToUrlResolver<TParent = GQLExternalModerationPhase, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalModerationPhaseToFormatResolver<TParent = GQLExternalModerationPhase, TResult = GQLCOMMENT_BODY_FORMAT> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalModerationPhaseToTimeoutResolver<TParent = GQLExternalModerationPhase, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ExternalModerationPhaseToSigningSecretResolver<TParent = GQLExternalModerationPhase, TResult = GQLSigningSecret> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRecentCommentHistoryConfigurationTypeResolver<TParent = GQLRecentCommentHistoryConfiguration> {
  enabled?: RecentCommentHistoryConfigurationToEnabledResolver<TParent>;
  timeFrame?: RecentCommentHistoryConfigurationToTimeFrameResolver<TParent>;
  triggerRejectionRate?: RecentCommentHistoryConfigurationToTriggerRejectionRateResolver<TParent>;
}

export interface RecentCommentHistoryConfigurationToEnabledResolver<TParent = GQLRecentCommentHistoryConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RecentCommentHistoryConfigurationToTimeFrameResolver<TParent = GQLRecentCommentHistoryConfiguration, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RecentCommentHistoryConfigurationToTriggerRejectionRateResolver<TParent = GQLRecentCommentHistoryConfiguration, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReactionConfigurationTypeResolver<TParent = GQLReactionConfiguration> {
  icon?: ReactionConfigurationToIconResolver<TParent>;
  iconActive?: ReactionConfigurationToIconActiveResolver<TParent>;
  label?: ReactionConfigurationToLabelResolver<TParent>;
  labelActive?: ReactionConfigurationToLabelActiveResolver<TParent>;
  sortLabel?: ReactionConfigurationToSortLabelResolver<TParent>;
  color?: ReactionConfigurationToColorResolver<TParent>;
}

export interface ReactionConfigurationToIconResolver<TParent = GQLReactionConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReactionConfigurationToIconActiveResolver<TParent = GQLReactionConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReactionConfigurationToLabelResolver<TParent = GQLReactionConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReactionConfigurationToLabelActiveResolver<TParent = GQLReactionConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReactionConfigurationToSortLabelResolver<TParent = GQLReactionConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReactionConfigurationToColorResolver<TParent = GQLReactionConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStaffConfigurationTypeResolver<TParent = GQLStaffConfiguration> {
  label?: StaffConfigurationToLabelResolver<TParent>;
  staffLabel?: StaffConfigurationToStaffLabelResolver<TParent>;
  moderatorLabel?: StaffConfigurationToModeratorLabelResolver<TParent>;
  adminLabel?: StaffConfigurationToAdminLabelResolver<TParent>;
}

export interface StaffConfigurationToLabelResolver<TParent = GQLStaffConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StaffConfigurationToStaffLabelResolver<TParent = GQLStaffConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StaffConfigurationToModeratorLabelResolver<TParent = GQLStaffConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StaffConfigurationToAdminLabelResolver<TParent = GQLStaffConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommenterAccountFeaturesTypeResolver<TParent = GQLCommenterAccountFeatures> {
  changeUsername?: CommenterAccountFeaturesToChangeUsernameResolver<TParent>;
  downloadComments?: CommenterAccountFeaturesToDownloadCommentsResolver<TParent>;
  deleteAccount?: CommenterAccountFeaturesToDeleteAccountResolver<TParent>;
}

export interface CommenterAccountFeaturesToChangeUsernameResolver<TParent = GQLCommenterAccountFeatures, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommenterAccountFeaturesToDownloadCommentsResolver<TParent = GQLCommenterAccountFeatures, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommenterAccountFeaturesToDeleteAccountResolver<TParent = GQLCommenterAccountFeatures, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStoryConfigurationTypeResolver<TParent = GQLStoryConfiguration> {
  scraping?: StoryConfigurationToScrapingResolver<TParent>;
  disableLazy?: StoryConfigurationToDisableLazyResolver<TParent>;
}

export interface StoryConfigurationToScrapingResolver<TParent = GQLStoryConfiguration, TResult = GQLStoryScrapingConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryConfigurationToDisableLazyResolver<TParent = GQLStoryConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLStoryScrapingConfigurationTypeResolver<TParent = GQLStoryScrapingConfiguration> {
  enabled?: StoryScrapingConfigurationToEnabledResolver<TParent>;
  proxyURL?: StoryScrapingConfigurationToProxyURLResolver<TParent>;
  customUserAgent?: StoryScrapingConfigurationToCustomUserAgentResolver<TParent>;
  authentication?: StoryScrapingConfigurationToAuthenticationResolver<TParent>;
  username?: StoryScrapingConfigurationToUsernameResolver<TParent>;
  password?: StoryScrapingConfigurationToPasswordResolver<TParent>;
}

export interface StoryScrapingConfigurationToEnabledResolver<TParent = GQLStoryScrapingConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryScrapingConfigurationToProxyURLResolver<TParent = GQLStoryScrapingConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryScrapingConfigurationToCustomUserAgentResolver<TParent = GQLStoryScrapingConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryScrapingConfigurationToAuthenticationResolver<TParent = GQLStoryScrapingConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryScrapingConfigurationToUsernameResolver<TParent = GQLStoryScrapingConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StoryScrapingConfigurationToPasswordResolver<TParent = GQLStoryScrapingConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMediaConfigurationTypeResolver<TParent = GQLMediaConfiguration> {
  twitter?: MediaConfigurationToTwitterResolver<TParent>;
  youtube?: MediaConfigurationToYoutubeResolver<TParent>;
  giphy?: MediaConfigurationToGiphyResolver<TParent>;
  external?: MediaConfigurationToExternalResolver<TParent>;
}

export interface MediaConfigurationToTwitterResolver<TParent = GQLMediaConfiguration, TResult = GQLTwitterMediaConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MediaConfigurationToYoutubeResolver<TParent = GQLMediaConfiguration, TResult = GQLYouTubeMediaConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MediaConfigurationToGiphyResolver<TParent = GQLMediaConfiguration, TResult = GQLGiphyMediaConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MediaConfigurationToExternalResolver<TParent = GQLMediaConfiguration, TResult = GQLExternalMediaConfiguration> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTwitterMediaConfigurationTypeResolver<TParent = GQLTwitterMediaConfiguration> {
  enabled?: TwitterMediaConfigurationToEnabledResolver<TParent>;
}

export interface TwitterMediaConfigurationToEnabledResolver<TParent = GQLTwitterMediaConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLYouTubeMediaConfigurationTypeResolver<TParent = GQLYouTubeMediaConfiguration> {
  enabled?: YouTubeMediaConfigurationToEnabledResolver<TParent>;
}

export interface YouTubeMediaConfigurationToEnabledResolver<TParent = GQLYouTubeMediaConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGiphyMediaConfigurationTypeResolver<TParent = GQLGiphyMediaConfiguration> {
  enabled?: GiphyMediaConfigurationToEnabledResolver<TParent>;
  maxRating?: GiphyMediaConfigurationToMaxRatingResolver<TParent>;
  key?: GiphyMediaConfigurationToKeyResolver<TParent>;
}

export interface GiphyMediaConfigurationToEnabledResolver<TParent = GQLGiphyMediaConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GiphyMediaConfigurationToMaxRatingResolver<TParent = GQLGiphyMediaConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GiphyMediaConfigurationToKeyResolver<TParent = GQLGiphyMediaConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLExternalMediaConfigurationTypeResolver<TParent = GQLExternalMediaConfiguration> {
  enabled?: ExternalMediaConfigurationToEnabledResolver<TParent>;
}

export interface ExternalMediaConfigurationToEnabledResolver<TParent = GQLExternalMediaConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNewCommentersConfigurationTypeResolver<TParent = GQLNewCommentersConfiguration> {
  premodEnabled?: NewCommentersConfigurationToPremodEnabledResolver<TParent>;
  approvedCommentsThreshold?: NewCommentersConfigurationToApprovedCommentsThresholdResolver<TParent>;
}

export interface NewCommentersConfigurationToPremodEnabledResolver<TParent = GQLNewCommentersConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NewCommentersConfigurationToApprovedCommentsThresholdResolver<TParent = GQLNewCommentersConfiguration, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAnnouncementTypeResolver<TParent = GQLAnnouncement> {
  id?: AnnouncementToIdResolver<TParent>;
  content?: AnnouncementToContentResolver<TParent>;
  createdAt?: AnnouncementToCreatedAtResolver<TParent>;
  disableAt?: AnnouncementToDisableAtResolver<TParent>;
  duration?: AnnouncementToDurationResolver<TParent>;
}

export interface AnnouncementToIdResolver<TParent = GQLAnnouncement, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AnnouncementToContentResolver<TParent = GQLAnnouncement, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AnnouncementToCreatedAtResolver<TParent = GQLAnnouncement, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AnnouncementToDisableAtResolver<TParent = GQLAnnouncement, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AnnouncementToDurationResolver<TParent = GQLAnnouncement, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRTEConfigurationTypeResolver<TParent = GQLRTEConfiguration> {
  enabled?: RTEConfigurationToEnabledResolver<TParent>;
  strikethrough?: RTEConfigurationToStrikethroughResolver<TParent>;
  spoiler?: RTEConfigurationToSpoilerResolver<TParent>;
  sarcasm?: RTEConfigurationToSarcasmResolver<TParent>;
}

export interface RTEConfigurationToEnabledResolver<TParent = GQLRTEConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RTEConfigurationToStrikethroughResolver<TParent = GQLRTEConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RTEConfigurationToSpoilerResolver<TParent = GQLRTEConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RTEConfigurationToSarcasmResolver<TParent = GQLRTEConfiguration, TResult = boolean> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDiscoveredOIDCConfigurationTypeResolver<TParent = GQLDiscoveredOIDCConfiguration> {
  issuer?: DiscoveredOIDCConfigurationToIssuerResolver<TParent>;
  authorizationURL?: DiscoveredOIDCConfigurationToAuthorizationURLResolver<TParent>;
  tokenURL?: DiscoveredOIDCConfigurationToTokenURLResolver<TParent>;
  jwksURI?: DiscoveredOIDCConfigurationToJwksURIResolver<TParent>;
}

export interface DiscoveredOIDCConfigurationToIssuerResolver<TParent = GQLDiscoveredOIDCConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DiscoveredOIDCConfigurationToAuthorizationURLResolver<TParent = GQLDiscoveredOIDCConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DiscoveredOIDCConfigurationToTokenURLResolver<TParent = GQLDiscoveredOIDCConfiguration, TResult = string | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DiscoveredOIDCConfigurationToJwksURIResolver<TParent = GQLDiscoveredOIDCConfiguration, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLQueuesTypeResolver<TParent = GQLQueues> {
  mailer?: QueuesToMailerResolver<TParent>;
  scraper?: QueuesToScraperResolver<TParent>;
  notifier?: QueuesToNotifierResolver<TParent>;
  webhook?: QueuesToWebhookResolver<TParent>;
  rejector?: QueuesToRejectorResolver<TParent>;
}

export interface QueuesToMailerResolver<TParent = GQLQueues, TResult = GQLQueue> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueuesToScraperResolver<TParent = GQLQueues, TResult = GQLQueue> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueuesToNotifierResolver<TParent = GQLQueues, TResult = GQLQueue> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueuesToWebhookResolver<TParent = GQLQueues, TResult = GQLQueue> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueuesToRejectorResolver<TParent = GQLQueues, TResult = GQLQueue> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLQueueTypeResolver<TParent = GQLQueue> {
  counts?: QueueToCountsResolver<TParent>;
}

export interface QueueToCountsResolver<TParent = GQLQueue, TResult = GQLQueueCounts> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLQueueCountsTypeResolver<TParent = GQLQueueCounts> {
  waiting?: QueueCountsToWaitingResolver<TParent>;
  active?: QueueCountsToActiveResolver<TParent>;
  delayed?: QueueCountsToDelayedResolver<TParent>;
}

export interface QueueCountsToWaitingResolver<TParent = GQLQueueCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueueCountsToActiveResolver<TParent = GQLQueueCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueueCountsToDelayedResolver<TParent = GQLQueueCounts, TResult = number> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMutationTypeResolver<TParent = undefined> {
  createComment?: MutationToCreateCommentResolver<TParent>;
  createCommentReply?: MutationToCreateCommentReplyResolver<TParent>;
  editComment?: MutationToEditCommentResolver<TParent>;
  updateSettings?: MutationToUpdateSettingsResolver<TParent>;
  rotateSSOSigningSecret?: MutationToRotateSSOSigningSecretResolver<TParent>;
  deactivateSSOSigningSecret?: MutationToDeactivateSSOSigningSecretResolver<TParent>;
  deleteSSOSigningSecret?: MutationToDeleteSSOSigningSecretResolver<TParent>;
  createCommentReaction?: MutationToCreateCommentReactionResolver<TParent>;
  removeCommentReaction?: MutationToRemoveCommentReactionResolver<TParent>;
  createCommentDontAgree?: MutationToCreateCommentDontAgreeResolver<TParent>;
  removeCommentDontAgree?: MutationToRemoveCommentDontAgreeResolver<TParent>;
  createCommentFlag?: MutationToCreateCommentFlagResolver<TParent>;
  featureComment?: MutationToFeatureCommentResolver<TParent>;
  unfeatureComment?: MutationToUnfeatureCommentResolver<TParent>;
  createStory?: MutationToCreateStoryResolver<TParent>;
  updateStory?: MutationToUpdateStoryResolver<TParent>;
  updateStorySettings?: MutationToUpdateStorySettingsResolver<TParent>;
  closeStory?: MutationToCloseStoryResolver<TParent>;
  openStory?: MutationToOpenStoryResolver<TParent>;
  mergeStories?: MutationToMergeStoriesResolver<TParent>;
  removeStory?: MutationToRemoveStoryResolver<TParent>;
  scrapeStory?: MutationToScrapeStoryResolver<TParent>;
  approveComment?: MutationToApproveCommentResolver<TParent>;
  rejectComment?: MutationToRejectCommentResolver<TParent>;
  inviteUsers?: MutationToInviteUsersResolver<TParent>;
  setUsername?: MutationToSetUsernameResolver<TParent>;
  updateBio?: MutationToUpdateBioResolver<TParent>;
  updateUsername?: MutationToUpdateUsernameResolver<TParent>;
  setEmail?: MutationToSetEmailResolver<TParent>;
  setPassword?: MutationToSetPasswordResolver<TParent>;
  updatePassword?: MutationToUpdatePasswordResolver<TParent>;
  requestAccountDeletion?: MutationToRequestAccountDeletionResolver<TParent>;
  deleteUserAccount?: MutationToDeleteUserAccountResolver<TParent>;
  cancelAccountDeletion?: MutationToCancelAccountDeletionResolver<TParent>;
  createToken?: MutationToCreateTokenResolver<TParent>;
  deactivateToken?: MutationToDeactivateTokenResolver<TParent>;
  updateUserUsername?: MutationToUpdateUserUsernameResolver<TParent>;
  updateEmail?: MutationToUpdateEmailResolver<TParent>;
  updateNotificationSettings?: MutationToUpdateNotificationSettingsResolver<TParent>;
  updateUserMediaSettings?: MutationToUpdateUserMediaSettingsResolver<TParent>;
  updateUserEmail?: MutationToUpdateUserEmailResolver<TParent>;
  updateUserAvatar?: MutationToUpdateUserAvatarResolver<TParent>;
  updateUserRole?: MutationToUpdateUserRoleResolver<TParent>;
  promoteUser?: MutationToPromoteUserResolver<TParent>;
  demoteUser?: MutationToDemoteUserResolver<TParent>;
  updateUserModerationScopes?: MutationToUpdateUserModerationScopesResolver<TParent>;
  banUser?: MutationToBanUserResolver<TParent>;
  removeUserBan?: MutationToRemoveUserBanResolver<TParent>;
  suspendUser?: MutationToSuspendUserResolver<TParent>;
  warnUser?: MutationToWarnUserResolver<TParent>;
  removeUserWarning?: MutationToRemoveUserWarningResolver<TParent>;
  acknowledgeWarning?: MutationToAcknowledgeWarningResolver<TParent>;
  removeUserSuspension?: MutationToRemoveUserSuspensionResolver<TParent>;
  ignoreUser?: MutationToIgnoreUserResolver<TParent>;
  removeUserIgnore?: MutationToRemoveUserIgnoreResolver<TParent>;
  requestCommentsDownload?: MutationToRequestCommentsDownloadResolver<TParent>;
  requestUserCommentsDownload?: MutationToRequestUserCommentsDownloadResolver<TParent>;
  premodUser?: MutationToPremodUserResolver<TParent>;
  removeUserPremod?: MutationToRemoveUserPremodResolver<TParent>;
  createModeratorNote?: MutationToCreateModeratorNoteResolver<TParent>;
  deleteModeratorNote?: MutationToDeleteModeratorNoteResolver<TParent>;
  enableFeatureFlag?: MutationToEnableFeatureFlagResolver<TParent>;
  disableFeatureFlag?: MutationToDisableFeatureFlagResolver<TParent>;
  createAnnouncement?: MutationToCreateAnnouncementResolver<TParent>;
  deleteAnnouncement?: MutationToDeleteAnnouncementResolver<TParent>;
  createSite?: MutationToCreateSiteResolver<TParent>;
  updateSite?: MutationToUpdateSiteResolver<TParent>;
  createWebhookEndpoint?: MutationToCreateWebhookEndpointResolver<TParent>;
  updateWebhookEndpoint?: MutationToUpdateWebhookEndpointResolver<TParent>;
  enableWebhookEndpoint?: MutationToEnableWebhookEndpointResolver<TParent>;
  disableWebhookEndpoint?: MutationToDisableWebhookEndpointResolver<TParent>;
  deleteWebhookEndpoint?: MutationToDeleteWebhookEndpointResolver<TParent>;
  rotateWebhookEndpointSigningSecret?: MutationToRotateWebhookEndpointSigningSecretResolver<TParent>;
  createExternalModerationPhase?: MutationToCreateExternalModerationPhaseResolver<TParent>;
  updateExternalModerationPhase?: MutationToUpdateExternalModerationPhaseResolver<TParent>;
  enableExternalModerationPhase?: MutationToEnableExternalModerationPhaseResolver<TParent>;
  disableExternalModerationPhase?: MutationToDisableExternalModerationPhaseResolver<TParent>;
  deleteExternalModerationPhase?: MutationToDeleteExternalModerationPhaseResolver<TParent>;
  rotateExternalModerationPhaseSigningSecret?: MutationToRotateExternalModerationPhaseSigningSecretResolver<TParent>;
  updateStoryMode?: MutationToUpdateStoryModeResolver<TParent>;
  addStoryExpert?: MutationToAddStoryExpertResolver<TParent>;
  removeStoryExpert?: MutationToRemoveStoryExpertResolver<TParent>;
  testSMTP?: MutationToTestSMTPResolver<TParent>;
  reviewCommentFlag?: MutationToReviewCommentFlagResolver<TParent>;
}

export interface MutationToCreateCommentArgs {
  input: GQLCreateCommentInput;
}
export interface MutationToCreateCommentResolver<TParent = undefined, TResult = GQLCreateCommentPayload> {
  (parent: TParent, args: MutationToCreateCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCommentReplyArgs {
  input: GQLCreateCommentReplyInput;
}
export interface MutationToCreateCommentReplyResolver<TParent = undefined, TResult = GQLCreateCommentReplyPayload> {
  (parent: TParent, args: MutationToCreateCommentReplyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEditCommentArgs {
  input: GQLEditCommentInput;
}
export interface MutationToEditCommentResolver<TParent = undefined, TResult = GQLEditCommentPayload> {
  (parent: TParent, args: MutationToEditCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateSettingsArgs {
  input: GQLUpdateSettingsInput;
}
export interface MutationToUpdateSettingsResolver<TParent = undefined, TResult = GQLUpdateSettingsPayload> {
  (parent: TParent, args: MutationToUpdateSettingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRotateSSOSigningSecretArgs {
  input: GQLRotateSSOSigningSecretInput;
}
export interface MutationToRotateSSOSigningSecretResolver<TParent = undefined, TResult = GQLRotateSSOSigningSecretPayload> {
  (parent: TParent, args: MutationToRotateSSOSigningSecretArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeactivateSSOSigningSecretArgs {
  input: GQLDeactivateSSOSigningSecretInput;
}
export interface MutationToDeactivateSSOSigningSecretResolver<TParent = undefined, TResult = GQLDeactivateSSOSigningSecretPayload> {
  (parent: TParent, args: MutationToDeactivateSSOSigningSecretArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteSSOSigningSecretArgs {
  input: GQLDeleteSSOSigningSecretInput;
}
export interface MutationToDeleteSSOSigningSecretResolver<TParent = undefined, TResult = GQLDeleteSSOSigningSecretPayload> {
  (parent: TParent, args: MutationToDeleteSSOSigningSecretArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCommentReactionArgs {
  input: GQLCreateCommentReactionInput;
}
export interface MutationToCreateCommentReactionResolver<TParent = undefined, TResult = GQLCreateCommentReactionPayload | null> {
  (parent: TParent, args: MutationToCreateCommentReactionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveCommentReactionArgs {
  input: GQLRemoveCommentReactionInput;
}
export interface MutationToRemoveCommentReactionResolver<TParent = undefined, TResult = GQLRemoveCommentReactionPayload | null> {
  (parent: TParent, args: MutationToRemoveCommentReactionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCommentDontAgreeArgs {
  input: GQLCreateCommentDontAgreeInput;
}
export interface MutationToCreateCommentDontAgreeResolver<TParent = undefined, TResult = GQLCreateCommentDontAgreePayload | null> {
  (parent: TParent, args: MutationToCreateCommentDontAgreeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveCommentDontAgreeArgs {
  input: GQLRemoveCommentDontAgreeInput;
}
export interface MutationToRemoveCommentDontAgreeResolver<TParent = undefined, TResult = GQLRemoveCommentDontAgreePayload | null> {
  (parent: TParent, args: MutationToRemoveCommentDontAgreeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCommentFlagArgs {
  input: GQLCreateCommentFlagInput;
}
export interface MutationToCreateCommentFlagResolver<TParent = undefined, TResult = GQLCreateCommentFlagPayload> {
  (parent: TParent, args: MutationToCreateCommentFlagArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToFeatureCommentArgs {
  input: GQLFeatureCommentInput;
}
export interface MutationToFeatureCommentResolver<TParent = undefined, TResult = GQLFeatureCommentPayload> {
  (parent: TParent, args: MutationToFeatureCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUnfeatureCommentArgs {
  input: GQLUnfeatureCommentInput;
}
export interface MutationToUnfeatureCommentResolver<TParent = undefined, TResult = GQLUnfeatureCommentPayload> {
  (parent: TParent, args: MutationToUnfeatureCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateStoryArgs {
  input: GQLCreateStoryInput;
}
export interface MutationToCreateStoryResolver<TParent = undefined, TResult = GQLCreateStoryPayload> {
  (parent: TParent, args: MutationToCreateStoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateStoryArgs {
  input: GQLUpdateStoryInput;
}
export interface MutationToUpdateStoryResolver<TParent = undefined, TResult = GQLUpdateStoryPayload> {
  (parent: TParent, args: MutationToUpdateStoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateStorySettingsArgs {
  input: GQLUpdateStorySettingsInput;
}
export interface MutationToUpdateStorySettingsResolver<TParent = undefined, TResult = GQLUpdateStorySettingsPayload> {
  (parent: TParent, args: MutationToUpdateStorySettingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCloseStoryArgs {
  input: GQLCloseStoryInput;
}
export interface MutationToCloseStoryResolver<TParent = undefined, TResult = GQLCloseStoryPayload> {
  (parent: TParent, args: MutationToCloseStoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToOpenStoryArgs {
  input: GQLOpenStoryInput;
}
export interface MutationToOpenStoryResolver<TParent = undefined, TResult = GQLOpenStoryPayload> {
  (parent: TParent, args: MutationToOpenStoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToMergeStoriesArgs {
  input: GQLMergeStoriesInput;
}
export interface MutationToMergeStoriesResolver<TParent = undefined, TResult = GQLMergeStoriesPayload> {
  (parent: TParent, args: MutationToMergeStoriesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveStoryArgs {
  input: GQLRemoveStoryInput;
}
export interface MutationToRemoveStoryResolver<TParent = undefined, TResult = GQLRemoveStoryPayload> {
  (parent: TParent, args: MutationToRemoveStoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToScrapeStoryArgs {
  input: GQLScrapeStoryInput;
}
export interface MutationToScrapeStoryResolver<TParent = undefined, TResult = GQLScrapeStoryPayload> {
  (parent: TParent, args: MutationToScrapeStoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToApproveCommentArgs {
  input: GQLApproveCommentInput;
}
export interface MutationToApproveCommentResolver<TParent = undefined, TResult = GQLApproveCommentPayload> {
  (parent: TParent, args: MutationToApproveCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRejectCommentArgs {
  input: GQLRejectCommentInput;
}
export interface MutationToRejectCommentResolver<TParent = undefined, TResult = GQLRejectCommentPayload> {
  (parent: TParent, args: MutationToRejectCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToInviteUsersArgs {
  input: GQLInviteUsersInput;
}
export interface MutationToInviteUsersResolver<TParent = undefined, TResult = GQLInviteUsersPayload> {
  (parent: TParent, args: MutationToInviteUsersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetUsernameArgs {
  input: GQLSetUsernameInput;
}
export interface MutationToSetUsernameResolver<TParent = undefined, TResult = GQLSetUsernamePayload> {
  (parent: TParent, args: MutationToSetUsernameArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateBioArgs {
  input: GQLUpdateBioInput;
}
export interface MutationToUpdateBioResolver<TParent = undefined, TResult = GQLUpdateBioPayload> {
  (parent: TParent, args: MutationToUpdateBioArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateUsernameArgs {
  input: GQLUpdateUsernameInput;
}
export interface MutationToUpdateUsernameResolver<TParent = undefined, TResult = GQLUpdateUsernamePayload> {
  (parent: TParent, args: MutationToUpdateUsernameArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetEmailArgs {
  input: GQLSetEmailInput;
}
export interface MutationToSetEmailResolver<TParent = undefined, TResult = GQLSetEmailPayload> {
  (parent: TParent, args: MutationToSetEmailArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetPasswordArgs {
  input: GQLSetPasswordInput;
}
export interface MutationToSetPasswordResolver<TParent = undefined, TResult = GQLSetPasswordPayload> {
  (parent: TParent, args: MutationToSetPasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePasswordArgs {
  input: GQLUpdatePasswordInput;
}
export interface MutationToUpdatePasswordResolver<TParent = undefined, TResult = GQLUpdatePasswordPayload> {
  (parent: TParent, args: MutationToUpdatePasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRequestAccountDeletionArgs {
  input: GQLRequestAccountDeletionInput;
}
export interface MutationToRequestAccountDeletionResolver<TParent = undefined, TResult = GQLRequestAccountDeletionPayload> {
  (parent: TParent, args: MutationToRequestAccountDeletionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteUserAccountArgs {
  input: GQLDeleteUserAccountInput;
}
export interface MutationToDeleteUserAccountResolver<TParent = undefined, TResult = GQLDeleteUserAccountPayload> {
  (parent: TParent, args: MutationToDeleteUserAccountArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCancelAccountDeletionArgs {
  input: GQLCancelAccountDeletionInput;
}
export interface MutationToCancelAccountDeletionResolver<TParent = undefined, TResult = GQLCancelAccountDeletionPayload> {
  (parent: TParent, args: MutationToCancelAccountDeletionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateTokenArgs {
  input: GQLCreateTokenInput;
}
export interface MutationToCreateTokenResolver<TParent = undefined, TResult = GQLCreateTokenPayload> {
  (parent: TParent, args: MutationToCreateTokenArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeactivateTokenArgs {
  input: GQLDeactivateTokenInput;
}
export interface MutationToDeactivateTokenResolver<TParent = undefined, TResult = GQLDeactivateTokenPayload> {
  (parent: TParent, args: MutationToDeactivateTokenArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateUserUsernameArgs {
  input: GQLUpdateUserUsernameInput;
}
export interface MutationToUpdateUserUsernameResolver<TParent = undefined, TResult = GQLUpdateUserUsernamePayload> {
  (parent: TParent, args: MutationToUpdateUserUsernameArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateEmailArgs {
  input: GQLUpdateEmailInput;
}
export interface MutationToUpdateEmailResolver<TParent = undefined, TResult = GQLUpdateEmailPayload> {
  (parent: TParent, args: MutationToUpdateEmailArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateNotificationSettingsArgs {
  input: GQLUpdateNotificationSettingsInput;
}
export interface MutationToUpdateNotificationSettingsResolver<TParent = undefined, TResult = GQLUpdateNotificationSettingsPayload> {
  (parent: TParent, args: MutationToUpdateNotificationSettingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateUserMediaSettingsArgs {
  input: GQLUpdateUserMediaSettingsInput;
}
export interface MutationToUpdateUserMediaSettingsResolver<TParent = undefined, TResult = GQLUpdateUserMediaSettingsPayload> {
  (parent: TParent, args: MutationToUpdateUserMediaSettingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateUserEmailArgs {
  input: GQLUpdateUserEmailInput;
}
export interface MutationToUpdateUserEmailResolver<TParent = undefined, TResult = GQLUpdateUserEmailPayload> {
  (parent: TParent, args: MutationToUpdateUserEmailArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateUserAvatarArgs {
  input: GQLUpdateUserAvatarInput;
}
export interface MutationToUpdateUserAvatarResolver<TParent = undefined, TResult = GQLUpdateUserAvatarPayload> {
  (parent: TParent, args: MutationToUpdateUserAvatarArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateUserRoleArgs {
  input: GQLUpdateUserRoleInput;
}
export interface MutationToUpdateUserRoleResolver<TParent = undefined, TResult = GQLUpdateUserRolePayload> {
  (parent: TParent, args: MutationToUpdateUserRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPromoteUserArgs {
  input: GQLPromoteUserInput;
}
export interface MutationToPromoteUserResolver<TParent = undefined, TResult = GQLPromoteUserPayload> {
  (parent: TParent, args: MutationToPromoteUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDemoteUserArgs {
  input: GQLDemoteUserInput;
}
export interface MutationToDemoteUserResolver<TParent = undefined, TResult = GQLDemoteUserPayload> {
  (parent: TParent, args: MutationToDemoteUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateUserModerationScopesArgs {
  input: GQLUpdateUserModerationScopesInput;
}
export interface MutationToUpdateUserModerationScopesResolver<TParent = undefined, TResult = GQLUpdateUserModerationScopesPayload> {
  (parent: TParent, args: MutationToUpdateUserModerationScopesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToBanUserArgs {
  input: GQLBanUserInput;
}
export interface MutationToBanUserResolver<TParent = undefined, TResult = GQLBanUserPayload> {
  (parent: TParent, args: MutationToBanUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveUserBanArgs {
  input: GQLRemoveUserBanInput;
}
export interface MutationToRemoveUserBanResolver<TParent = undefined, TResult = GQLRemoveUserBanPayload> {
  (parent: TParent, args: MutationToRemoveUserBanArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSuspendUserArgs {
  input: GQLSuspendUserInput;
}
export interface MutationToSuspendUserResolver<TParent = undefined, TResult = GQLSuspendUserPayload> {
  (parent: TParent, args: MutationToSuspendUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToWarnUserArgs {
  input: GQLWarnUserInput;
}
export interface MutationToWarnUserResolver<TParent = undefined, TResult = GQLWarnUserPayload> {
  (parent: TParent, args: MutationToWarnUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveUserWarningArgs {
  input: GQLRemoveUserWarningInput;
}
export interface MutationToRemoveUserWarningResolver<TParent = undefined, TResult = GQLRemoveUserWarningPayload> {
  (parent: TParent, args: MutationToRemoveUserWarningArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAcknowledgeWarningArgs {
  input: GQLAcknowledgeWarningInput;
}
export interface MutationToAcknowledgeWarningResolver<TParent = undefined, TResult = GQLAcknowledgeWarningPayload | null> {
  (parent: TParent, args: MutationToAcknowledgeWarningArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveUserSuspensionArgs {
  input: GQLRemoveUserSuspensionInput;
}
export interface MutationToRemoveUserSuspensionResolver<TParent = undefined, TResult = GQLRemoveUserSuspensionPayload> {
  (parent: TParent, args: MutationToRemoveUserSuspensionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToIgnoreUserArgs {
  input: GQLIgnoreUserInput;
}
export interface MutationToIgnoreUserResolver<TParent = undefined, TResult = GQLIgnoreUserPayload> {
  (parent: TParent, args: MutationToIgnoreUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveUserIgnoreArgs {
  input: GQLRemoveUserIgnoreInput;
}
export interface MutationToRemoveUserIgnoreResolver<TParent = undefined, TResult = GQLRemoveUserIgnorePayload> {
  (parent: TParent, args: MutationToRemoveUserIgnoreArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRequestCommentsDownloadArgs {
  input: GQLRequestCommentsDownloadInput;
}
export interface MutationToRequestCommentsDownloadResolver<TParent = undefined, TResult = GQLRequestCommentsDownloadPayload> {
  (parent: TParent, args: MutationToRequestCommentsDownloadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRequestUserCommentsDownloadArgs {
  input: GQLRequestUserCommentsDownloadInput;
}
export interface MutationToRequestUserCommentsDownloadResolver<TParent = undefined, TResult = GQLRequestUserCommentsDownloadPayload> {
  (parent: TParent, args: MutationToRequestUserCommentsDownloadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPremodUserArgs {
  input: GQLPremodUserInput;
}
export interface MutationToPremodUserResolver<TParent = undefined, TResult = GQLPremodUserPayload> {
  (parent: TParent, args: MutationToPremodUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveUserPremodArgs {
  input: GQLRemovePremodUserInput;
}
export interface MutationToRemoveUserPremodResolver<TParent = undefined, TResult = GQLRemovePremodUserPayload> {
  (parent: TParent, args: MutationToRemoveUserPremodArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateModeratorNoteArgs {
  input: GQLCreateModeratorNoteInput;
}
export interface MutationToCreateModeratorNoteResolver<TParent = undefined, TResult = GQLCreateModeratorNotePayload> {
  (parent: TParent, args: MutationToCreateModeratorNoteArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteModeratorNoteArgs {
  input: GQLDeleteModeratorNoteInput;
}
export interface MutationToDeleteModeratorNoteResolver<TParent = undefined, TResult = GQLDeleteModeratorNotePayload> {
  (parent: TParent, args: MutationToDeleteModeratorNoteArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEnableFeatureFlagArgs {
  input: GQLEnableFeatureFlagInput;
}
export interface MutationToEnableFeatureFlagResolver<TParent = undefined, TResult = GQLEnableFeatureFlagPayload> {
  (parent: TParent, args: MutationToEnableFeatureFlagArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDisableFeatureFlagArgs {
  input: GQLDisableFeatureFlagInput;
}
export interface MutationToDisableFeatureFlagResolver<TParent = undefined, TResult = GQLDisableFeatureFlagPayload> {
  (parent: TParent, args: MutationToDisableFeatureFlagArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateAnnouncementArgs {
  input: GQLCreateAnnouncementInput;
}
export interface MutationToCreateAnnouncementResolver<TParent = undefined, TResult = GQLCreateAnnouncementPayload> {
  (parent: TParent, args: MutationToCreateAnnouncementArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteAnnouncementArgs {
  input: GQLDeleteAnnouncementInput;
}
export interface MutationToDeleteAnnouncementResolver<TParent = undefined, TResult = GQLDeleteAnnouncementPayload> {
  (parent: TParent, args: MutationToDeleteAnnouncementArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateSiteArgs {
  input: GQLCreateSiteInput;
}
export interface MutationToCreateSiteResolver<TParent = undefined, TResult = GQLCreateSitePayload> {
  (parent: TParent, args: MutationToCreateSiteArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateSiteArgs {
  input: GQLUpdateSiteInput;
}
export interface MutationToUpdateSiteResolver<TParent = undefined, TResult = GQLUpdateSitePayload> {
  (parent: TParent, args: MutationToUpdateSiteArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateWebhookEndpointArgs {
  input: GQLCreateWebhookEndpointInput;
}
export interface MutationToCreateWebhookEndpointResolver<TParent = undefined, TResult = GQLCreateWebhookEndpointPayload> {
  (parent: TParent, args: MutationToCreateWebhookEndpointArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateWebhookEndpointArgs {
  input: GQLUpdateWebhookEndpointInput;
}
export interface MutationToUpdateWebhookEndpointResolver<TParent = undefined, TResult = GQLUpdateWebhookEndpointPayload> {
  (parent: TParent, args: MutationToUpdateWebhookEndpointArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEnableWebhookEndpointArgs {
  input: GQLEnableWebhookEndpointInput;
}
export interface MutationToEnableWebhookEndpointResolver<TParent = undefined, TResult = GQLEnableWebhookEndpointPayload> {
  (parent: TParent, args: MutationToEnableWebhookEndpointArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDisableWebhookEndpointArgs {
  input: GQLDisableWebhookEndpointInput;
}
export interface MutationToDisableWebhookEndpointResolver<TParent = undefined, TResult = GQLDisableWebhookEndpointPayload> {
  (parent: TParent, args: MutationToDisableWebhookEndpointArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteWebhookEndpointArgs {
  input: GQLDeleteWebhookEndpointInput;
}
export interface MutationToDeleteWebhookEndpointResolver<TParent = undefined, TResult = GQLDeleteWebhookEndpointPayload> {
  (parent: TParent, args: MutationToDeleteWebhookEndpointArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRotateWebhookEndpointSigningSecretArgs {
  input: GQLRotateWebhookEndpointSigningSecretInput;
}
export interface MutationToRotateWebhookEndpointSigningSecretResolver<TParent = undefined, TResult = GQLRotateWebhookEndpointSigningSecretPayload> {
  (parent: TParent, args: MutationToRotateWebhookEndpointSigningSecretArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateExternalModerationPhaseArgs {
  input: GQLCreateExternalModerationPhaseInput;
}
export interface MutationToCreateExternalModerationPhaseResolver<TParent = undefined, TResult = GQLCreateExternalModerationPhasePayload> {
  (parent: TParent, args: MutationToCreateExternalModerationPhaseArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateExternalModerationPhaseArgs {
  input: GQLUpdateExternalModerationPhaseInput;
}
export interface MutationToUpdateExternalModerationPhaseResolver<TParent = undefined, TResult = GQLUpdateExternalModerationPhasePayload> {
  (parent: TParent, args: MutationToUpdateExternalModerationPhaseArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEnableExternalModerationPhaseArgs {
  input: GQLEnableExternalModerationPhaseInput;
}
export interface MutationToEnableExternalModerationPhaseResolver<TParent = undefined, TResult = GQLEnableExternalModerationPhasePayload> {
  (parent: TParent, args: MutationToEnableExternalModerationPhaseArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDisableExternalModerationPhaseArgs {
  input: GQLDisableExternalModerationPhaseInput;
}
export interface MutationToDisableExternalModerationPhaseResolver<TParent = undefined, TResult = GQLDisableExternalModerationPhasePayload> {
  (parent: TParent, args: MutationToDisableExternalModerationPhaseArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteExternalModerationPhaseArgs {
  input: GQLDeleteExternalModerationPhaseInput;
}
export interface MutationToDeleteExternalModerationPhaseResolver<TParent = undefined, TResult = GQLDeleteExternalModerationPhasePayload> {
  (parent: TParent, args: MutationToDeleteExternalModerationPhaseArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRotateExternalModerationPhaseSigningSecretArgs {
  input: GQLRotateExternalModerationPhaseSigningSecretInput;
}
export interface MutationToRotateExternalModerationPhaseSigningSecretResolver<TParent = undefined, TResult = GQLRotateExternalModerationPhaseSigningSecretPayload> {
  (parent: TParent, args: MutationToRotateExternalModerationPhaseSigningSecretArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateStoryModeArgs {
  input: GQLUpdateStoryModeInput;
}
export interface MutationToUpdateStoryModeResolver<TParent = undefined, TResult = GQLUpdateStoryModePayload> {
  (parent: TParent, args: MutationToUpdateStoryModeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAddStoryExpertArgs {
  input: GQLAddStoryExpertInput;
}
export interface MutationToAddStoryExpertResolver<TParent = undefined, TResult = GQLAddStoryExpertPayload> {
  (parent: TParent, args: MutationToAddStoryExpertArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveStoryExpertArgs {
  input: GQLRemoveStoryExpertInput;
}
export interface MutationToRemoveStoryExpertResolver<TParent = undefined, TResult = GQLRemoveStoryExpertPayload> {
  (parent: TParent, args: MutationToRemoveStoryExpertArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToTestSMTPArgs {
  input: GQLTestSMTPInput;
}
export interface MutationToTestSMTPResolver<TParent = undefined, TResult = GQLTestSMTPPayload> {
  (parent: TParent, args: MutationToTestSMTPArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReviewCommentFlagArgs {
  input: GQLReviewCommentFlagInput;
}
export interface MutationToReviewCommentFlagResolver<TParent = undefined, TResult = GQLReviewCommentFlagPayload> {
  (parent: TParent, args: MutationToReviewCommentFlagArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCommentPayloadTypeResolver<TParent = GQLCreateCommentPayload> {
  edge?: CreateCommentPayloadToEdgeResolver<TParent>;
  clientMutationId?: CreateCommentPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateCommentPayloadToEdgeResolver<TParent = GQLCreateCommentPayload, TResult = GQLCommentEdge> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCommentPayloadToClientMutationIdResolver<TParent = GQLCreateCommentPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCommentReplyPayloadTypeResolver<TParent = GQLCreateCommentReplyPayload> {
  edge?: CreateCommentReplyPayloadToEdgeResolver<TParent>;
  clientMutationId?: CreateCommentReplyPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateCommentReplyPayloadToEdgeResolver<TParent = GQLCreateCommentReplyPayload, TResult = GQLCommentEdge> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCommentReplyPayloadToClientMutationIdResolver<TParent = GQLCreateCommentReplyPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEditCommentPayloadTypeResolver<TParent = GQLEditCommentPayload> {
  comment?: EditCommentPayloadToCommentResolver<TParent>;
  clientMutationId?: EditCommentPayloadToClientMutationIdResolver<TParent>;
}

export interface EditCommentPayloadToCommentResolver<TParent = GQLEditCommentPayload, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EditCommentPayloadToClientMutationIdResolver<TParent = GQLEditCommentPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateSettingsPayloadTypeResolver<TParent = GQLUpdateSettingsPayload> {
  settings?: UpdateSettingsPayloadToSettingsResolver<TParent>;
  clientMutationId?: UpdateSettingsPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateSettingsPayloadToSettingsResolver<TParent = GQLUpdateSettingsPayload, TResult = GQLSettings | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSettingsPayloadToClientMutationIdResolver<TParent = GQLUpdateSettingsPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRotateSSOSigningSecretPayloadTypeResolver<TParent = GQLRotateSSOSigningSecretPayload> {
  clientMutationId?: RotateSSOSigningSecretPayloadToClientMutationIdResolver<TParent>;
  settings?: RotateSSOSigningSecretPayloadToSettingsResolver<TParent>;
}

export interface RotateSSOSigningSecretPayloadToClientMutationIdResolver<TParent = GQLRotateSSOSigningSecretPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RotateSSOSigningSecretPayloadToSettingsResolver<TParent = GQLRotateSSOSigningSecretPayload, TResult = GQLSettings | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeactivateSSOSigningSecretPayloadTypeResolver<TParent = GQLDeactivateSSOSigningSecretPayload> {
  clientMutationId?: DeactivateSSOSigningSecretPayloadToClientMutationIdResolver<TParent>;
  settings?: DeactivateSSOSigningSecretPayloadToSettingsResolver<TParent>;
}

export interface DeactivateSSOSigningSecretPayloadToClientMutationIdResolver<TParent = GQLDeactivateSSOSigningSecretPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeactivateSSOSigningSecretPayloadToSettingsResolver<TParent = GQLDeactivateSSOSigningSecretPayload, TResult = GQLSettings | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteSSOSigningSecretPayloadTypeResolver<TParent = GQLDeleteSSOSigningSecretPayload> {
  clientMutationId?: DeleteSSOSigningSecretPayloadToClientMutationIdResolver<TParent>;
  settings?: DeleteSSOSigningSecretPayloadToSettingsResolver<TParent>;
}

export interface DeleteSSOSigningSecretPayloadToClientMutationIdResolver<TParent = GQLDeleteSSOSigningSecretPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteSSOSigningSecretPayloadToSettingsResolver<TParent = GQLDeleteSSOSigningSecretPayload, TResult = GQLSettings | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCommentReactionPayloadTypeResolver<TParent = GQLCreateCommentReactionPayload> {
  comment?: CreateCommentReactionPayloadToCommentResolver<TParent>;
  clientMutationId?: CreateCommentReactionPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateCommentReactionPayloadToCommentResolver<TParent = GQLCreateCommentReactionPayload, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCommentReactionPayloadToClientMutationIdResolver<TParent = GQLCreateCommentReactionPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemoveCommentReactionPayloadTypeResolver<TParent = GQLRemoveCommentReactionPayload> {
  comment?: RemoveCommentReactionPayloadToCommentResolver<TParent>;
  clientMutationId?: RemoveCommentReactionPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveCommentReactionPayloadToCommentResolver<TParent = GQLRemoveCommentReactionPayload, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveCommentReactionPayloadToClientMutationIdResolver<TParent = GQLRemoveCommentReactionPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCommentDontAgreePayloadTypeResolver<TParent = GQLCreateCommentDontAgreePayload> {
  comment?: CreateCommentDontAgreePayloadToCommentResolver<TParent>;
  clientMutationId?: CreateCommentDontAgreePayloadToClientMutationIdResolver<TParent>;
}

export interface CreateCommentDontAgreePayloadToCommentResolver<TParent = GQLCreateCommentDontAgreePayload, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCommentDontAgreePayloadToClientMutationIdResolver<TParent = GQLCreateCommentDontAgreePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemoveCommentDontAgreePayloadTypeResolver<TParent = GQLRemoveCommentDontAgreePayload> {
  comment?: RemoveCommentDontAgreePayloadToCommentResolver<TParent>;
  clientMutationId?: RemoveCommentDontAgreePayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveCommentDontAgreePayloadToCommentResolver<TParent = GQLRemoveCommentDontAgreePayload, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveCommentDontAgreePayloadToClientMutationIdResolver<TParent = GQLRemoveCommentDontAgreePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCommentFlagPayloadTypeResolver<TParent = GQLCreateCommentFlagPayload> {
  comment?: CreateCommentFlagPayloadToCommentResolver<TParent>;
  clientMutationId?: CreateCommentFlagPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateCommentFlagPayloadToCommentResolver<TParent = GQLCreateCommentFlagPayload, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCommentFlagPayloadToClientMutationIdResolver<TParent = GQLCreateCommentFlagPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFeatureCommentPayloadTypeResolver<TParent = GQLFeatureCommentPayload> {
  comment?: FeatureCommentPayloadToCommentResolver<TParent>;
  clientMutationId?: FeatureCommentPayloadToClientMutationIdResolver<TParent>;
  moderationQueues?: FeatureCommentPayloadToModerationQueuesResolver<TParent>;
}

export interface FeatureCommentPayloadToCommentResolver<TParent = GQLFeatureCommentPayload, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeatureCommentPayloadToClientMutationIdResolver<TParent = GQLFeatureCommentPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeatureCommentPayloadToModerationQueuesArgs {
  storyID?: string;
}
export interface FeatureCommentPayloadToModerationQueuesResolver<TParent = GQLFeatureCommentPayload, TResult = GQLModerationQueues | null> {
  (parent: TParent, args: FeatureCommentPayloadToModerationQueuesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUnfeatureCommentPayloadTypeResolver<TParent = GQLUnfeatureCommentPayload> {
  comment?: UnfeatureCommentPayloadToCommentResolver<TParent>;
  clientMutationId?: UnfeatureCommentPayloadToClientMutationIdResolver<TParent>;
}

export interface UnfeatureCommentPayloadToCommentResolver<TParent = GQLUnfeatureCommentPayload, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UnfeatureCommentPayloadToClientMutationIdResolver<TParent = GQLUnfeatureCommentPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateStoryPayloadTypeResolver<TParent = GQLCreateStoryPayload> {
  story?: CreateStoryPayloadToStoryResolver<TParent>;
  clientMutationId?: CreateStoryPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateStoryPayloadToStoryResolver<TParent = GQLCreateStoryPayload, TResult = GQLStory | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateStoryPayloadToClientMutationIdResolver<TParent = GQLCreateStoryPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateStoryPayloadTypeResolver<TParent = GQLUpdateStoryPayload> {
  story?: UpdateStoryPayloadToStoryResolver<TParent>;
  clientMutationId?: UpdateStoryPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateStoryPayloadToStoryResolver<TParent = GQLUpdateStoryPayload, TResult = GQLStory | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateStoryPayloadToClientMutationIdResolver<TParent = GQLUpdateStoryPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateStorySettingsPayloadTypeResolver<TParent = GQLUpdateStorySettingsPayload> {
  story?: UpdateStorySettingsPayloadToStoryResolver<TParent>;
  clientMutationId?: UpdateStorySettingsPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateStorySettingsPayloadToStoryResolver<TParent = GQLUpdateStorySettingsPayload, TResult = GQLStory | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateStorySettingsPayloadToClientMutationIdResolver<TParent = GQLUpdateStorySettingsPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCloseStoryPayloadTypeResolver<TParent = GQLCloseStoryPayload> {
  story?: CloseStoryPayloadToStoryResolver<TParent>;
  clientMutationId?: CloseStoryPayloadToClientMutationIdResolver<TParent>;
}

export interface CloseStoryPayloadToStoryResolver<TParent = GQLCloseStoryPayload, TResult = GQLStory | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CloseStoryPayloadToClientMutationIdResolver<TParent = GQLCloseStoryPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLOpenStoryPayloadTypeResolver<TParent = GQLOpenStoryPayload> {
  story?: OpenStoryPayloadToStoryResolver<TParent>;
  clientMutationId?: OpenStoryPayloadToClientMutationIdResolver<TParent>;
}

export interface OpenStoryPayloadToStoryResolver<TParent = GQLOpenStoryPayload, TResult = GQLStory | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OpenStoryPayloadToClientMutationIdResolver<TParent = GQLOpenStoryPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMergeStoriesPayloadTypeResolver<TParent = GQLMergeStoriesPayload> {
  story?: MergeStoriesPayloadToStoryResolver<TParent>;
  clientMutationId?: MergeStoriesPayloadToClientMutationIdResolver<TParent>;
}

export interface MergeStoriesPayloadToStoryResolver<TParent = GQLMergeStoriesPayload, TResult = GQLStory | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MergeStoriesPayloadToClientMutationIdResolver<TParent = GQLMergeStoriesPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemoveStoryPayloadTypeResolver<TParent = GQLRemoveStoryPayload> {
  story?: RemoveStoryPayloadToStoryResolver<TParent>;
  clientMutationId?: RemoveStoryPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveStoryPayloadToStoryResolver<TParent = GQLRemoveStoryPayload, TResult = GQLStory | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveStoryPayloadToClientMutationIdResolver<TParent = GQLRemoveStoryPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLScrapeStoryPayloadTypeResolver<TParent = GQLScrapeStoryPayload> {
  story?: ScrapeStoryPayloadToStoryResolver<TParent>;
  clientMutationId?: ScrapeStoryPayloadToClientMutationIdResolver<TParent>;
}

export interface ScrapeStoryPayloadToStoryResolver<TParent = GQLScrapeStoryPayload, TResult = GQLStory | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ScrapeStoryPayloadToClientMutationIdResolver<TParent = GQLScrapeStoryPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLApproveCommentPayloadTypeResolver<TParent = GQLApproveCommentPayload> {
  comment?: ApproveCommentPayloadToCommentResolver<TParent>;
  moderationQueues?: ApproveCommentPayloadToModerationQueuesResolver<TParent>;
  clientMutationId?: ApproveCommentPayloadToClientMutationIdResolver<TParent>;
}

export interface ApproveCommentPayloadToCommentResolver<TParent = GQLApproveCommentPayload, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApproveCommentPayloadToModerationQueuesArgs {
  storyID?: string;
  siteID?: string;
  section?: GQLSectionFilter;
}
export interface ApproveCommentPayloadToModerationQueuesResolver<TParent = GQLApproveCommentPayload, TResult = GQLModerationQueues | null> {
  (parent: TParent, args: ApproveCommentPayloadToModerationQueuesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApproveCommentPayloadToClientMutationIdResolver<TParent = GQLApproveCommentPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRejectCommentPayloadTypeResolver<TParent = GQLRejectCommentPayload> {
  comment?: RejectCommentPayloadToCommentResolver<TParent>;
  moderationQueues?: RejectCommentPayloadToModerationQueuesResolver<TParent>;
  clientMutationId?: RejectCommentPayloadToClientMutationIdResolver<TParent>;
}

export interface RejectCommentPayloadToCommentResolver<TParent = GQLRejectCommentPayload, TResult = GQLComment | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RejectCommentPayloadToModerationQueuesArgs {
  storyID?: string;
  siteID?: string;
  section?: GQLSectionFilter;
}
export interface RejectCommentPayloadToModerationQueuesResolver<TParent = GQLRejectCommentPayload, TResult = GQLModerationQueues | null> {
  (parent: TParent, args: RejectCommentPayloadToModerationQueuesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RejectCommentPayloadToClientMutationIdResolver<TParent = GQLRejectCommentPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInviteUsersPayloadTypeResolver<TParent = GQLInviteUsersPayload> {
  invites?: InviteUsersPayloadToInvitesResolver<TParent>;
  clientMutationId?: InviteUsersPayloadToClientMutationIdResolver<TParent>;
}

export interface InviteUsersPayloadToInvitesResolver<TParent = GQLInviteUsersPayload, TResult = Array<GQLInvite | null>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InviteUsersPayloadToClientMutationIdResolver<TParent = GQLInviteUsersPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInviteTypeResolver<TParent = GQLInvite> {
  id?: InviteToIdResolver<TParent>;
  email?: InviteToEmailResolver<TParent>;
  role?: InviteToRoleResolver<TParent>;
  createdBy?: InviteToCreatedByResolver<TParent>;
  createdAt?: InviteToCreatedAtResolver<TParent>;
}

export interface InviteToIdResolver<TParent = GQLInvite, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InviteToEmailResolver<TParent = GQLInvite, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InviteToRoleResolver<TParent = GQLInvite, TResult = GQLUSER_ROLE> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InviteToCreatedByResolver<TParent = GQLInvite, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InviteToCreatedAtResolver<TParent = GQLInvite, TResult = GQLTime> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSetUsernamePayloadTypeResolver<TParent = GQLSetUsernamePayload> {
  user?: SetUsernamePayloadToUserResolver<TParent>;
  clientMutationId?: SetUsernamePayloadToClientMutationIdResolver<TParent>;
}

export interface SetUsernamePayloadToUserResolver<TParent = GQLSetUsernamePayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SetUsernamePayloadToClientMutationIdResolver<TParent = GQLSetUsernamePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateBioPayloadTypeResolver<TParent = GQLUpdateBioPayload> {
  user?: UpdateBioPayloadToUserResolver<TParent>;
  clientMutationId?: UpdateBioPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateBioPayloadToUserResolver<TParent = GQLUpdateBioPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBioPayloadToClientMutationIdResolver<TParent = GQLUpdateBioPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateUsernamePayloadTypeResolver<TParent = GQLUpdateUsernamePayload> {
  user?: UpdateUsernamePayloadToUserResolver<TParent>;
  clientMutationId?: UpdateUsernamePayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateUsernamePayloadToUserResolver<TParent = GQLUpdateUsernamePayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateUsernamePayloadToClientMutationIdResolver<TParent = GQLUpdateUsernamePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSetEmailPayloadTypeResolver<TParent = GQLSetEmailPayload> {
  user?: SetEmailPayloadToUserResolver<TParent>;
  clientMutationId?: SetEmailPayloadToClientMutationIdResolver<TParent>;
}

export interface SetEmailPayloadToUserResolver<TParent = GQLSetEmailPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SetEmailPayloadToClientMutationIdResolver<TParent = GQLSetEmailPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSetPasswordPayloadTypeResolver<TParent = GQLSetPasswordPayload> {
  user?: SetPasswordPayloadToUserResolver<TParent>;
  clientMutationId?: SetPasswordPayloadToClientMutationIdResolver<TParent>;
}

export interface SetPasswordPayloadToUserResolver<TParent = GQLSetPasswordPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SetPasswordPayloadToClientMutationIdResolver<TParent = GQLSetPasswordPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdatePasswordPayloadTypeResolver<TParent = GQLUpdatePasswordPayload> {
  user?: UpdatePasswordPayloadToUserResolver<TParent>;
  clientMutationId?: UpdatePasswordPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdatePasswordPayloadToUserResolver<TParent = GQLUpdatePasswordPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdatePasswordPayloadToClientMutationIdResolver<TParent = GQLUpdatePasswordPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRequestAccountDeletionPayloadTypeResolver<TParent = GQLRequestAccountDeletionPayload> {
  user?: RequestAccountDeletionPayloadToUserResolver<TParent>;
  clientMutationId?: RequestAccountDeletionPayloadToClientMutationIdResolver<TParent>;
}

export interface RequestAccountDeletionPayloadToUserResolver<TParent = GQLRequestAccountDeletionPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequestAccountDeletionPayloadToClientMutationIdResolver<TParent = GQLRequestAccountDeletionPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteUserAccountPayloadTypeResolver<TParent = GQLDeleteUserAccountPayload> {
  user?: DeleteUserAccountPayloadToUserResolver<TParent>;
  clientMutationId?: DeleteUserAccountPayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteUserAccountPayloadToUserResolver<TParent = GQLDeleteUserAccountPayload, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteUserAccountPayloadToClientMutationIdResolver<TParent = GQLDeleteUserAccountPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCancelAccountDeletionPayloadTypeResolver<TParent = GQLCancelAccountDeletionPayload> {
  user?: CancelAccountDeletionPayloadToUserResolver<TParent>;
  clientMutationId?: CancelAccountDeletionPayloadToClientMutationIdResolver<TParent>;
}

export interface CancelAccountDeletionPayloadToUserResolver<TParent = GQLCancelAccountDeletionPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CancelAccountDeletionPayloadToClientMutationIdResolver<TParent = GQLCancelAccountDeletionPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateTokenPayloadTypeResolver<TParent = GQLCreateTokenPayload> {
  user?: CreateTokenPayloadToUserResolver<TParent>;
  token?: CreateTokenPayloadToTokenResolver<TParent>;
  signedToken?: CreateTokenPayloadToSignedTokenResolver<TParent>;
  clientMutationId?: CreateTokenPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateTokenPayloadToUserResolver<TParent = GQLCreateTokenPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateTokenPayloadToTokenResolver<TParent = GQLCreateTokenPayload, TResult = GQLToken> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateTokenPayloadToSignedTokenResolver<TParent = GQLCreateTokenPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateTokenPayloadToClientMutationIdResolver<TParent = GQLCreateTokenPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeactivateTokenPayloadTypeResolver<TParent = GQLDeactivateTokenPayload> {
  user?: DeactivateTokenPayloadToUserResolver<TParent>;
  token?: DeactivateTokenPayloadToTokenResolver<TParent>;
  clientMutationId?: DeactivateTokenPayloadToClientMutationIdResolver<TParent>;
}

export interface DeactivateTokenPayloadToUserResolver<TParent = GQLDeactivateTokenPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeactivateTokenPayloadToTokenResolver<TParent = GQLDeactivateTokenPayload, TResult = GQLToken | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeactivateTokenPayloadToClientMutationIdResolver<TParent = GQLDeactivateTokenPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateUserUsernamePayloadTypeResolver<TParent = GQLUpdateUserUsernamePayload> {
  user?: UpdateUserUsernamePayloadToUserResolver<TParent>;
  clientMutationId?: UpdateUserUsernamePayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateUserUsernamePayloadToUserResolver<TParent = GQLUpdateUserUsernamePayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateUserUsernamePayloadToClientMutationIdResolver<TParent = GQLUpdateUserUsernamePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateEmailPayloadTypeResolver<TParent = GQLUpdateEmailPayload> {
  user?: UpdateEmailPayloadToUserResolver<TParent>;
  clientMutationId?: UpdateEmailPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateEmailPayloadToUserResolver<TParent = GQLUpdateEmailPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateEmailPayloadToClientMutationIdResolver<TParent = GQLUpdateEmailPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateNotificationSettingsPayloadTypeResolver<TParent = GQLUpdateNotificationSettingsPayload> {
  user?: UpdateNotificationSettingsPayloadToUserResolver<TParent>;
  clientMutationId?: UpdateNotificationSettingsPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateNotificationSettingsPayloadToUserResolver<TParent = GQLUpdateNotificationSettingsPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateNotificationSettingsPayloadToClientMutationIdResolver<TParent = GQLUpdateNotificationSettingsPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateUserMediaSettingsPayloadTypeResolver<TParent = GQLUpdateUserMediaSettingsPayload> {
  user?: UpdateUserMediaSettingsPayloadToUserResolver<TParent>;
  clientMutationId?: UpdateUserMediaSettingsPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateUserMediaSettingsPayloadToUserResolver<TParent = GQLUpdateUserMediaSettingsPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateUserMediaSettingsPayloadToClientMutationIdResolver<TParent = GQLUpdateUserMediaSettingsPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateUserEmailPayloadTypeResolver<TParent = GQLUpdateUserEmailPayload> {
  user?: UpdateUserEmailPayloadToUserResolver<TParent>;
  clientMutationId?: UpdateUserEmailPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateUserEmailPayloadToUserResolver<TParent = GQLUpdateUserEmailPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateUserEmailPayloadToClientMutationIdResolver<TParent = GQLUpdateUserEmailPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateUserAvatarPayloadTypeResolver<TParent = GQLUpdateUserAvatarPayload> {
  user?: UpdateUserAvatarPayloadToUserResolver<TParent>;
  clientMutationId?: UpdateUserAvatarPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateUserAvatarPayloadToUserResolver<TParent = GQLUpdateUserAvatarPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateUserAvatarPayloadToClientMutationIdResolver<TParent = GQLUpdateUserAvatarPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateUserRolePayloadTypeResolver<TParent = GQLUpdateUserRolePayload> {
  clientMutationId?: UpdateUserRolePayloadToClientMutationIdResolver<TParent>;
  user?: UpdateUserRolePayloadToUserResolver<TParent>;
}

export interface UpdateUserRolePayloadToClientMutationIdResolver<TParent = GQLUpdateUserRolePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateUserRolePayloadToUserResolver<TParent = GQLUpdateUserRolePayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPromoteUserPayloadTypeResolver<TParent = GQLPromoteUserPayload> {
  clientMutationId?: PromoteUserPayloadToClientMutationIdResolver<TParent>;
  user?: PromoteUserPayloadToUserResolver<TParent>;
}

export interface PromoteUserPayloadToClientMutationIdResolver<TParent = GQLPromoteUserPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoteUserPayloadToUserResolver<TParent = GQLPromoteUserPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDemoteUserPayloadTypeResolver<TParent = GQLDemoteUserPayload> {
  clientMutationId?: DemoteUserPayloadToClientMutationIdResolver<TParent>;
  user?: DemoteUserPayloadToUserResolver<TParent>;
}

export interface DemoteUserPayloadToClientMutationIdResolver<TParent = GQLDemoteUserPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DemoteUserPayloadToUserResolver<TParent = GQLDemoteUserPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateUserModerationScopesPayloadTypeResolver<TParent = GQLUpdateUserModerationScopesPayload> {
  user?: UpdateUserModerationScopesPayloadToUserResolver<TParent>;
  clientMutationId?: UpdateUserModerationScopesPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateUserModerationScopesPayloadToUserResolver<TParent = GQLUpdateUserModerationScopesPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateUserModerationScopesPayloadToClientMutationIdResolver<TParent = GQLUpdateUserModerationScopesPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBanUserPayloadTypeResolver<TParent = GQLBanUserPayload> {
  user?: BanUserPayloadToUserResolver<TParent>;
  clientMutationId?: BanUserPayloadToClientMutationIdResolver<TParent>;
}

export interface BanUserPayloadToUserResolver<TParent = GQLBanUserPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BanUserPayloadToClientMutationIdResolver<TParent = GQLBanUserPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemoveUserBanPayloadTypeResolver<TParent = GQLRemoveUserBanPayload> {
  user?: RemoveUserBanPayloadToUserResolver<TParent>;
  clientMutationId?: RemoveUserBanPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveUserBanPayloadToUserResolver<TParent = GQLRemoveUserBanPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveUserBanPayloadToClientMutationIdResolver<TParent = GQLRemoveUserBanPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSuspendUserPayloadTypeResolver<TParent = GQLSuspendUserPayload> {
  user?: SuspendUserPayloadToUserResolver<TParent>;
  clientMutationId?: SuspendUserPayloadToClientMutationIdResolver<TParent>;
}

export interface SuspendUserPayloadToUserResolver<TParent = GQLSuspendUserPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SuspendUserPayloadToClientMutationIdResolver<TParent = GQLSuspendUserPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWarnUserPayloadTypeResolver<TParent = GQLWarnUserPayload> {
  clientMutationId?: WarnUserPayloadToClientMutationIdResolver<TParent>;
  user?: WarnUserPayloadToUserResolver<TParent>;
}

export interface WarnUserPayloadToClientMutationIdResolver<TParent = GQLWarnUserPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WarnUserPayloadToUserResolver<TParent = GQLWarnUserPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemoveUserWarningPayloadTypeResolver<TParent = GQLRemoveUserWarningPayload> {
  clientMutationId?: RemoveUserWarningPayloadToClientMutationIdResolver<TParent>;
  user?: RemoveUserWarningPayloadToUserResolver<TParent>;
}

export interface RemoveUserWarningPayloadToClientMutationIdResolver<TParent = GQLRemoveUserWarningPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveUserWarningPayloadToUserResolver<TParent = GQLRemoveUserWarningPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAcknowledgeWarningPayloadTypeResolver<TParent = GQLAcknowledgeWarningPayload> {
  clientMutationId?: AcknowledgeWarningPayloadToClientMutationIdResolver<TParent>;
  user?: AcknowledgeWarningPayloadToUserResolver<TParent>;
}

export interface AcknowledgeWarningPayloadToClientMutationIdResolver<TParent = GQLAcknowledgeWarningPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AcknowledgeWarningPayloadToUserResolver<TParent = GQLAcknowledgeWarningPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemoveUserSuspensionPayloadTypeResolver<TParent = GQLRemoveUserSuspensionPayload> {
  user?: RemoveUserSuspensionPayloadToUserResolver<TParent>;
  clientMutationId?: RemoveUserSuspensionPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveUserSuspensionPayloadToUserResolver<TParent = GQLRemoveUserSuspensionPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveUserSuspensionPayloadToClientMutationIdResolver<TParent = GQLRemoveUserSuspensionPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLIgnoreUserPayloadTypeResolver<TParent = GQLIgnoreUserPayload> {
  user?: IgnoreUserPayloadToUserResolver<TParent>;
  clientMutationId?: IgnoreUserPayloadToClientMutationIdResolver<TParent>;
}

export interface IgnoreUserPayloadToUserResolver<TParent = GQLIgnoreUserPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IgnoreUserPayloadToClientMutationIdResolver<TParent = GQLIgnoreUserPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemoveUserIgnorePayloadTypeResolver<TParent = GQLRemoveUserIgnorePayload> {
  user?: RemoveUserIgnorePayloadToUserResolver<TParent>;
  clientMutationId?: RemoveUserIgnorePayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveUserIgnorePayloadToUserResolver<TParent = GQLRemoveUserIgnorePayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveUserIgnorePayloadToClientMutationIdResolver<TParent = GQLRemoveUserIgnorePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRequestCommentsDownloadPayloadTypeResolver<TParent = GQLRequestCommentsDownloadPayload> {
  clientMutationId?: RequestCommentsDownloadPayloadToClientMutationIdResolver<TParent>;
}

export interface RequestCommentsDownloadPayloadToClientMutationIdResolver<TParent = GQLRequestCommentsDownloadPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRequestUserCommentsDownloadPayloadTypeResolver<TParent = GQLRequestUserCommentsDownloadPayload> {
  clientMutationId?: RequestUserCommentsDownloadPayloadToClientMutationIdResolver<TParent>;
  archiveURL?: RequestUserCommentsDownloadPayloadToArchiveURLResolver<TParent>;
}

export interface RequestUserCommentsDownloadPayloadToClientMutationIdResolver<TParent = GQLRequestUserCommentsDownloadPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequestUserCommentsDownloadPayloadToArchiveURLResolver<TParent = GQLRequestUserCommentsDownloadPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPremodUserPayloadTypeResolver<TParent = GQLPremodUserPayload> {
  user?: PremodUserPayloadToUserResolver<TParent>;
  clientMutationId?: PremodUserPayloadToClientMutationIdResolver<TParent>;
}

export interface PremodUserPayloadToUserResolver<TParent = GQLPremodUserPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PremodUserPayloadToClientMutationIdResolver<TParent = GQLPremodUserPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemovePremodUserPayloadTypeResolver<TParent = GQLRemovePremodUserPayload> {
  user?: RemovePremodUserPayloadToUserResolver<TParent>;
  clientMutationId?: RemovePremodUserPayloadToClientMutationIdResolver<TParent>;
}

export interface RemovePremodUserPayloadToUserResolver<TParent = GQLRemovePremodUserPayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemovePremodUserPayloadToClientMutationIdResolver<TParent = GQLRemovePremodUserPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateModeratorNotePayloadTypeResolver<TParent = GQLCreateModeratorNotePayload> {
  clientMutationId?: CreateModeratorNotePayloadToClientMutationIdResolver<TParent>;
  user?: CreateModeratorNotePayloadToUserResolver<TParent>;
}

export interface CreateModeratorNotePayloadToClientMutationIdResolver<TParent = GQLCreateModeratorNotePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateModeratorNotePayloadToUserResolver<TParent = GQLCreateModeratorNotePayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteModeratorNotePayloadTypeResolver<TParent = GQLDeleteModeratorNotePayload> {
  clientMutationId?: DeleteModeratorNotePayloadToClientMutationIdResolver<TParent>;
  user?: DeleteModeratorNotePayloadToUserResolver<TParent>;
}

export interface DeleteModeratorNotePayloadToClientMutationIdResolver<TParent = GQLDeleteModeratorNotePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteModeratorNotePayloadToUserResolver<TParent = GQLDeleteModeratorNotePayload, TResult = GQLUser> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEnableFeatureFlagPayloadTypeResolver<TParent = GQLEnableFeatureFlagPayload> {
  clientMutationId?: EnableFeatureFlagPayloadToClientMutationIdResolver<TParent>;
  flags?: EnableFeatureFlagPayloadToFlagsResolver<TParent>;
}

export interface EnableFeatureFlagPayloadToClientMutationIdResolver<TParent = GQLEnableFeatureFlagPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnableFeatureFlagPayloadToFlagsResolver<TParent = GQLEnableFeatureFlagPayload, TResult = Array<GQLFEATURE_FLAG>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDisableFeatureFlagPayloadTypeResolver<TParent = GQLDisableFeatureFlagPayload> {
  clientMutationId?: DisableFeatureFlagPayloadToClientMutationIdResolver<TParent>;
  flags?: DisableFeatureFlagPayloadToFlagsResolver<TParent>;
}

export interface DisableFeatureFlagPayloadToClientMutationIdResolver<TParent = GQLDisableFeatureFlagPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DisableFeatureFlagPayloadToFlagsResolver<TParent = GQLDisableFeatureFlagPayload, TResult = Array<GQLFEATURE_FLAG>> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateAnnouncementPayloadTypeResolver<TParent = GQLCreateAnnouncementPayload> {
  clientMutationId?: CreateAnnouncementPayloadToClientMutationIdResolver<TParent>;
  settings?: CreateAnnouncementPayloadToSettingsResolver<TParent>;
}

export interface CreateAnnouncementPayloadToClientMutationIdResolver<TParent = GQLCreateAnnouncementPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateAnnouncementPayloadToSettingsResolver<TParent = GQLCreateAnnouncementPayload, TResult = GQLSettings> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteAnnouncementPayloadTypeResolver<TParent = GQLDeleteAnnouncementPayload> {
  clientMutationId?: DeleteAnnouncementPayloadToClientMutationIdResolver<TParent>;
  settings?: DeleteAnnouncementPayloadToSettingsResolver<TParent>;
}

export interface DeleteAnnouncementPayloadToClientMutationIdResolver<TParent = GQLDeleteAnnouncementPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteAnnouncementPayloadToSettingsResolver<TParent = GQLDeleteAnnouncementPayload, TResult = GQLSettings> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateSitePayloadTypeResolver<TParent = GQLCreateSitePayload> {
  clientMutationId?: CreateSitePayloadToClientMutationIdResolver<TParent>;
  site?: CreateSitePayloadToSiteResolver<TParent>;
}

export interface CreateSitePayloadToClientMutationIdResolver<TParent = GQLCreateSitePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateSitePayloadToSiteResolver<TParent = GQLCreateSitePayload, TResult = GQLSite> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateSitePayloadTypeResolver<TParent = GQLUpdateSitePayload> {
  clientMutationId?: UpdateSitePayloadToClientMutationIdResolver<TParent>;
  site?: UpdateSitePayloadToSiteResolver<TParent>;
}

export interface UpdateSitePayloadToClientMutationIdResolver<TParent = GQLUpdateSitePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSitePayloadToSiteResolver<TParent = GQLUpdateSitePayload, TResult = GQLSite> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateWebhookEndpointPayloadTypeResolver<TParent = GQLCreateWebhookEndpointPayload> {
  clientMutationId?: CreateWebhookEndpointPayloadToClientMutationIdResolver<TParent>;
  endpoint?: CreateWebhookEndpointPayloadToEndpointResolver<TParent>;
  settings?: CreateWebhookEndpointPayloadToSettingsResolver<TParent>;
}

export interface CreateWebhookEndpointPayloadToClientMutationIdResolver<TParent = GQLCreateWebhookEndpointPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateWebhookEndpointPayloadToEndpointResolver<TParent = GQLCreateWebhookEndpointPayload, TResult = GQLWebhookEndpoint> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateWebhookEndpointPayloadToSettingsResolver<TParent = GQLCreateWebhookEndpointPayload, TResult = GQLSettings> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateWebhookEndpointPayloadTypeResolver<TParent = GQLUpdateWebhookEndpointPayload> {
  clientMutationId?: UpdateWebhookEndpointPayloadToClientMutationIdResolver<TParent>;
  endpoint?: UpdateWebhookEndpointPayloadToEndpointResolver<TParent>;
}

export interface UpdateWebhookEndpointPayloadToClientMutationIdResolver<TParent = GQLUpdateWebhookEndpointPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateWebhookEndpointPayloadToEndpointResolver<TParent = GQLUpdateWebhookEndpointPayload, TResult = GQLWebhookEndpoint> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEnableWebhookEndpointPayloadTypeResolver<TParent = GQLEnableWebhookEndpointPayload> {
  clientMutationId?: EnableWebhookEndpointPayloadToClientMutationIdResolver<TParent>;
  endpoint?: EnableWebhookEndpointPayloadToEndpointResolver<TParent>;
}

export interface EnableWebhookEndpointPayloadToClientMutationIdResolver<TParent = GQLEnableWebhookEndpointPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnableWebhookEndpointPayloadToEndpointResolver<TParent = GQLEnableWebhookEndpointPayload, TResult = GQLWebhookEndpoint> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDisableWebhookEndpointPayloadTypeResolver<TParent = GQLDisableWebhookEndpointPayload> {
  clientMutationId?: DisableWebhookEndpointPayloadToClientMutationIdResolver<TParent>;
  endpoint?: DisableWebhookEndpointPayloadToEndpointResolver<TParent>;
}

export interface DisableWebhookEndpointPayloadToClientMutationIdResolver<TParent = GQLDisableWebhookEndpointPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DisableWebhookEndpointPayloadToEndpointResolver<TParent = GQLDisableWebhookEndpointPayload, TResult = GQLWebhookEndpoint> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteWebhookEndpointPayloadTypeResolver<TParent = GQLDeleteWebhookEndpointPayload> {
  clientMutationId?: DeleteWebhookEndpointPayloadToClientMutationIdResolver<TParent>;
  endpoint?: DeleteWebhookEndpointPayloadToEndpointResolver<TParent>;
}

export interface DeleteWebhookEndpointPayloadToClientMutationIdResolver<TParent = GQLDeleteWebhookEndpointPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteWebhookEndpointPayloadToEndpointResolver<TParent = GQLDeleteWebhookEndpointPayload, TResult = GQLWebhookEndpoint> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRotateWebhookEndpointSigningSecretPayloadTypeResolver<TParent = GQLRotateWebhookEndpointSigningSecretPayload> {
  clientMutationId?: RotateWebhookEndpointSigningSecretPayloadToClientMutationIdResolver<TParent>;
  endpoint?: RotateWebhookEndpointSigningSecretPayloadToEndpointResolver<TParent>;
}

export interface RotateWebhookEndpointSigningSecretPayloadToClientMutationIdResolver<TParent = GQLRotateWebhookEndpointSigningSecretPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RotateWebhookEndpointSigningSecretPayloadToEndpointResolver<TParent = GQLRotateWebhookEndpointSigningSecretPayload, TResult = GQLWebhookEndpoint> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateExternalModerationPhasePayloadTypeResolver<TParent = GQLCreateExternalModerationPhasePayload> {
  clientMutationId?: CreateExternalModerationPhasePayloadToClientMutationIdResolver<TParent>;
  phase?: CreateExternalModerationPhasePayloadToPhaseResolver<TParent>;
  settings?: CreateExternalModerationPhasePayloadToSettingsResolver<TParent>;
}

export interface CreateExternalModerationPhasePayloadToClientMutationIdResolver<TParent = GQLCreateExternalModerationPhasePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateExternalModerationPhasePayloadToPhaseResolver<TParent = GQLCreateExternalModerationPhasePayload, TResult = GQLExternalModerationPhase> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateExternalModerationPhasePayloadToSettingsResolver<TParent = GQLCreateExternalModerationPhasePayload, TResult = GQLSettings> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateExternalModerationPhasePayloadTypeResolver<TParent = GQLUpdateExternalModerationPhasePayload> {
  clientMutationId?: UpdateExternalModerationPhasePayloadToClientMutationIdResolver<TParent>;
  phase?: UpdateExternalModerationPhasePayloadToPhaseResolver<TParent>;
}

export interface UpdateExternalModerationPhasePayloadToClientMutationIdResolver<TParent = GQLUpdateExternalModerationPhasePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateExternalModerationPhasePayloadToPhaseResolver<TParent = GQLUpdateExternalModerationPhasePayload, TResult = GQLExternalModerationPhase> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEnableExternalModerationPhasePayloadTypeResolver<TParent = GQLEnableExternalModerationPhasePayload> {
  clientMutationId?: EnableExternalModerationPhasePayloadToClientMutationIdResolver<TParent>;
  phase?: EnableExternalModerationPhasePayloadToPhaseResolver<TParent>;
}

export interface EnableExternalModerationPhasePayloadToClientMutationIdResolver<TParent = GQLEnableExternalModerationPhasePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnableExternalModerationPhasePayloadToPhaseResolver<TParent = GQLEnableExternalModerationPhasePayload, TResult = GQLExternalModerationPhase> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDisableExternalModerationPhasePayloadTypeResolver<TParent = GQLDisableExternalModerationPhasePayload> {
  clientMutationId?: DisableExternalModerationPhasePayloadToClientMutationIdResolver<TParent>;
  phase?: DisableExternalModerationPhasePayloadToPhaseResolver<TParent>;
}

export interface DisableExternalModerationPhasePayloadToClientMutationIdResolver<TParent = GQLDisableExternalModerationPhasePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DisableExternalModerationPhasePayloadToPhaseResolver<TParent = GQLDisableExternalModerationPhasePayload, TResult = GQLExternalModerationPhase> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteExternalModerationPhasePayloadTypeResolver<TParent = GQLDeleteExternalModerationPhasePayload> {
  clientMutationId?: DeleteExternalModerationPhasePayloadToClientMutationIdResolver<TParent>;
  phase?: DeleteExternalModerationPhasePayloadToPhaseResolver<TParent>;
}

export interface DeleteExternalModerationPhasePayloadToClientMutationIdResolver<TParent = GQLDeleteExternalModerationPhasePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteExternalModerationPhasePayloadToPhaseResolver<TParent = GQLDeleteExternalModerationPhasePayload, TResult = GQLExternalModerationPhase> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRotateExternalModerationPhaseSigningSecretPayloadTypeResolver<TParent = GQLRotateExternalModerationPhaseSigningSecretPayload> {
  clientMutationId?: RotateExternalModerationPhaseSigningSecretPayloadToClientMutationIdResolver<TParent>;
  phase?: RotateExternalModerationPhaseSigningSecretPayloadToPhaseResolver<TParent>;
}

export interface RotateExternalModerationPhaseSigningSecretPayloadToClientMutationIdResolver<TParent = GQLRotateExternalModerationPhaseSigningSecretPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RotateExternalModerationPhaseSigningSecretPayloadToPhaseResolver<TParent = GQLRotateExternalModerationPhaseSigningSecretPayload, TResult = GQLExternalModerationPhase> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateStoryModePayloadTypeResolver<TParent = GQLUpdateStoryModePayload> {
  clientMutationId?: UpdateStoryModePayloadToClientMutationIdResolver<TParent>;
  story?: UpdateStoryModePayloadToStoryResolver<TParent>;
}

export interface UpdateStoryModePayloadToClientMutationIdResolver<TParent = GQLUpdateStoryModePayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateStoryModePayloadToStoryResolver<TParent = GQLUpdateStoryModePayload, TResult = GQLStory> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAddStoryExpertPayloadTypeResolver<TParent = GQLAddStoryExpertPayload> {
  clientMutationId?: AddStoryExpertPayloadToClientMutationIdResolver<TParent>;
  story?: AddStoryExpertPayloadToStoryResolver<TParent>;
}

export interface AddStoryExpertPayloadToClientMutationIdResolver<TParent = GQLAddStoryExpertPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AddStoryExpertPayloadToStoryResolver<TParent = GQLAddStoryExpertPayload, TResult = GQLStory> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemoveStoryExpertPayloadTypeResolver<TParent = GQLRemoveStoryExpertPayload> {
  clientMutationId?: RemoveStoryExpertPayloadToClientMutationIdResolver<TParent>;
  story?: RemoveStoryExpertPayloadToStoryResolver<TParent>;
}

export interface RemoveStoryExpertPayloadToClientMutationIdResolver<TParent = GQLRemoveStoryExpertPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveStoryExpertPayloadToStoryResolver<TParent = GQLRemoveStoryExpertPayload, TResult = GQLStory> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTestSMTPPayloadTypeResolver<TParent = GQLTestSMTPPayload> {
  clientMutationId?: TestSMTPPayloadToClientMutationIdResolver<TParent>;
}

export interface TestSMTPPayloadToClientMutationIdResolver<TParent = GQLTestSMTPPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReviewCommentFlagPayloadTypeResolver<TParent = GQLReviewCommentFlagPayload> {
  clientMutationId?: ReviewCommentFlagPayloadToClientMutationIdResolver<TParent>;
  flag?: ReviewCommentFlagPayloadToFlagResolver<TParent>;
}

export interface ReviewCommentFlagPayloadToClientMutationIdResolver<TParent = GQLReviewCommentFlagPayload, TResult = string> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewCommentFlagPayloadToFlagResolver<TParent = GQLReviewCommentFlagPayload, TResult = GQLFlag> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSubscriptionTypeResolver<TParent = undefined> {
  commentEnteredModerationQueue?: SubscriptionToCommentEnteredModerationQueueResolver<TParent>;
  commentLeftModerationQueue?: SubscriptionToCommentLeftModerationQueueResolver<TParent>;
  commentStatusUpdated?: SubscriptionToCommentStatusUpdatedResolver<TParent>;
  commentEntered?: SubscriptionToCommentEnteredResolver<TParent>;
  commentCreated?: SubscriptionToCommentCreatedResolver<TParent>;
  commentReleased?: SubscriptionToCommentReleasedResolver<TParent>;
  commentReplyCreated?: SubscriptionToCommentReplyCreatedResolver<TParent>;
  commentFeatured?: SubscriptionToCommentFeaturedResolver<TParent>;
}

export interface SubscriptionToCommentEnteredModerationQueueArgs {
  storyID?: string;
  siteID?: string;
  section?: GQLSectionFilter;
  orderBy?: GQLCOMMENT_SORT;
  queue?: GQLMODERATION_QUEUE;
}
export interface SubscriptionToCommentEnteredModerationQueueResolver<TParent = undefined, TResult = GQLCommentEnteredModerationQueuePayload> {
  resolve?: (parent: TParent, args: SubscriptionToCommentEnteredModerationQueueArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToCommentEnteredModerationQueueArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToCommentLeftModerationQueueArgs {
  storyID?: string;
  siteID?: string;
  section?: GQLSectionFilter;
  orderBy?: GQLCOMMENT_SORT;
  queue?: GQLMODERATION_QUEUE;
}
export interface SubscriptionToCommentLeftModerationQueueResolver<TParent = undefined, TResult = GQLCommentLeftModerationQueuePayload> {
  resolve?: (parent: TParent, args: SubscriptionToCommentLeftModerationQueueArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToCommentLeftModerationQueueArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToCommentStatusUpdatedArgs {
  id?: string;
}
export interface SubscriptionToCommentStatusUpdatedResolver<TParent = undefined, TResult = GQLCommentStatusUpdatedPayload> {
  resolve?: (parent: TParent, args: SubscriptionToCommentStatusUpdatedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToCommentStatusUpdatedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToCommentEnteredArgs {
  storyID: string;
  ancestorID?: string;
}
export interface SubscriptionToCommentEnteredResolver<TParent = undefined, TResult = GQLCommentEnteredPayload> {
  resolve?: (parent: TParent, args: SubscriptionToCommentEnteredArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToCommentEnteredArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToCommentCreatedArgs {
  storyID: string;
}
export interface SubscriptionToCommentCreatedResolver<TParent = undefined, TResult = GQLCommentCreatedPayload> {
  resolve?: (parent: TParent, args: SubscriptionToCommentCreatedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToCommentCreatedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToCommentReleasedArgs {
  storyID: string;
}
export interface SubscriptionToCommentReleasedResolver<TParent = undefined, TResult = GQLCommentReleasedPayload> {
  resolve?: (parent: TParent, args: SubscriptionToCommentReleasedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToCommentReleasedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToCommentReplyCreatedArgs {
  ancestorID: string;
}
export interface SubscriptionToCommentReplyCreatedResolver<TParent = undefined, TResult = GQLCommentReplyCreatedPayload> {
  resolve?: (parent: TParent, args: SubscriptionToCommentReplyCreatedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToCommentReplyCreatedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToCommentFeaturedArgs {
  storyID: string;
}
export interface SubscriptionToCommentFeaturedResolver<TParent = undefined, TResult = GQLCommentFeaturedPayload> {
  resolve?: (parent: TParent, args: SubscriptionToCommentFeaturedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToCommentFeaturedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface GQLCommentEnteredModerationQueuePayloadTypeResolver<TParent = GQLCommentEnteredModerationQueuePayload> {
  queue?: CommentEnteredModerationQueuePayloadToQueueResolver<TParent>;
  comment?: CommentEnteredModerationQueuePayloadToCommentResolver<TParent>;
}

export interface CommentEnteredModerationQueuePayloadToQueueResolver<TParent = GQLCommentEnteredModerationQueuePayload, TResult = GQLMODERATION_QUEUE> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentEnteredModerationQueuePayloadToCommentResolver<TParent = GQLCommentEnteredModerationQueuePayload, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentLeftModerationQueuePayloadTypeResolver<TParent = GQLCommentLeftModerationQueuePayload> {
  queue?: CommentLeftModerationQueuePayloadToQueueResolver<TParent>;
  comment?: CommentLeftModerationQueuePayloadToCommentResolver<TParent>;
}

export interface CommentLeftModerationQueuePayloadToQueueResolver<TParent = GQLCommentLeftModerationQueuePayload, TResult = GQLMODERATION_QUEUE> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentLeftModerationQueuePayloadToCommentResolver<TParent = GQLCommentLeftModerationQueuePayload, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentStatusUpdatedPayloadTypeResolver<TParent = GQLCommentStatusUpdatedPayload> {
  newStatus?: CommentStatusUpdatedPayloadToNewStatusResolver<TParent>;
  oldStatus?: CommentStatusUpdatedPayloadToOldStatusResolver<TParent>;
  moderator?: CommentStatusUpdatedPayloadToModeratorResolver<TParent>;
  comment?: CommentStatusUpdatedPayloadToCommentResolver<TParent>;
}

export interface CommentStatusUpdatedPayloadToNewStatusResolver<TParent = GQLCommentStatusUpdatedPayload, TResult = GQLCOMMENT_STATUS> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentStatusUpdatedPayloadToOldStatusResolver<TParent = GQLCommentStatusUpdatedPayload, TResult = GQLCOMMENT_STATUS> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentStatusUpdatedPayloadToModeratorResolver<TParent = GQLCommentStatusUpdatedPayload, TResult = GQLUser | null> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentStatusUpdatedPayloadToCommentResolver<TParent = GQLCommentStatusUpdatedPayload, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentEnteredPayloadTypeResolver<TParent = GQLCommentEnteredPayload> {
  comment?: CommentEnteredPayloadToCommentResolver<TParent>;
}

export interface CommentEnteredPayloadToCommentResolver<TParent = GQLCommentEnteredPayload, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentCreatedPayloadTypeResolver<TParent = GQLCommentCreatedPayload> {
  comment?: CommentCreatedPayloadToCommentResolver<TParent>;
}

export interface CommentCreatedPayloadToCommentResolver<TParent = GQLCommentCreatedPayload, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentReleasedPayloadTypeResolver<TParent = GQLCommentReleasedPayload> {
  comment?: CommentReleasedPayloadToCommentResolver<TParent>;
}

export interface CommentReleasedPayloadToCommentResolver<TParent = GQLCommentReleasedPayload, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentReplyCreatedPayloadTypeResolver<TParent = GQLCommentReplyCreatedPayload> {
  comment?: CommentReplyCreatedPayloadToCommentResolver<TParent>;
}

export interface CommentReplyCreatedPayloadToCommentResolver<TParent = GQLCommentReplyCreatedPayload, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentFeaturedPayloadTypeResolver<TParent = GQLCommentFeaturedPayload> {
  comment?: CommentFeaturedPayloadToCommentResolver<TParent>;
}

export interface CommentFeaturedPayloadToCommentResolver<TParent = GQLCommentFeaturedPayload, TResult = GQLComment> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}
